import { deleteSelectedRowsWithChildSupport, insertColumnsLeft, insertColumnsRight, makeColumnArrayForDB, removeDeletedColumnFilters } from "./callbackHelper";
import { v4 as uuidv4 } from 'uuid';
import { myComparator, syncLidWithId } from "./dataHarvestHelper";
import CustomCellRenderer from "../components/Grid/CustomCellRenderer";
import { CustomCellEditor } from "../components/Grid/CustomCellEditor";
import { CustomTextNumberFilter } from "../cellComponents/Filters/CustomTextNumberFilter";
import { addThisNodeAsSuccessorToOtherRows, addTimes, checkNodesForCircularDependency, deepCopy, filterRows, findAllTimeSeriesColumnFieldsTillSpecifiedEndDate,findColumnUsingParamsOrGridRef, findEndDateColumnField, findStartDateColumnField, getAllChildrenOfaNode, getAllParentsOfANode, getIndexesFromNodeArray, getNodeListFromIdList, handleUndoRowUpdates, increaseDateByOne,  makeColumnGroup, makeParentCellNotEditable, mapUpdatedRows, maxDate, parentRowsAferRollup, processSuccessorNodes, recursivelyCalculateParent, removeColumnFromGroup, removeDurationFromValue, removeGroupInfoFromColumn, removeThisNodeAsSuccessorFromOtherRows, traverseChildrenRecursivelyForColumnsWhereGroupingIsMultiLevel, updateOrCreateObject, validateAndFormatDate } from "./helpersSubModule";
import { renderAlert } from "../../../CommonComponents/Alert/Alert";
import dayjs from "dayjs";
import { MDVParentColumnRawStructure, timeSeriesChildColumnListData } from "../cellComponents/FushionColumn/constants/MdvConstant";
import { isStringifiedArrayWithPropName } from "../../../helpers/ExportHelper";
import { processDate } from "./dateHelper";
import { changeUpdatedDateOfRow, checkIfRollupEnabledInMDV, getRolledUpValueForMDV, getRolledUpValueForTimeSeriesCell, isTimeSeriesPresent, removeExistingPredecessorsAndApplyNewOnes, returnDateRollUpFields, returnNumberRollupFields, returnRollUpFields, updateCellValue, updateTotalIfValueIsChanged } from "./xTablesHelper";
import xTablesStore from "../redux/xTablesStore";
import { categorizeAndStoreUpdatedRows } from "../redux/action/gridAction";
import { getAccessInfoByEntityId, getAccessInfoByEntityIdFprManageAccess, setAccessByEntityId } from "../../../redux/action/userActivityAction";
import { getLoggedInUser, getUser } from "../../../redux/action/userAction";
import { formatSharedWbObject } from "../../../helpers/helper";
import store from "../../../redux/store";
import { containsRowId, getMatchedValueObject, getTotalColumn, parseNewValue, populateBacklogStatusColumnIfNeeded } from "./cellValueChangeHelpers";
import { trace, context } from "@opentelemetry/api";
import { logSpan } from "../../../helpers/loggingHelper";
import XTABLES_ACTION_TYPES from "../redux/xTablesReduxActionTypes";
import { formatArrayforLogs, formatParentDataIntoOTelFormat, formatUndoRowFordragFunc, formatdropIndexInOutdent, formatCellValueCallBackArray, formatPasteRowObjectMap } from "../../../helpers/loggerFormatHelper";
import { scheduleGridToCardSync } from "../redux/thunks/cardViewThunks";
import { parseDataString } from "./MdvHelper";
const tracer = trace.getTracer("helper-functions")

export const enableCardViewIfApplicable = (colDef, newValue, oldValue, dispatch) => {
    const isAutoColumn = colDef?.colId === "ag-Grid-AutoColumn";
    const valueChanged = newValue !== oldValue && newValue !== undefined && newValue !== null;

    if (isAutoColumn && valueChanged) {
        dispatch({ type: XTABLES_ACTION_TYPES.ENABLE_CARD_VIEW, cardView: false });
    }
};

export const isInsertToBeDisabled = (params, selectedCell, gridRef) => {

    if (!params.node) return true
    // if(params.node.data.l_id.includes('.')) return true
    if (gridRef.current && gridRef.current.api.getFocusedCell()) return false
    else return true
}
export function dateDifference(date1, date2, duration = null) {
    const startDate = new Date(date1);
    const endDate = new Date(date2);
    const startDay = startDate.getDay();
    const endDay = endDate.getDay();

    const isWeekend = (day) => day === 0 || day === 6; // 0 is Sunday, 6 is Saturday

    let daysDifference;

    // if (isWeekend(startDay) || isWeekend(endDay)) {
    //     daysDifference = Math.ceil(Math.abs(endDate - startDate) / (1000 * 60 * 60 * 24));
    // } else {
        daysDifference = countWeekdays(startDate, endDate);
    // }
    // daysDifference+=1
    const weeksDifference = Math.floor(daysDifference / 5); // Since we only count weekdays, weeks are made of 5 days
    // const startYear = startDate.getFullYear();
    // const startMonth = startDate.getMonth();
    // const endYear = endDate.getFullYear();
    // const endMonth = endDate.getMonth();
    // const monthsDifference = (endYear - startYear) * 12 + (endMonth - startMonth);
    // const yearsDifference = endYear - startYear;

    if (duration) {
        const validDurationRegex = /^(\d+)([dDhHwW])?$/;
        let durationValue = daysDifference; let durationType;
        if (isNaN(duration)) {
            durationType = 'd';
        }
        else {
            if (validDurationRegex.test(duration) || !isNaN(duration))
                durationValue = parseInt(duration.match(/\d+/)[0])
            let allCharacters = duration?.match(/[dDwWhH]+/);
            durationType = allCharacters ? allCharacters[0] : 'd';
        }
        switch (durationType) {
            case 'd':
                return `${daysDifference}d`;
            case 'D':
                return `${daysDifference}D`;
            case 'w':
                if(weeksDifference==0) return `${daysDifference}d`;
                return `${weeksDifference}w`;
            case 'W':
                if(weeksDifference==0) return `${daysDifference}d`;
                return `${weeksDifference}W`;
            case 'h':
            case 'H':
                let hoursDifference = daysDifference * 8; // Assuming 8 hours per workday

                if (duration) {
                    const oldHoursValue =duration.match(/\d+/)? parseInt(duration.match(/\d+/)[0]):0;
                    const oldHoursMultiple = Math.floor(oldHoursValue / 8) * 8;
                    const newHoursMultiple = Math.floor(hoursDifference / 8) * 8;

                    if (oldHoursValue < newHoursMultiple && oldHoursValue >= oldHoursMultiple) {
                        hoursDifference = oldHoursValue;
                    }
                }

                return durationType === 'h' ? `${hoursDifference}h` : `${hoursDifference}H`;
            // case 'm':
            //     return `${monthsDifference}m`;
            // case 'y':
            //     return `${yearsDifference}y`;
            default:
                if(allCharacters.length>1 || exceedsTwoYears(`${durationValue}d`)) {
                    return `${daysDifference}d`;
                }
                return `${durationValue}d`;
        }
    } else {
        // if (yearsDifference >= 1) {
        //     return `${yearsDifference}y`;
        // } else if (monthsDifference >= 1) {
        //     return `${monthsDifference}m`;
        // } else
         if (weeksDifference >= 1) {
            return `${weeksDifference}w`;
        } else {
            return `${daysDifference}d`;
        }
    }
}

export const countWeekdays=(start, end)=>{
    let count = 0;
    let currentDate = new Date(start);
    let enddate=new Date(end);
    while (currentDate <= enddate) {
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) { // 0 is Sunday, 6 is Saturday
            count++;
        }
        currentDate.setDate(currentDate.getDate() + 1);
    }

    return count;
}

export const applyStylestoCellRenderer = (formatString) => {
    let styles = {};

    if (!formatString) return styles;

    formatString = formatString.trim();

    if (formatString.includes("bold")) {
        styles.fontWeight = "bold";
    } else if (formatString.includes("UNBOLD")) {
        styles.fontWeight = "normal";
    }

    if (formatString.includes("italic")) {
        styles.fontStyle = "italic";
    } else if (formatString.includes("UNITALIC")) {
        styles.fontStyle = "normal";
    }

    let decoration = [];

    if (formatString.includes("underline")) {
        decoration.push("underline");
    } else if (formatString.includes("UNUNDERLINE")) {

    }

    if (formatString.includes("strikethrough")) {
        decoration.push("line-through");
    } else if (formatString.includes("UNSTRIKETHROUGH")) {
    }
    if (decoration.length > 0) {
        styles.textDecoration = decoration.join(" ");
    }

    return styles;
};

export const getMainMenuItems = (params, gridRef, undoStack, setColumnDefs, addColumnToIndex, updateColumnWithId, setUndoStack, columnWidthChanged, deleteColumn, setSelectedColumn, setColumnToDelete, canBeDeleted,openTimeSeriesPopupFunc, columnDefs,selectedColumns,openModalContainer,setAddNewColumn,allColumns,handleOpenViewPopup,currentFilter, handleExtendTimeSeries, handleDeleteBlock) => {
    let colId = params.column.getId();
    let colType = params.column.colDef.type
    let menuItems = []
    let defaultItemsOnlyInPrimary = ["expandAll", "contractAll"]
    let parent= recursivelyCalculateParent(params.column)?.providedColumnGroup?.colGroupDef;
    let isParentABlock=parent && params.column.colDef.parent && parent.block
    let defaultItemsInOthers = []
    const currentSheet = store.getState().sheetReducer.currentSelectedSheet;
    if (colId === "ag-Grid-AutoColumn") {
        params.defaultItems.forEach((item) => {
            if (defaultItemsOnlyInPrimary.includes(item)) {
                menuItems.push(item);
            }
        })
    }
    else if(colId!='#') {
        params.defaultItems.forEach((item) => {
            if (defaultItemsInOthers.includes(item)) {
                menuItems.push(item);
            }
        })
       if(currentSheet.sheetType !== "rolluplist" || currentSheet.sheetType !== "checkinagent"){menuItems.push({
            name: `Insert Column Left`,
            action: function () {
                insertColumnsLeft({ gridRef, undoStack, columnMenuParams: params, setColumnDefs, addColumnToIndex,openModalContainer,allColumns:allColumns });
            }
        });}
    }
    if(colId!='#') {
        if(currentSheet.sheetType !== "rolluplist" || currentSheet.sheetType !== "checkinagent") {menuItems.push({
            name: `Insert Column Right`,
            action: function () {
                insertColumnsRight({ gridRef, undoStack, columnMenuParams: params, setColumnDefs, addColumnToIndex ,openModalContainer ,allColumns:allColumns});
            }
        });}
        if(params.column.colDef.type !== "predecessor" ) menuItems.push({
            name: `Filter`,
            action: function () {
                if (currentFilter !== null && currentFilter.filters.length !== 0) {
                    handleOpenViewPopup(true, currentFilter.filters, currentFilter.filterName, currentFilter.id);
                }
                else {
                    const filters = [{
                        id: Date.now(),
                        column: {
                            colId: params.column.colId,
                            type: params.column.colDef.type,
                            ...(params.column.colDef.listData && {listData: params.column.colDef.listData}),
                            edit: false
                        },
                        condition: 'equals',
                        inputValue: '',
                        option: '',
                        options: []
                    }];
                    handleOpenViewPopup(true,filters);
                }

            }
        });
        const hasTimeSeriesInSheet = columnDefs.some(obj => {return obj.hasOwnProperty('block') && (obj.hasOwnProperty('parent') || obj.hasOwnProperty('children'))});
        if(!isParentABlock && currentSheet.sheetType !== "rolluplist" && currentSheet?.sheetType !== "checkinagent") menuItems.push({
            name:"Insert Column Blocks",
            subMenu:[
                {
                    name: `Time Series`,
                    action: function () {
                        if(hasTimeSeriesInSheet){
                            renderAlert('Insertion failed. Only one time series is allowed per sheet.', 'error', 2000)
                        }else{
                            openTimeSeriesPopupFunc(params.column);
                        }
                    }
                }
            ]
            
        });
    }
    if(parent && params.column.colDef.parent && !parent.block){
        menuItems.push({
            name: `Remove From Group`,
            action: function () {
                unGroupColumn({  undoStack, params, setColumnDefs, updateColumnWithId,deleteColumn,addToRoot:true });
            }
        });
    } 
   
    if(!isParentABlock) menuItems.push({
        name: `Edit Column Properties`,
       disabled: currentSheet?.sheetType === "checkinagent" || (!params.column.colDef.editable && colId!=='#'),
        action: function () {
            setSelectedColumn({ ...params.column })
            setAddNewColumn(false);
        }
    });

    if (isParentABlock) {
        const colDef = columnDefs.find((column) => column.colId === params.column.colDef.parent);
        menuItems.push({
            name: `Extend Time series`,
            disabled: currentSheet?.sheetType === "checkinagent" || !params.column.colDef.editable && colId !== '#',
            subMenu: [
                {
                    name: `Right`,
                    action: function () {
                        handleExtendTimeSeries('right', colDef)
                    }
                },
                {
                    name: `Left`,
                    action: function () {
                        handleExtendTimeSeries('left', colDef)
                    }
                }
            ]
        });
    }

    if (isParentABlock) {
        menuItems.push({
            name: `Delete Block`,
            disabled : (params.column.colDef.template && !currentSheet?.copyOfOriginal)||currentSheet?.sheetType === "checkinagent" || (!params.column.colDef.editable && colId !== '#'),
            action: function () {
                handleDeleteBlock(params)
            }
        });
    }
        
    if (colId !== "ag-Grid-AutoColumn" && colId!=='#') {
        if(!isParentABlock)  menuItems.push({
            name: "Delete Column(s)",
            disabled: currentSheet?.sheetType === "checkinagent" || !params.column.colDef.deleteable||params.column.colDef.azureColumn,
            action: () => {
                gridRef.current.api.expandAll();
                deleteColumnFromMenuHelper(gridRef,selectedColumns,setColumnToDelete)
            }
        })
    }

    return menuItems;
};
export const deleteColumnFromMenuHelper = (gridRef, selectedColumns,setColumnToDelete) => {
    const focusedColumn = gridRef.current.api.getAllGridColumns().find(col => col.menuVisible);
    let isMoreThanOneColumnSelected = selectedColumns.length > 1
    const deleteMenuColumnNameList = isMoreThanOneColumnSelected ?
        selectedColumns.map((col) => { let gridColumn = gridRef.current.api.getColumnDef(col); return gridColumn.headerName })
            .join(', ')
        : focusedColumn.colDef.headerName
    setColumnToDelete({ deleteAlertOpen: true, focusedColumn: focusedColumn, deleteMenuColumnNameList, columnsToDelete: isMoreThanOneColumnSelected ? selectedColumns : [focusedColumn.colId] })
}
export const getSelectedRowIndexes = (gridRef) => {
    let selectedNodes = gridRef.current.api.getSelectedNodes();
    let selectedRowIndexes = [];
    selectedNodes.forEach((selectedNode) => {
        selectedRowIndexes.push(selectedNode.rowIndex);
    });
    return selectedRowIndexes;
}

export const getSelectedRowIndexesFromRangeSelection=(start,end)=>{
    const result = [];
    for (let i = start; i <= end; i++) {
        result.push(i);
    }
    return result.sort((a,b)=>a-b);
}
export const getSmallestSelectedIndex = (selectedIndexes) => {
    let smallestSelectedRowIndex = Math.min(...selectedIndexes);
    return smallestSelectedRowIndex;
};
export const getLargestSelectedIndex = (selectedIndexes) => {
    let largestSelectedRowIndex = Math.max(...selectedIndexes);
    return largestSelectedRowIndex;
};
export const addRowToParentList = (l_id, parentList) => {
    let newParentList = new Set(parentList)
    let ids = l_id.split(".").slice(0, -1)
    ids.forEach((id) => newParentList.add(id))
    return Array.from(newParentList)
}

export const makeChildrenListObject = (l_id, childrenListObject) => {
    let idList = l_id.split(".")
    let idListLength = idList.length
    let currentId = idList[idListLength - 1]
    let parentId = idListLength > 1 ? idList[idListLength - 2] : false;
    if (parentId) {
        childrenListObject[parentId] = (childrenListObject[parentId] || []).concat(currentId);
    }
    return childrenListObject
}

export const addChildToChildrenListObject = (l_id, childrenListObject, order, direction) => {
    let newChildListObj = { ...childrenListObject }
    let idList = l_id.split(".")
    let idListLength = idList.length
    let currentId = idList[idListLength - 1]
    let parentId = idListLength > 1 ? idList[idListLength - 2] : false;
    let previousParentId = idListLength > 2 ? idList[idListLength - 3] : false;
    if (previousParentId) {
        const indexToRemove = newChildListObj[previousParentId]?.indexOf(currentId);
        if (indexToRemove !== -1 && newChildListObj[previousParentId]) {
            newChildListObj[previousParentId]?.splice(indexToRemove, 1);
        }
    }
    if (parentId) {
        if (order) {
            let pidx = order.indexOf(parentId);
            let cidx = order.indexOf(currentId)
            let indexInsideParent = direction === 'above' ? cidx - pidx - 1 : cidx - pidx
            newChildListObj[parentId]?.splice(indexInsideParent, 0, currentId);
        }
        else newChildListObj[parentId] = (newChildListObj[parentId] || []).concat(currentId);
        newChildListObj[parentId] = [...new Set(newChildListObj[parentId])]
    }
    return newChildListObj
}
export const removeChildFromChildrenListObject = (prevL_id, l_id, childrenListObject, nodeisDeleted) => {

    let newChildListObj = { ...childrenListObject }
    let newIdList = l_id.split(".")
    let idListLength = newIdList.length
    let currentId = newIdList[idListLength - 1]
    let parentId = idListLength > 1 ? newIdList[idListLength - 2] : false;
    let prevIdList = prevL_id.split(".")
    let previousParentId = prevIdList.length > 1 ? prevIdList[prevIdList.length - 2] : false;
    let changeIndexOfRow = false, totalChildLength = 0
    if (previousParentId || nodeisDeleted) {
        const indexToRemove = newChildListObj[previousParentId]?.indexOf(currentId);
        if (indexToRemove !== -1) {
            if (!newChildListObj[previousParentId]) newChildListObj[previousParentId] = []
            if (indexToRemove !== newChildListObj[previousParentId].length - 1) { changeIndexOfRow = indexToRemove; totalChildLength = newChildListObj[previousParentId].length }
            newChildListObj[previousParentId].splice(indexToRemove, 1);
            if (newChildListObj[previousParentId].length === 0) delete newChildListObj[previousParentId]
        }
    }
    if (parentId && !nodeisDeleted) {
        newChildListObj[parentId] = (newChildListObj[parentId] || []).concat(currentId);
        newChildListObj[parentId] = [...new Set(newChildListObj[parentId])]
    }
    return { newChildListObj, changeIndexOfRow, totalChildLength }
}
export const makeRowsObject = (rows) => {
    let rowsObj = {}
    rows.forEach((row) => { rowsObj[row.id] = row })
    return rowsObj
}
export const returnIndentedChildren = (rowData, parentId, appendedParent, parentIndex, childrenArray,loggedInUser) => {
    let currIndex = parentIndex + 1, childRows = [], undoRowsIndented = []
    let alreadyTraversed = {}
    alreadyTraversed[parentId] = true
    while (rowData[currIndex]?.data.l_id.includes(parentId)) {
        if (!alreadyTraversed[rowData[currIndex].data.id]) {
            console.log("Inside outdent/indent  child node ", rowData[currIndex].data.l_id, rowData[currIndex].data.primaryCol)
            alreadyTraversed[rowData[currIndex].data.id] = true
            let newRow = rowData[currIndex].data
            undoRowsIndented.push({ ...rowData[currIndex].data })
            let l_id = rowData[currIndex].data.l_id.split('.')
            let pidx = l_id.indexOf(parentId)
            newRow.l_id =removeDuplicateKeepLast(appendedParent + '.' + l_id.slice(pidx).join('.'))
            newRow.l_id = syncLidWithId(newRow)
            newRow = changeUpdatedDateOfRow(newRow,loggedInUser)
            childRows.push(newRow)
            currIndex++
        }
    }

    if (childrenArray && childrenArray.length) {
        for (let currIndex = 0; currIndex < childrenArray.length; currIndex++) {
            if (childrenArray[currIndex] && !alreadyTraversed[childrenArray[currIndex].data.id]) {
                console.log("Inside outdent/indent childarray child node ", childrenArray[currIndex].data.l_id, childrenArray[currIndex].data.primaryCol)
                alreadyTraversed[childrenArray[currIndex].data.id] = true
                let newRow = childrenArray[currIndex].data
                let l_id = newRow.l_id.split('.')
                if (l_id.includes(parentId)) {
                    undoRowsIndented.push({ ...childrenArray[currIndex].data })
                    let pidx = l_id.indexOf(parentId)
                    newRow.l_id = removeDuplicateKeepLast(appendedParent + '.' + l_id.slice(pidx).join('.'))
                    newRow.l_id = syncLidWithId(newRow)
                    childRows.push(newRow)
                }
            }
        }
    }
    return { childRows, undoRowsIndented }
}
export const indexIsInCellRange=(gridRef,selectedNode) => {
    let cellRanges = gridRef.current.api.getCellRanges()
    if (cellRanges && cellRanges.length > 0) {
        let start = Math.min(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex), end = Math.max(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex)
        if (selectedNode.rowIndex >= start && selectedNode.rowIndex <= end) return true
    }
    return false
}
export const checkIfRowIsAParent = (gridRef, childrenListObject) => {
    let currentSheetRows = gridRef.current.api.getModel().rowsToDisplay;
    let selectedNodes = gridRef.current.api.getSelectedNodes()
    let cellRanges = gridRef.current.api.getCellRanges()

    if (cellRanges && cellRanges.length > 0 && selectedNodes.length === 0) {
        for (let i = 0; i < cellRanges.length; i++) {
            const startRowIndex = cellRanges[i]?.startRow?.rowIndex;
            const endRowIndex = cellRanges[i]?.endRow?.rowIndex;
            for (var j = startRowIndex; j <= endRowIndex; j++) {
                selectedNodes.push(currentSheetRows[j])
            }
        }
    }
    if (selectedNodes.length === 0) {
        let cell = gridRef.current.api.getFocusedCell()
        selectedNodes = [currentSheetRows[cell?.rowIndex]]
    }
    let isParent = false;
    

    selectedNodes.forEach((row) => {
      const childrenArray = getUniqueChildrenArray(row)  
        if (childrenArray?.length > 1) {
            isParent = row?.rowIndex;
        }
    })
    return isParent || isParent===0;
}
export const deleteRowHandler = ({ gridRef, childrenListObject, setChildrenListObject, undoStack, rowObj, deleteRow, deleteSelectedRowWithChildRows, setRowData, setUndoStack, setSelectedCellHelper, setRedoStack, insertRow, operationInProcess, setOperationInProcess, successorNodesForRowUndo, setSuccessorNodesForRowUndo, dispatch }) => {
    tracer.startActiveSpan("deleteRowHandler", context.active(), (span) => {
        let functionFlow = ["deleteRowHandler started"];
        deleteSelectedRowsWithChildSupport({
            gridRef, undoStack, setRowData, deleteRow, rowObj, childrenListObject, setChildrenListObject,
            setUndoStack, setSelectedCellHelper, setRedoStack, insertRow, operationInProcess, setOperationInProcess, successorNodesForRowUndo, setSuccessorNodesForRowUndo, dispatch
        })
       
       scheduleGridToCardSync(gridRef, dispatch , true);
        functionFlow.push("deleteRowHandler end");
        span.setAttribute("deleteRowHandler-functionFlow", functionFlow);
    });
}
export const changeOrderAfterSortHelper = (gridRef) => {
    let newOrder = []
    gridRef.current.api.forEachNodeAfterFilterAndSort((row) => newOrder.push(row.id))
    return newOrder
}
export const makeColStateObj = (columns) => {
    let obj = {}
    columns.forEach((col) => {
        obj[col.colId] = col
    })
    return obj
}
export const makeColFieldObj = (columns, autoColumnGroupDefsState) => {
    let obj = {};
  
    // 1️⃣ Check if primaryCol exists
    const hasPrimaryCol = columns.some(col => col.field === "primaryCol");
  
    // 2️⃣ If missing → inject from autoColumnGroupDefsState
    if (!hasPrimaryCol && autoColumnGroupDefsState?.field === "primaryCol") {
      columns = [autoColumnGroupDefsState, ...columns]; // keep it at start
    }
  
    // 3️⃣ Build map
    columns.forEach(col => {
      const cleanCol = { ...col };
  
      if (cleanCol.marryChildren === true && cleanCol.headerGroupComponentParams) {
        delete cleanCol.headerGroupComponentParams;
      }
  
      if (cleanCol.headerComponentParams) {
        delete cleanCol.headerComponentParams;
      }
  
      obj[cleanCol.field] = cleanCol;
    });
  
    return obj;
  };
  
export const syncColumnDefsWithColState = ({ colDefs, autoColumnGroupDef, colState }) => {
    colDefs.forEach((colDef) => {
        colDef.sort = colState[colDef.colId]?.sort
    })
    autoColumnGroupDef.sort = colState[autoColumnGroupDef.colId]?.sort
    return { newColDefs: colDefs, autoGroupColumnDef: autoColumnGroupDef }
}

// Main function to find and outdent child nodes
export const findChildsOfNode = (l_id, index, rowData, new_lid, childrenArray, gridRef,dontincludeSiblings) => {
    try {
      const newIdList = l_id.split(".");
      const idListLength = newIdList.length;
      const parent = newIdList[idListLength - 2];
      let undoRowsOutdented = [];
      let rowIndex = index;
      if (!parent) return { canBecomeParent: false, updatedRows: [], undoRowsOutdented: [] };
      let canBecomeParent = rowData[index + 1]?.data?.l_id.includes(parent);
      const totalChildrenCount = childrenArray?.filter(node => node.rowIndex !== null).length;
      let children_length = totalChildrenCount-1;
      const { updatedRows, alreadyTraversed,undoChildrenRows,canBecomeParentUpdated } = traverseChildren(index, parent, new_lid, rowData, childrenArray, gridRef,canBecomeParent);
      const { additionalRows, additionalUndoRows } =dontincludeSiblings?{additionalRows:[],additionalUndoRows:[]} : processChildNodes(index + children_length, parent, new_lid, rowData, gridRef, alreadyTraversed);
        console.log("Child nodes processed")
      return {
        canBecomeParent:canBecomeParent || canBecomeParentUpdated,
        updatedRows: [...updatedRows, ...additionalRows],
        undoRowsOutdented: [...undoRowsOutdented,...undoChildrenRows, ...additionalUndoRows],
        alreadyTraversed:alreadyTraversed
      };
    } catch (error) {
      console.error("Error in findChildsOfNode:", error);
      return { canBecomeParent: false, updatedRows: [{ row: rowData[index].data, rowIndex: index }], undoRowsOutdented: [] };
    }
  };
  
  // Helper function to traverse children nodes and outdent them
  const traverseChildren = (index, parent, new_lid, rowData, childrenArray, gridRef,canBecomeParentUpdated) => {
    let updatedRows = [{ row: rowData[index].data, rowIndex: index }];
    let undoChildrenRows=[]
    let alreadyTraversed = {};
    alreadyTraversed[rowData[index].id] = true;
  
    // Traverse direct children
    for (let i = 0; i < childrenArray.length-1 ; i++) {
      try {
        const childNode = childrenArray[i+1];
        if (shouldOutdentChild(childNode, parent, rowData[index], alreadyTraversed)) {
          if(!canBecomeParentUpdated && childNode.data.l_id.includes(rowData[index].id)) {canBecomeParentUpdated = true}
          console.log("Inside outdent outdenting the child node in child array", childNode.data.l_id, childNode.data.primaryCol, childNode.data.id);
          undoChildrenRows.push({...childNode.data})
          alreadyTraversed[childNode.data.id] = true;
          let newChildLid = computeNewChildLid(childNode, parent, new_lid);
          childNode.data.l_id = newChildLid;
          childNode.data.l_id = syncLidWithId(childNode.data);
        //   let rowIndex = gridRef.current.api.getRowNode(childNode.data.id).rowIndex;
          updatedRows.push({ row: childNode.data, rowIndex:childNode.rowIndex });
        }
      } catch (error) {
        console.error("Error while traversing children:", error);
      }
    }
  
    return { updatedRows, alreadyTraversed ,undoChildrenRows,canBecomeParentUpdated};
  };
  
  // Helper function to process additional child nodes using a while loop
  const processChildNodes = (index, parent, new_lid, rowData, gridRef, alreadyTraversed) => {
    let additionalRows = [];
    let additionalUndoRows = [];
    let currIndex = index;
    let collapsedChildrenRows = [];
    while (rowData[currIndex + 1] && rowData[currIndex + 1].data.l_id.includes(parent)) {
      try {
        if (!alreadyTraversed[rowData[currIndex + 1].data.id]) {
          alreadyTraversed[rowData[currIndex + 1].data.id] = true;
          let isMyIdAlreadyPresentInChild = rowData[currIndex + 1].data.l_id.includes(rowData[index].data.id);
          additionalUndoRows.push({ ...rowData[currIndex + 1].data });
          if (isMyIdAlreadyPresentInChild) {
            console.log("Inside outdent outdenting the child node ", rowData[currIndex + 1].data.l_id, rowData[currIndex + 1].data.primaryCol, rowData[currIndex + 1].data.id,"isExpanded",rowData[currIndex + 1].expanded);
            let temp = rowData[currIndex + 1].data.l_id.split('.');
            if (temp.indexOf(parent) != -1) {
              let idx = temp.indexOf(rowData[index].data.id);
              let updated_lid = new_lid + '.' + temp.slice(idx + 1).join('.');
              rowData[currIndex + 1].data.l_id = removeDuplicateKeepLast(updated_lid);
              rowData[currIndex + 1].data.l_id = syncLidWithId(rowData[currIndex + 1].data);
              if(rowData[currIndex + 1].expanded===false) { // add child rows if parent's path is changed
                collapsedChildrenRows=[...collapsedChildrenRows,...getAllChildrenOfaNode(rowData[currIndex + 1])]
              }
            }
          } else {
            console.log("Inside outdent outdenting the child node ", rowData[currIndex + 1].data.l_id, rowData[currIndex + 1].data.primaryCol, rowData[currIndex + 1].data.id,"isExpanded",rowData[currIndex + 1].expanded);
            let temp = rowData[currIndex + 1].data.l_id.split('.');
            let idx = temp.indexOf(parent);
            if (idx != -1) {
              let updated_lid = new_lid + '.' + temp.slice(idx + 1).join('.');
              rowData[currIndex + 1].data.l_id = removeDuplicateKeepLast(updated_lid);
              rowData[currIndex + 1].data.l_id = syncLidWithId(rowData[currIndex + 1].data);
              if(rowData[currIndex + 1].expanded===false && rowData[currIndex + 1].childrenAfterAggFilter.length !== 0 ) { // add child rows if parent's path is changed
                collapsedChildrenRows=[...collapsedChildrenRows,...getAllChildrenOfaNode(rowData[currIndex + 1])]
                console.log(rowData[currIndex + 1].data.primaryCol, " is collapsed",rowData[currIndex + 1].id,rowData[currIndex + 1].data.l_id)
              }
            }
          }
        //   let rowIndex = gridRef.current.api.getRowNode(rowData[currIndex + 1].data.id).rowIndex;
          additionalRows.push({ row: rowData[currIndex + 1].data, rowIndex:rowData[currIndex + 1].rowIndex });
          currIndex += 1;
        }
      } catch (error) {
        console.error("Error while processing additional child nodes:", error);
      }
    }
    console.log("collapsed children rows",collapsedChildrenRows);
    let {collapsedAndChangedChildrenRows,collapsedAndChangedChildrenRowsForUndo}=addChildRowsIfCollapsed(index, parent, new_lid, alreadyTraversed,collapsedChildrenRows)
    console.log("collapsedAndChangedChildrenRows",collapsedAndChangedChildrenRows);
    additionalRows=[...additionalRows,...collapsedAndChangedChildrenRows]
    additionalUndoRows=[...additionalUndoRows,...collapsedAndChangedChildrenRowsForUndo]
    return { additionalRows, additionalUndoRows };
  };
  function addChildRowsIfCollapsed(index, parent, new_lid,  alreadyTraversed,collapsedChildrenRows){
    let childrenIndex=0
    let collapsedAndChangedChildrenRows=[],collapsedAndChangedChildrenRowsForUndo=[]
    // if(collapsedChildrenRows) return {collapsedAndChangedChildrenRows,collapsedAndChangedChildrenRowsForUndo}
    while (collapsedChildrenRows[childrenIndex] && collapsedChildrenRows[childrenIndex].data.l_id.includes(parent)) {
        try {
          if (!alreadyTraversed[collapsedChildrenRows[childrenIndex].data.id]) {
            alreadyTraversed[collapsedChildrenRows[childrenIndex].data.id] = true;
            // let isMyIdAlreadyPresentInChild = collapsedChildrenRows[childrenIndex].data.l_id.includes(collapsedChildrenRows[index].data.id);
            collapsedAndChangedChildrenRowsForUndo.push({ ...collapsedChildrenRows[childrenIndex].data });
            // if (isMyIdAlreadyPresentInChild) {
            //   console.log("Inside outdent outdenting the child node ", collapsedChildrenRows[childrenIndex].data.l_id, collapsedChildrenRows[childrenIndex].data.primaryCol, collapsedChildrenRows[childrenIndex].data.id);
            //   let temp = collapsedChildrenRows[childrenIndex].data.l_id.split('.');
            //   if (temp.indexOf(parent) != -1) {
            //     let idx = temp.indexOf(collapsedChildrenRows[index].data.id);
            //     let updated_lid = new_lid + '.' + temp.slice(idx + 1).join('.');
            //     collapsedChildrenRows[childrenIndex].data.l_id = removeDuplicateKeepLast(updated_lid);
            //     collapsedChildrenRows[childrenIndex].data.l_id = syncLidWithId(collapsedChildrenRows[childrenIndex].data);
            //   }
            // } else {
              console.log("Inside outdent outdenting the child node ", collapsedChildrenRows[childrenIndex].data.l_id, collapsedChildrenRows[childrenIndex].data.primaryCol, collapsedChildrenRows[childrenIndex].data.id);
              let temp = collapsedChildrenRows[childrenIndex].data.l_id.split('.');
              let idx = temp.indexOf(parent);
              if (idx != -1) {
                let updated_lid = new_lid + '.' + temp.slice(idx + 1).join('.');
                collapsedChildrenRows[childrenIndex].data.l_id = removeDuplicateKeepLast(updated_lid);
                collapsedChildrenRows[childrenIndex].data.l_id = syncLidWithId(collapsedChildrenRows[childrenIndex].data);
              }
            // }
          //   let rowIndex = gridRef.current.api.getRowNode(rowData[childrenIndex].data.id).rowIndex;
            collapsedAndChangedChildrenRows.push({ row: collapsedChildrenRows[childrenIndex].data, rowIndex:collapsedChildrenRows[childrenIndex].rowIndex });
            childrenIndex += 1;
          }
        } catch (error) {
          console.error("Error while processing additional child nodes:", error);
        }
      }
    return { collapsedAndChangedChildrenRows, collapsedAndChangedChildrenRowsForUndo };
  }
  // Helper function to determine if a child should be outdented
  const shouldOutdentChild = (childNode, parent, currentNode, alreadyTraversed) => {
    return !alreadyTraversed[childNode.data.id] &&
      childNode.data.l_id.includes(currentNode.data.id) &&
      (childNode.rowIndex === null || currentNode.rowIndex < childNode.rowIndex);
  };
  
  // Helper function to compute new l_id for a child node
  const computeNewChildLid = (childNode, parent, new_lid) => {
    const temp = childNode.data.l_id.split('.');
    if (temp.indexOf(parent) !== -1) {
      const idx = temp.indexOf(parent);
      return removeDuplicateKeepLast(new_lid + '.' + temp.slice(idx + 1).join('.'));
    }
    return childNode.data.l_id;
  };
  

// export const findChildsOfNode = (l_id, index, rowData, newl_id, childrenArray, gridRef) => {
//     try{
//             let newIdList = l_id.split(".")
//             let undoRowsOutdented = []
//             let idListLength = newIdList.length
//             let parent = newIdList[idListLength - 2]
//             let rowIndex = index
//             let updatedRows = [{ row: rowData[index].data, rowIndex: rowIndex, rowMetaData: rowData[index].data }]
//             if(!parent) return { canBecomeParent:false, updatedRows, undoRowsOutdented:[] }
//             console.log(newl_id, l_id, "findChildsOfNode", parent)
//             let canBecomeParent = rowData[index + 1].data.l_id.includes(parent)
//             let currIndex = index
//             let stopExecution = false
//             //we shoud have outdented the row at index but the outdented l_id is already sent by the rowData from callee function
//             let alreadyTraversed = {}
//             alreadyTraversed[rowData[index].id] = true
//             // if(childrenArray.length<2){
        
//             // }
//             for (let currIndex=0;currIndex<childrenArray.length-1;currIndex++){
//                 if(!alreadyTraversed[childrenArray[currIndex+1].data.id] && childrenArray[currIndex+1].data.l_id.includes(rowData[index].id) && (childrenArray[currIndex+1].rowIndex===null || rowData[index].rowIndex<childrenArray[currIndex+1].rowIndex)){
//                     alreadyTraversed[childrenArray[currIndex+1].data.id]=true
//                     let isMyIdAlreadyPresentInChild=childrenArray[currIndex+1].data.l_id.includes(childrenArray[0].data.id)
//                     undoRowsOutdented.push({...childrenArray[currIndex+1].data})
//                     if(isMyIdAlreadyPresentInChild!=false) {
//                         console.log("Inside outdent Child Array outdenting the child node ",childrenArray[currIndex+1].data.l_id,childrenArray[currIndex+1].data.primaryCol)
//                         canBecomeParent=true
//                         let temp=childrenArray[currIndex+1].data.l_id.split('.')
//                         // let idx=temp.indexOf(parent)
//                         // temp.splice(idx,1)
//                         // childrenArray[currIndex+1].data.l_id=removeDuplicateKeepLast(temp.join('.'))
//                         if(temp.indexOf(parent)!=-1){
//                             let idx=temp.indexOf(parent)
//                             let updated_lid=newl_id+'.' +temp.slice(idx+1).join('.')
//                             childrenArray[currIndex+1].data.l_id=removeDuplicateKeepLast(updated_lid)
//                             childrenArray[currIndex+1].data.l_id=syncLidWithId(childrenArray[currIndex+1].data)
//                         }
        
//                     }
//                     else{
//                         console.log("Inside outdent Child Array outdenting the child node ",childrenArray[currIndex+1].data.l_id,childrenArray[currIndex+1].data.primaryCol)
//                         let temp=childrenArray[currIndex+1].data.l_id.split('.')
//                         let idx=temp.indexOf(parent)
//                         if(idx!=-1){
//                             let updatedl_id=newl_id +'.'+ temp.slice(idx+1).join('.')
//                             childrenArray[currIndex+1].data.l_id=removeDuplicateKeepLast(updatedl_id)
//                             childrenArray[currIndex+1].data.l_id=syncLidWithId(childrenArray[currIndex+1].data)
        
//                         }
        
//                         // childrenArray[currIndex+1].data.l_id=removeDuplicateKeepLast(childrenArray[currIndex+1].data.l_id.replace(parent,childrenArray[0].data.id))
//                     } 
//                     let rowIndex=gridRef.current.api.getRowNode(childrenArray[currIndex+1].data.id).rowIndex
//                     updatedRows.push({row:childrenArray[currIndex+1].data,rowIndex:rowIndex,rowMetaData:childrenArray[currIndex+1].data})
//                 }
//             }
//             while (rowData[currIndex + 1].data.l_id.includes(parent)) {
//                 if (!alreadyTraversed[rowData[currIndex + 1].data.id]) {
//                     alreadyTraversed[rowData[currIndex + 1].data.id] = true
//                     let isMyIdAlreadyPresentInChild = rowData[currIndex + 1].data.l_id.includes(rowData[index].data.id)
//                     undoRowsOutdented.push({ ...rowData[currIndex + 1].data })
//                     if (isMyIdAlreadyPresentInChild != false) {
//                         console.log("Inside outdent outdenting the child node ", rowData[currIndex + 1].data.l_id, rowData[currIndex + 1].data.primaryCol, rowData[currIndex + 1].data.id)
//                         let temp = rowData[currIndex + 1].data.l_id.split('.')
//                         //previous implementation before 02/06/2023
//                         // let idx=temp.indexOf(parent)
//                         // temp.splice(idx,1)
//                         // rowData[currIndex+1].data.l_id=removeDuplicateKeepLast(temp.join('.'))
//                         //new implementation on 02/06/2023
//                         if (temp.indexOf(parent) != -1) {
//                             let idx = temp.indexOf(rowData[index].data.id)
//                             let updated_lid = newl_id + '.' + temp.slice(idx + 1).join('.')
//                             rowData[currIndex + 1].data.l_id = removeDuplicateKeepLast(updated_lid)
//                             rowData[currIndex + 1].data.l_id=syncLidWithId(rowData[currIndex + 1].data)
        
//                         }
//                     }
//                     else {
//                         //new implementation on 02/06/2023
//                         console.log("Inside outdent outdenting the child node ", rowData[currIndex + 1].data.l_id, rowData[currIndex + 1].data.primaryCol, rowData[currIndex + 1].data.id)
//                         let temp = rowData[currIndex + 1].data.l_id.split('.')
//                         let idx = temp.indexOf(parent)
//                         if (idx != -1) {
//                             let updatedl_id = newl_id + '.' + temp.slice(idx + 1).join('.')
//                             rowData[currIndex + 1].data.l_id = removeDuplicateKeepLast(updatedl_id)
//                             rowData[currIndex + 1].data.l_id=syncLidWithId(rowData[currIndex + 1].data)
//                         }
//                         //previous implementation before 02/06/2023
//                         // rowData[currIndex+1].data.l_id=removeDuplicateKeepLast(rowData[currIndex+1].data.l_id.replace(parent,rowData[index].data.id))
//                     }
//                     let rowIndex = gridRef.current.api.getRowNode(rowData[currIndex + 1].data.id).rowIndex
//                     updatedRows.push({ row: rowData[currIndex + 1].data, rowIndex: rowIndex, rowMetaData: rowData[currIndex + 1].data })
//                     currIndex += 1
//                 }
//             }
          
        
//             return { canBecomeParent, updatedRows, undoRowsOutdented }
//     }
//     catch(e)
//     {
//         let rowIndex = index
//         let updatedRows = [{ row: rowData[index].data, rowIndex: rowIndex, rowMetaData: rowData[index].data }]
//         console.log("Error in find Childs of node",e)
//         return  {canBecomeParent:false, updatedRows, undoRowsOutdented:[] }
//     }
// }
// Utility Functions

const initializeShiftData = () => {
    return {
        indexesToShift: [],
        elements: [],
        rowsBeforeDrag: [],
        alreadyTraversed: {},
        noOfVisibleChildren: -1,
        collapsedChildren: []
    };
};

const updateElementLid = (element, prefixlid, parentl_id) => {
    element.data.l_id = removeDuplicateKeepLast(prefixlid + element.data.l_id.split('.').slice(parentl_id.length).join('.'));
    return element;
};

const processRow = (row, shiftData, prefixlid, parentl_id,loggedInUser) => {
    const { alreadyTraversed, elements, rowsBeforeDrag, collapsedChildren } = shiftData;
    if (!alreadyTraversed[row.data.id]) {
        alreadyTraversed[row.data.id] = true;
        shiftData.indexesToShift.push(row.rowIndex);
        row.data = changeUpdatedDateOfRow(row.data,loggedInUser);
        rowsBeforeDrag.push(JSON.parse(JSON.stringify(row.data)));
        elements.push(updateElementLid(row, prefixlid, parentl_id));
        shiftData.noOfVisibleChildren += 1;
        if (row.rowIndex !== null && row.expanded === false) collapsedChildren.push(row);
    }    
};

const processRows = (fromIndex, parentid, rows, prefixlid, parentl_id, shiftData) => {
    let currIndex = fromIndex;
    while (rows[currIndex] && rows[currIndex].data.l_id.includes(parentid)) {
        processRow(rows[currIndex], shiftData, prefixlid, parentl_id);
        currIndex += 1;
    }
};

const processChildrenArray = (parentid, childrenArray, prefixlid, parentl_id, shiftData,loggedInUser) => {
    for (let currIndex = 0; currIndex < childrenArray.length; currIndex++) {
        if (childrenArray[currIndex] && !shiftData.alreadyTraversed[childrenArray[currIndex].data.id] && childrenArray[currIndex].data.l_id.includes(parentid)) {
            processRow(childrenArray[currIndex], shiftData, prefixlid, parentl_id,loggedInUser);
        }
    }
};

// Main Function

export function changeOrderForAllChildren(fromIndex, parentid, rows, prefixlid = '', childrenArray,loggedInUser) {
    const shiftData = initializeShiftData();
    let parentl_id = rows[fromIndex].data.l_id.split('.').slice(0, -1);
    prefixlid += prefixlid ? '.' : '';

    //processRows(fromIndex, parentid, rows, prefixlid, parentl_id, shiftData);

    if (childrenArray && childrenArray.length > 1) {
        processChildrenArray(parentid, childrenArray, prefixlid, parentl_id, shiftData,loggedInUser);
    }
    let elements = shiftData.elements.sort((a, b) => a.sourceRowIndex < b.sourceRowIndex).map((element) => {return element.data});
    return {
        changedRows: elements,
        rowsBeforeDrag: shiftData.rowsBeforeDrag,
        noOfVisibleChildren: shiftData.noOfVisibleChildren,
        collapsedChildren: shiftData.collapsedChildren
    };
}

export const findFromIndex = (currentSheetRows, dragStartIndex, rid) => {
    if (dragStartIndex !== undefined) return dragStartIndex;
    for (let i = 0; i < currentSheetRows.length; i++) {
        if (currentSheetRows[i].data?.id === rid) {
            return i;
        }
    }
    return -1;
};

export const isParentChildConflict = (prefixlid, fromData) => {
    return prefixlid.includes(fromData.id);
};

export const generateNewLid = (prefixlid, fromData) => {
    let newl_id = prefixlid ? `${prefixlid}.${fromData.id}` : fromData.id;
    return removeDuplicateKeepLast(newl_id);
};

export const validateNewLid = (newl_id, fromData, gridRef) => {
    return validatel_id(newl_id, fromData.id, gridRef);
};

export function getUniqueChildrenArray(nodes) {
    const seenKeys = new Set();
    const childrenArray = [];
    childrenArray.push(nodes);
    function addNodeAndChildren(node) {
        if (!node || seenKeys.has(node.key)) return;

        seenKeys.add(node.key);
        childrenArray.push(node);

        (node?.childrenAfterGroup || []).forEach(childNode => addNodeAndChildren(childNode));
    }
if(nodes?.childrenAfterGroup) {
    (nodes?.childrenAfterGroup || []).forEach(childNode => addNodeAndChildren(childNode));

    return childrenArray;
} 
else {
    return childrenArray;
}}
export const collapseAboveNode = (row,gridRef,nodeStateMap) =>{
    let childrenArray = [];
    childrenArray = getUniqueChildrenArray(row);
    childrenArray.forEach((node) => {
        if (nodeStateMap.has(node.id)) {
            const shouldExpand = nodeStateMap.get(node.id);
            gridRef.current.api.setRowNodeExpanded(node, shouldExpand);
        }
    });

}
export const expandAboveNode = (row,gridRef) => {
    let childrenArray = [];
    childrenArray = getUniqueChildrenArray(row);

    // Capture current expanded state
    const nodeStateMap = new Map();
    childrenArray.forEach((node) => {
        nodeStateMap.set(node.id, node.expanded);
    });

    // Expand all child nodes
    let children = row.allLeafChildren || row.childrenAfterAggFilter
    requestAnimationFrame(() => {
    children.forEach((node) => {
      gridRef.current.api.setRowNodeExpanded(node, true, true);
    });
  });
    return nodeStateMap;
}
export const handleDragWithCollapsedNode = ({
    gridRef,
    currentSheetRows,
    overIndex,
    fromIndex,
    direction,
    undoRows,
    dragStartIndex,
    setUndoStack,
    getUniqueChildrenArray,
    isWholeTreeShift = false,
    changedRows,
    collapsedChildren,
    rowsBeforeDrag,
    rowsToUpdate,
    prefixlid,
    totalParentsBeforeAndAfterDrag,
    predecessorcolumn,
    loggedInUser,
    overNodeId,
    l_idForUndo
}) => {
    
    const activeSpan = trace.getSpan(context.active());
    let functionFlow = ["handleDragWithCollapsedNode start"]
    return new Promise((resolve) => {
        // If dragging upwards into a collapsed node with children
        let childrenArray = [];
        let nodeToExpand = direction === 'up' ? currentSheetRows[overIndex - 1] : currentSheetRows[overIndex]
        childrenArray = getUniqueChildrenArray(nodeToExpand);

        // Capture current expanded state
        const nodeStateMap = new Map();
        childrenArray.forEach((node) => {
            nodeStateMap.set(node.id, node.expanded);
        });
        // Expand all child nodes
        requestAnimationFrame(() => {

        nodeToExpand.allLeafChildren.forEach((node) => {
            gridRef.current.api.setRowNodeExpanded(node, true, true);
        });})

        const draggedchildrenArray = getUniqueChildrenArray(currentSheetRows[fromIndex]);
        nodeStateMap.set(currentSheetRows[fromIndex].id, currentSheetRows[fromIndex].expanded);
        const totalChildrenCount = draggedchildrenArray?.filter(node => node.rowIndex !== null).length;
        if (isWholeTreeShift) {
            functionFlow.push("isWholeTreeShift");
            setTimeout(() => {
                // Calculate transaction index
                let overIndexForTransaction =
                    fromIndex > overIndex && direction === "up"
                        ? overIndex + childrenArray.length - 1
                        : fromIndex > overIndex && direction === "down"
                            ? overIndex + childrenArray.length
                            : direction === "down"
                                ? overIndex + childrenArray.length-totalChildrenCount
                                : overIndex + childrenArray.length - 1 - totalChildrenCount;
                if (direction === null || direction === undefined) {
                    if (fromIndex > overIndex) {
                        overIndexForTransaction = overIndex + childrenArray.length - 1;
                    }
                    else {
                        overIndexForTransaction = overIndex - totalChildrenCount + 1;
                    }
                    if (fromIndex === overIndex) {
                        overIndexForTransaction = overIndex;
                    }
                }
                functionFlow.push(`handleDragWithCollapsedNode-wholeTree overIndexForTransaction:${overIndexForTransaction} fromIndex:${fromIndex} overIndex:${overIndex} direction:${direction} totalChildrenCount:${totalChildrenCount} l_idForUndo:${l_idForUndo}`);
                let undoInfo
                if (changedRows && overIndexForTransaction !== undefined) {
                    gridRef?.current?.api?.applyTransaction({ remove: changedRows });

                    let dropIndex = gridRef.current.api.applyTransaction({
                        add: changedRows,
                        addIndex: overIndexForTransaction,
                    });
                    let belowNodeId
                    // calculate belowNode
                    let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
                    let droppedNodeIndex = dropIndex.add.reduce((acc, curr) => {
                        return Math.max(acc, curr.sourceRowIndex);
                    }, 0);
                    if (droppedNodeIndex || droppedNodeIndex === 0) {
                        let nodeBelow = rowData[droppedNodeIndex + 1];
                        belowNodeId = nodeBelow?.id || 'none'
                    };
                    logSpan(`handleDragWithCollapsedNode-wholeTree-dropIndex Node`, activeSpan.spanContext(), "INFO", dropIndex);
                    functionFlow.push(`handleDragWithCollapsedNode-wholeTree droppedNodeIndex:${droppedNodeIndex}`);
                    if (dropIndex.add[0].rowIndex) {
                        let nodeToRefresh = gridRef.current.api.getRowNode(
                            changedRows[0].id
                        );
                        gridRef.current.api.refreshCells({
                            rowNodes: [nodeToRefresh],
                            force: true,
                        });
                    }
                    let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency(dropIndex.add, gridRef)
                    allRowsIncludingRefinedOnes.forEach((row) => {
                        let node = gridRef.current.api.getRowNode(row.id);
                        let parents = getAllParentsOfANode(node);
                        parents.forEach((parentNode) => totalParentsBeforeAndAfterDrag.add(parentNode));
                    });

                    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(allRowsIncludingRefinedOnes, gridRef, predecessorcolumn, totalParentsBeforeAndAfterDrag)

                    if (mergedRowsAfterRollupAndPredecessorChange.length)
                        applyTransaction(gridRef, mergedRowsAfterRollupAndPredecessorChange, dropIndex.add[0].rowIndex);

                    let undoRowsArray = rowsBeforeDrag && rowsBeforeDrag.length > 0 ? [...rowsBeforeDrag] : undoRows;
                    // Create a deep copy to prevent reference issues
                    let undoRowsArrayforUpdate = JSON.parse(JSON.stringify(undoRowsArray));
                    if (arrayOfAdditionalUndoRows?.length) {
                        handleUndoRowUpdates(arrayOfAdditionalUndoRows, undoRowsArrayforUpdate, 'id');
                    }
                    if (additionalParentAndExtraRowsForUndo?.length) {
                        handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowsArrayforUpdate, 'id');
                    }
                    
                    logSpan(`handleDragWithCollapsedNode-handleUndoRowUpdates-before-wholeTree undoStack-rollup`, activeSpan.spanContext(), "INFO", formatArrayforLogs(undoRowsArrayforUpdate), formatArrayforLogs(mergedRowsAfterRollupAndPredecessorChange));
                    // Filter rows in undoRowsArrayforUpdate that are not in undoRowsArray
                    const undoRowsArrayforUpdateFiltered = filterRows(undoRowsArrayforUpdate, undoRowsArray);
                    // Update changedRows based on mergedRowsAfterRollupAndPredecessorChange
                    const updatedChangedRows = mapUpdatedRows(changedRows, mergedRowsAfterRollupAndPredecessorChange);
                    // Get rows in mergedRowsAfterRollupAndPredecessorChange not in changedRows
                    const remainingMergedRows = filterRows(mergedRowsAfterRollupAndPredecessorChange, changedRows);

                    // Restore original node expanded states
                    requestAnimationFrame(() => {

                        childrenArray.forEach((node) => {
                            if (nodeStateMap.has(node.id)) {
                                const shouldExpand = nodeStateMap.get(node.id);
                                gridRef.current.api.setRowNodeExpanded(node, shouldExpand);
                            }
                        });


                    // Resolve with the dropIndex after restoring states
                });
                setTimeout(() => {
                    if (nodeStateMap.has(currentSheetRows[fromIndex].id)) {
                        const shouldExpand = nodeStateMap.get(currentSheetRows[fromIndex].id);
                        gridRef.current.api.setRowNodeExpanded(currentSheetRows[fromIndex], shouldExpand);
                    }
                },1000)
                let overNodeForUndo;

                if (direction === "down") {
                  if (currentSheetRows[fromIndex + totalChildrenCount]) {
                    overNodeForUndo = currentSheetRows[fromIndex + totalChildrenCount];
                  } else {
                    overNodeForUndo = currentSheetRows[fromIndex - 1];
                  }
                } else {
                  if (currentSheetRows[fromIndex - 1]) {
                    overNodeForUndo = currentSheetRows[fromIndex - 1];
                  } else {
                    overNodeForUndo = currentSheetRows[fromIndex + totalChildrenCount];
                  }
                }                

                  let finalDirection = direction === "down"
                  ? (currentSheetRows[fromIndex + totalChildrenCount] ? direction : "up")
                  : (currentSheetRows[fromIndex - 1] ? direction : "down");
              
               if ( currentSheetRows[fromIndex - 1] &&  currentSheetRows[fromIndex - 1].expanded !== true && currentSheetRows[fromIndex - 1].childrenAfterGroup.length !== 0) {

                        let childrenArray1 = [];
                        childrenArray1 = getUniqueChildrenArray(currentSheetRows[fromIndex - 1]);
                         setTimeout(() => {                     
                            undoInfo = { type: "row", action: "drag",overNodeId,direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex + (fromIndex > overIndex ? childrenArray.length - 1 : 0) + childrenArray1.length - 1, overIndex: dropIndex.add[0].rowIndex + childrenArray.length - 1 + (fromIndex < overIndex ? childrenArray1.length - 1 : 0), aboveNode: currentSheetRows[overIndex - 1], fromIndexAboveNode: currentSheetRows[fromIndex - 1] ,cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId ,prefixl_idForUndo:l_idForUndo,draggedNode:dropIndex.add[0],
                            overNode:overNodeForUndo,word :1};
                            functionFlow.push("handleDragWithCollapsedNode-singleRow-dragStartIndex end")
                            activeSpan.setAttribute("handleDragWithCollapsedNode-functionFlow", functionFlow);
                            resolve({dropIndex:dropIndex.add[0].rowIndex,undoInfo});
                         }, 500);

                    }
                    else if (dragStartIndex !== undefined) {
                         setTimeout(() => {
                            undoInfo = 
                                {
                                    type: "row",
                                    action: "drag",
                                    direction:finalDirection,
                                    overNodeId,
                                    rowData: undoRowsArray,
                                    index: dragStartIndex + (fromIndex > overIndex ? childrenArray.length - 1 : 0),
                                    overIndex: (dropIndex.add[0].rowIndex + childrenArray.length) - 1,
                                    aboveNode: currentSheetRows[overIndex - 1],
                                    cellRows: updatedChangedRows,
                                     previousRows: undoRowsArrayforUpdateFiltered,
                                      updatedRows: remainingMergedRows ,
                                      belowNodeId,
                                      prefixl_idForUndo:l_idForUndo,
                                      draggedNode:dropIndex.add[0],
                                      overNode:overNodeForUndo,
                                      word :2
                                }
                                functionFlow.push("handleDragWithCollapsedNode-singleRow-dragStartIndex end")
                                activeSpan.setAttribute(`handleDragWithCollapsedNode-functionFlow`, functionFlow)
                                resolve({dropIndex:dropIndex.add[0].rowIndex,undoInfo});

                         }, 500);
                    
                    }

                    // Collapse previously collapsed children
  
                    setTimeout(() => {
                        childrenArray.forEach((node) => {
                            if (nodeStateMap.has(node.id)) {
                                const shouldExpand = nodeStateMap.get(node.id);
                                gridRef.current.api.setRowNodeExpanded(node, shouldExpand);
                            }
                        });
                          
    
                        // Resolve with the dropIndex after restoring states
                    }, 0);
                }
            }, 10);
        } else if (!isWholeTreeShift) {
            functionFlow.push("SingleRowShift");
            setTimeout(() => {
                let overIndexForTransaction =
                    fromIndex > overIndex && direction === "up"
                        ? overIndex + childrenArray.length - 1
                        : fromIndex > overIndex && direction === "down"
                            ? overIndex + childrenArray.length 
                            : direction === "up"
                                ? overIndex + childrenArray.length - 2
                                : overIndex + childrenArray.length - 1;
                if (direction === null || direction === undefined) {
                    if (fromIndex > overIndex) {
                        overIndexForTransaction = overIndex + childrenArray.length - 1;
                    }
                    else {
                        overIndexForTransaction = overIndex + childrenArray.length - 1;
                    }
                }
                let undoInfo;
                if (fromIndex === overIndex) {
                    overIndexForTransaction = overIndex;
                }
                functionFlow.push(`handleDragWithCollapsedNode-singleRow overIndexForTransaction:${overIndexForTransaction}`);
                if (rowsToUpdate?.length && overIndexForTransaction !== undefined) {
                    rowsToUpdate[0] = changeUpdatedDateOfRow(rowsToUpdate[0], loggedInUser);
                    gridRef?.current?.api?.applyTransaction({ remove: [rowsToUpdate[0]] });
                    let dropIndex = gridRef?.current?.api?.applyTransaction({
                        add: [rowsToUpdate[0]],
                        addIndex: prefixlid || prefixlid === "" ? overIndexForTransaction : fromIndex < overIndex && direction === "up" ? overIndexForTransaction : overIndex,
                    });

                    let belowNodeId
                    // calculate belowNode
                    let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
                    let droppedNodeIndex = dropIndex.add.reduce((acc, curr) => {
                        return Math.max(acc, curr.sourceRowIndex);
                    }, 0);
                    if (droppedNodeIndex || droppedNodeIndex === 0) {
                        let nodeBelow = rowData[droppedNodeIndex + 1];
                        belowNodeId = nodeBelow?.id || 'none'
                    };

                    logSpan(`handleDragWithCollapsedNode-singleRow-dropIndex Node`, activeSpan.spanContext(),"INFO", dropIndex);
                    functionFlow.push(`handleDragWithCollapsedNode-singleRow droppedNodeIndex:${droppedNodeIndex} fromIndex:${fromIndex} overIndex:${overIndex} direction:${direction} l_idForUndo:${l_idForUndo}`);

                    if (dropIndex.add[0].rowIndex) {
                        let nodeToRefresh = gridRef.current.api.getRowNode(rowsToUpdate[0].id);
                        gridRef.current.api.refreshCells({
                            rowNodes: [nodeToRefresh],
                            force: true,
                        });}
                        let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency(dropIndex.add, gridRef)
                        allRowsIncludingRefinedOnes.forEach((row) => {
                            let node = gridRef.current.api.getRowNode(row.id);
                            let parents = getAllParentsOfANode(node);
                            parents.forEach((parentNode) => totalParentsBeforeAndAfterDrag.add(parentNode));
                        });
            
                        let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(allRowsIncludingRefinedOnes, gridRef, predecessorcolumn, totalParentsBeforeAndAfterDrag)
            
                        if (mergedRowsAfterRollupAndPredecessorChange.length)
                            applyTransaction(gridRef, mergedRowsAfterRollupAndPredecessorChange, dropIndex.add[0].rowIndex);
            
                        let undoRowsArray = undoRows
                        // Create a deep copy to prevent reference issues
                        let undoRowsArrayforUpdate = JSON.parse(JSON.stringify(undoRowsArray));
                        if (arrayOfAdditionalUndoRows?.length) {
                            handleUndoRowUpdates(arrayOfAdditionalUndoRows, undoRowsArrayforUpdate, 'id');
                        }
                        if (additionalParentAndExtraRowsForUndo?.length) {
                            handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowsArrayforUpdate, 'id');
                        }

                         // Filter rows in undoRowsArrayforUpdate that are not in undoRowsArray
                const undoRowsArrayforUpdateFiltered = filterRows(undoRowsArrayforUpdate, undoRowsArray);
                // Update changedRows based on mergedRowsAfterRollupAndPredecessorChange
                const updatedChangedRows = mapUpdatedRows([rowsToUpdate[0]], mergedRowsAfterRollupAndPredecessorChange);
                // Get rows in mergedRowsAfterRollupAndPredecessorChange not in changedRows
                const remainingMergedRows = filterRows(mergedRowsAfterRollupAndPredecessorChange, [rowsToUpdate[0]]);
                const childrenArray2 = getUniqueChildrenArray(currentSheetRows[fromIndex]);
                const totalChildrenCount = childrenArray2?.filter(node => node.rowIndex !== null).length;
                let overNodeForUndo;

                if (direction === "down") {
                  const nextNode = currentSheetRows[fromIndex + 1 + totalChildrenCount];
                  if (nextNode) {
                    overNodeForUndo = nextNode;
                  } else {
                    overNodeForUndo = currentSheetRows[fromIndex - 1];
                  }
                } else {
                  const prevNode = currentSheetRows[fromIndex - 1];
                  if (prevNode) {
                    overNodeForUndo = prevNode;
                  } else {
                    overNodeForUndo = currentSheetRows[fromIndex + 1 + totalChildrenCount];
                  }
                }
                

                    let finalDirection = direction === "down"
                        ? (currentSheetRows[fromIndex + totalChildrenCount] ? direction : "up")
                        : (currentSheetRows[fromIndex - 1] ? direction : "down");

                undoInfo = { type: "row", action: "drag",direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex, overIndex: dropIndex.add[0].rowIndex, cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId,draggedNode: dropIndex.add[0],overNode:overNodeForUndo};
                        if (currentSheetRows[fromIndex - 1] && currentSheetRows[fromIndex - 1].expanded !== true && currentSheetRows[fromIndex - 1].childrenAfterGroup.length !== 0) {
                        // setTimeout(() => {
                        //     childrenArray.forEach((node) => {
                        //         if (nodeStateMap.has(node.id)) {
                        //             const shouldExpand = nodeStateMap.get(node.id);
                        //             gridRef.current.api.setRowNodeExpanded(node, shouldExpand);
                        //         }
                        //     });
                        // }, 0);
                        let childrenArray1 = [];
                        childrenArray1 = getUniqueChildrenArray(currentSheetRows[fromIndex - 1]);
                         setTimeout(() => {
                            undoInfo = { type: "row", action: "drag",direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex + (fromIndex > overIndex ? childrenArray.length - 1 : 0) + childrenArray1.length - 1, overIndex: dropIndex.add[0].rowIndex + childrenArray.length - 1 + (fromIndex < overIndex ? childrenArray1.length - 1 : 0), aboveNode: currentSheetRows[overIndex - 1], fromIndexAboveNode: currentSheetRows[fromIndex - 1] ,cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows ,belowNodeId ,prefixl_idForUndo:l_idForUndo,  draggedNode:dropIndex.add[0],
                            overNode:overNodeForUndo,word :4};
                            functionFlow.push("handleDragWithCollapsedNode-singleRow end")
                            activeSpan.setAttribute("handleDragWithCollapsedNode-functionFlow", functionFlow);
                            resolve({dropIndex: dropIndex.add[0].rowIndex,undoInfo});
                         }, 500);

                    }
                    else {
                         setTimeout(() => {
                            if (dragStartIndex !== undefined) {
                                undoInfo = 
                                    {
                                        type: "row",
                                        action: "drag",
                                        direction:finalDirection,
                                        rowData: undoRowsArray,
                                        index: dragStartIndex + (fromIndex > overIndex ? childrenArray.length - 1 : 0),
                                        overIndex: dropIndex.add[0].rowIndex + childrenArray.length - 1,
                                        aboveNode: currentSheetRows[overIndex - 1],
                                        cellRows: updatedChangedRows,
                                         previousRows: undoRowsArrayforUpdateFiltered,
                                          updatedRows: remainingMergedRows,
                                          belowNodeId,
                                          prefixl_idForUndo:l_idForUndo,
                                          draggedNode:dropIndex.add[0],
                                          overNode:overNodeForUndo,
                                          word :5
                                    }
                                
                            }
                            functionFlow.push("handleDragWithCollapsedNode-singleRow-dragStartIndex end")
                            activeSpan.setAttribute("handleDragWithCollapsedNode-functionFlow", functionFlow);
                            resolve({dropIndex: dropIndex.add[0].rowIndex,undoInfo});
                        }, 500);
                    
                    }

                    setTimeout(() => {
                        childrenArray.forEach((node) => {
                            if (nodeStateMap.has(node.id)) {
                                const shouldExpand = nodeStateMap.get(node.id);
                                gridRef.current.api.setRowNodeExpanded(node, shouldExpand);
                            }
                        });
                          
    
                        // Resolve with the dropIndex after restoring states
                    }, 0);
                }
            }, 10);
        }
    });
};

  
export const handleWholeTreeShift = async (params) => {
    
    const activeSpan = trace.getSpan(context.active());
    let functionFlow = ["handleWholeTreeShift start"]
    const { fromIndex, currentSheetRows, prefixlid, gridRef, overIndex, setUndoStack, dragStartIndex, undoRows, direction,predecessorcolumn, overNodeId,l_idForUndo } = params;
    const childrenArray = getUniqueChildrenArray(currentSheetRows[fromIndex]);
    const totalChildrenCount = childrenArray?.filter(node => node.rowIndex !== null).length;
    const {loggedInUser} = xTablesStore.getState().gridReducer;
    const { changedRows, rowsBeforeDrag, noOfVisibleChildren, collapsedChildren } = changeOrderForAllChildren(fromIndex, currentSheetRows[fromIndex].data.id, currentSheetRows, prefixlid, childrenArray, loggedInUser);
    let node = gridRef.current.api.getRowNode(currentSheetRows[fromIndex].data.id);
    let totalParentsBeforeAndAfterDrag = getAllParentsOfANode(node);
    if(fromIndex === overIndex) return fromIndex;
    if(fromIndex === overIndex-1 && direction === "up") return fromIndex;
    let upperNodeCollapsed = false
    if(direction === "up") {
        upperNodeCollapsed = currentSheetRows[overIndex - 1] && currentSheetRows[overIndex - 1]?.expanded !== true && currentSheetRows[overIndex - 1]?.childrenAfterGroup.length !== 0
    }
    else {
        upperNodeCollapsed = currentSheetRows[overIndex] && currentSheetRows[overIndex]?.expanded !== true && currentSheetRows[overIndex]?.childrenAfterGroup.length !== 0
    }
    if (upperNodeCollapsed) {
        functionFlow.push("Upper node collapsed");
        //  this block of code is for sceanrio where dragging is in upward direction and the index over overDragIndex is collapsed  then source row index was coming wrong
        //   as it was collapsed so first the collapsed node is exapanded and then the transaaction is done to add the dragged node
        let {dropIndex,undoInfo} = await handleDragWithCollapsedNode({
            gridRef,
            currentSheetRows,
            overIndex,
            fromIndex,
            direction,
            undoRows,
            dragStartIndex,
            setUndoStack,
            getUniqueChildrenArray,
            isWholeTreeShift: true,
            changedRows,
            collapsedChildren,
            rowsBeforeDrag,
            totalParentsBeforeAndAfterDrag,
            predecessorcolumn,
            loggedInUser,
            overNodeId,
            l_idForUndo
        });

        logSpan(`handleWholeTreeShift-upperNodeCollapsed`, activeSpan.spanContext(),"INFO", formatUndoRowFordragFunc(undoInfo), dropIndex);
        functionFlow.push("handleWholeTreeShift end-upperNodeCollapsed")
        activeSpan.setAttribute("handleWholeTreeShift-functionFlow", functionFlow);
        if (currentSheetRows[fromIndex].expanded === false) {
            return { dropIndex, undoInfo, collapseDraggedNode: true };
        }
        else {
            return { dropIndex, undoInfo,collapseDraggedNode: false };
        }
    }
    else {
        let overIndexForTransaction = fromIndex > overIndex && direction === "up" ? overIndex : fromIndex > overIndex && direction === "down" ? overIndex + 1 : direction === "down" ? overIndex + 1 - totalChildrenCount : overIndex - totalChildrenCount;
        if (direction === null || direction === undefined) {
            if (fromIndex > overIndex) {
                overIndexForTransaction = overIndex;
            }
            else {
                overIndexForTransaction = overIndex - totalChildrenCount + 1;
            }
        }
        if (fromIndex === overIndex) {
            overIndexForTransaction = overIndex;
        }
        functionFlow.push(`overIndexForTransaction:${overIndexForTransaction} fromIndex:${fromIndex} overIndex:${overIndex} direction:${direction} totalChildrenCount:${totalChildrenCount}`)
        let undoInfo
        if (changedRows && overIndexForTransaction !== undefined) {
            gridRef?.current?.api?.applyTransaction({ remove: changedRows });
            let dropIndex = gridRef.current.api.applyTransaction({
                add: changedRows,
                addIndex: overIndexForTransaction,
            });
            let belowNodeId
            // calculate belowNode
            let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
            let droppedNodeIndex = dropIndex.add.reduce((acc, curr) => {
                return Math.max(acc, curr.sourceRowIndex);
            }, 0);
            if(droppedNodeIndex||droppedNodeIndex===0) {
                let nodeBelow = rowData[droppedNodeIndex + 1];
                belowNodeId= nodeBelow?.id||'none'
            };
            if (dropIndex.add[0].rowIndex) {
                let nodeToRefresh = gridRef.current.api.getRowNode(changedRows[0].id);
                gridRef.current.api.refreshCells({ rowNodes: [nodeToRefresh], force: true });}
                let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency(dropIndex.add, gridRef)
                allRowsIncludingRefinedOnes.forEach((row) => {
                    let node = gridRef.current.api.getRowNode(row.id);
                    let parents = getAllParentsOfANode(node);
                    parents.forEach((parentNode) => totalParentsBeforeAndAfterDrag.add(parentNode));
                });
    
                let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(allRowsIncludingRefinedOnes, gridRef, predecessorcolumn, totalParentsBeforeAndAfterDrag)
    
                if (mergedRowsAfterRollupAndPredecessorChange.length)
                    applyTransaction(gridRef, mergedRowsAfterRollupAndPredecessorChange, dropIndex.add[0].rowIndex);
                
                let undoRowsArray = []
            if (rowsBeforeDrag && rowsBeforeDrag.length > 0) undoRowsArray = [...rowsBeforeDrag]
            else undoRowsArray = undoRows;
            // Create a deep copy to prevent reference issues
            let undoRowsArrayforUpdate = JSON.parse(JSON.stringify(undoRowsArray));
            if (arrayOfAdditionalUndoRows?.length) {
                handleUndoRowUpdates(arrayOfAdditionalUndoRows, undoRowsArrayforUpdate, 'id');
            }
            if (additionalParentAndExtraRowsForUndo?.length) {
                handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowsArrayforUpdate, 'id');
            }
       
           
            if (dragStartIndex !== undefined) {
                  // Filter rows in undoRowsArrayforUpdate that are not in undoRowsArray
                  const undoRowsArrayforUpdateFiltered = filterRows(undoRowsArrayforUpdate, undoRowsArray);
                  // Update changedRows based on mergedRowsAfterRollupAndPredecessorChange
                  const updatedChangedRows = mapUpdatedRows(changedRows, mergedRowsAfterRollupAndPredecessorChange);
                  // Get rows in mergedRowsAfterRollupAndPredecessorChange not in changedRows
                  const remainingMergedRows = filterRows(mergedRowsAfterRollupAndPredecessorChange, changedRows);
                  let overNodeForUndo;

                  if (direction === "down") {
                    if (currentSheetRows[fromIndex + totalChildrenCount]) {
                      overNodeForUndo = currentSheetRows[fromIndex + totalChildrenCount];
                    } else {
                      overNodeForUndo = currentSheetRows[fromIndex - 1];
                    }
                  } else {
                    if (currentSheetRows[fromIndex - 1]) {
                      overNodeForUndo = currentSheetRows[fromIndex - 1];
                    } else {
                      overNodeForUndo = currentSheetRows[fromIndex + totalChildrenCount];
                    }
                  }
                  ``
                  
                let finalDirection = direction === "down"
                    ? (currentSheetRows[fromIndex + totalChildrenCount] ? direction : "up")
                    : (currentSheetRows[fromIndex - 1] ? direction : "down");

                  if (currentSheetRows[fromIndex - 1]  && currentSheetRows[fromIndex - 1].expanded !== true && currentSheetRows[fromIndex - 1].childrenAfterGroup.length !== 0) {
                    // this code to handle redo action if above node is collapsed 
                    let childrenArray = [];
                    // overnode to be handled seprately for up and down direction for undo . for up direction, overnode will be below node of dragged node  and for down direction , overnode will be above node of dragged node
                    // setTimeout(() => {
                        childrenArray = getUniqueChildrenArray(currentSheetRows[fromIndex - 1]);
                        undoInfo = { type: "row", action: "drag",overNodeId,direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex + childrenArray.length - 1, overIndex: (dropIndex.add[0].rowIndex !== null ? dropIndex.add[0].rowIndex : overIndexForTransaction) + (fromIndex < overIndex ? childrenArray.length - 1 : 0),  fromIndexAboveNode: currentSheetRows[fromIndex - 1],cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId,prefixl_idForUndo:l_idForUndo,  draggedNode:dropIndex.add[0],
                        overNode:overNodeForUndo,word:8};
                    // }, 500);

                }
                else {
                    // setTimeout(() => {
                        undoInfo = { type: "row", action: "drag",overNodeId,direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex, overIndex: dropIndex.add[0].rowIndex !== null ? dropIndex.add[0].rowIndex : overIndexForTransaction, cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId,prefixl_idForUndo:l_idForUndo ,  draggedNode:dropIndex.add[0],
                        overNode:overNodeForUndo,word:9};
                    // }, 500);
                }
                logSpan(`undoStack of tree drag operation`, activeSpan.spanContext(), "INFO", {...formatUndoRowFordragFunc(undoInfo), overNode: formatParentDataIntoOTelFormat(undoInfo?.overNode?.data)});
            }
            if (collapsedChildren?.length) {
                collapsedChildren.forEach((node) => {
                    gridRef.current.api.setRowNodeExpanded(gridRef.current.api.getModel().nodeManager.allNodesMap[node.id], false);
                });
            }
            functionFlow.push("handleWholeTreeShift end-overIndexForTransaction")
            activeSpan.setAttribute("handleWholeTreeShift-functionFlow", functionFlow);
            return {dropIndex:dropIndex.add[0].rowIndex,undoInfo};
        }
    }
    functionFlow.push("handleWholeTreeShift end")
    activeSpan.setAttribute("handleWholeTreeShift-functionFlow", functionFlow);
};

export const handleSingleRowShift = async (params) => {
    const activeSpan = trace.getSpan(context.active());
    let functionFlow = ["handleSingleRowShift start"]
    const { fromIndex, rowsToUpdate, prefixlid, gridRef, overIndex, setUndoStack, dragStartIndex, undoRows, direction, currentSheetRows,predecessorcolumn ,overNodeId,l_idForUndo} = params;
    let node = gridRef.current.api.getRowNode(rowsToUpdate[0].id);
    logSpan("handleSingleRowShift-node", activeSpan.spanContext(), "INFO",formatParentDataIntoOTelFormat(node.data)); 
    const {loggedInUser} = xTablesStore.getState().gridReducer;
    let totalParentsBeforeAndAfterDrag = getAllParentsOfANode(node);
    if(fromIndex === overIndex) return fromIndex;
    if(fromIndex === overIndex-1 && direction === "up") return fromIndex;
    let upperNodeCollapsed = false
    if(direction === "up") {
        upperNodeCollapsed = currentSheetRows[overIndex - 1] && currentSheetRows[overIndex - 1]?.expanded !== true && currentSheetRows[overIndex - 1]?.childrenAfterGroup.length !== 0
    }
    else {
        upperNodeCollapsed = currentSheetRows[overIndex] && currentSheetRows[overIndex]?.expanded !== true && currentSheetRows[overIndex]?.childrenAfterGroup.length !== 0
    }
    if (upperNodeCollapsed) {
        functionFlow.push("Upper node collapsed");
        //  this block of code is for sceanrio where dragging is in upward direction and the index over overDragIndex is collapsed  then source row index was coming wrong
        //   as it was collapsed so first the collapsed node is exapanded and then the transaaction is done to add the dragged node
        let {dropIndex,undoInfo} = await handleDragWithCollapsedNode({
            gridRef,
            currentSheetRows,
            overIndex,
            fromIndex,
            direction,
            undoRows,
            dragStartIndex,
            setUndoStack,
            getUniqueChildrenArray,
            isWholeTreeShift: false,
            rowsToUpdate: rowsToUpdate,
            prefixlid: prefixlid,
            totalParentsBeforeAndAfterDrag,
            predecessorcolumn,
            loggedInUser,
            overNodeId,
            l_idForUndo
        });
        
        logSpan(`handleSingleRowShift-upperNodeCollapsed`, activeSpan.spanContext(), "INFO",formatUndoRowFordragFunc(undoInfo), dropIndex);
        functionFlow.push("handleSingleRowShift end-upperNodeCollapsed") 
        activeSpan.setAttribute("handleSingleRowShift-functionFlow", functionFlow);
        return {dropIndex,undoInfo};
    }
    else {
        let undoInfo = []
        let overIndexForTransaction = fromIndex > overIndex && direction === "up" ? overIndex : fromIndex > overIndex && direction === "down" ? overIndex + 1 : direction === "up" ? overIndex - 1 : overIndex;
        if (direction === null || direction === undefined) {
            if (fromIndex > overIndex) {
                overIndexForTransaction = overIndex;
            }
            else {
                overIndexForTransaction = overIndex;
            }
        }
        if (fromIndex === overIndex) {
            overIndexForTransaction = overIndex;
        }
        functionFlow.push(`overIndexForTransaction:${overIndexForTransaction} fromIndex:${fromIndex} overIndex:${overIndex} direction:${direction}`)
        if (rowsToUpdate?.length && overIndexForTransaction !== undefined) {
            rowsToUpdate[0] = changeUpdatedDateOfRow(rowsToUpdate[0],loggedInUser);
            gridRef?.current?.api?.applyTransaction({ remove: [rowsToUpdate[0]] });
            let dropIndex = gridRef?.current?.api?.applyTransaction({
                add: [rowsToUpdate[0]],
                addIndex: prefixlid ? overIndexForTransaction : fromIndex < overIndex && direction === "up" ? overIndexForTransaction : overIndex,
            });
            let belowNodeId
            // calculate belowNode
            let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
            let droppedNodeIndex = dropIndex.add.reduce((acc, curr) => {
                return Math.max(acc, curr.sourceRowIndex);
            }, 0);
            if (droppedNodeIndex || (droppedNodeIndex == 0)) {
                let nodeBelow = rowData[droppedNodeIndex + 1];
                belowNodeId = nodeBelow?.id||'none'
            };

            if (dropIndex.add[0].rowIndex) {
                let nodeToRefresh = gridRef.current.api.getRowNode(rowsToUpdate[0].id);
                gridRef.current.api.refreshCells({ rowNodes: [nodeToRefresh], force: true });}
                let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency(dropIndex.add, gridRef)
                allRowsIncludingRefinedOnes.forEach((row) => {
                    let node = gridRef.current.api.getRowNode(row.id);
                    let parents = getAllParentsOfANode(node);
                    parents.forEach((parentNode) => totalParentsBeforeAndAfterDrag.add(parentNode));
                });
    
                let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(allRowsIncludingRefinedOnes, gridRef, predecessorcolumn, totalParentsBeforeAndAfterDrag)
    
                if (mergedRowsAfterRollupAndPredecessorChange.length)
                    applyTransaction(gridRef, mergedRowsAfterRollupAndPredecessorChange, dropIndex.add[0].rowIndex);
    
                let undoRowsArray = undoRows
                // Create a deep copy to prevent reference issues
                let undoRowsArrayforUpdate = JSON.parse(JSON.stringify(undoRowsArray));
                if (arrayOfAdditionalUndoRows?.length) {
                    handleUndoRowUpdates(arrayOfAdditionalUndoRows, undoRowsArrayforUpdate, 'id');
                }
                if (additionalParentAndExtraRowsForUndo?.length) {
                    handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowsArrayforUpdate, 'id');
                }
                // Filter rows in undoRowsArrayforUpdate that are not in undoRowsArray
                const undoRowsArrayforUpdateFiltered = filterRows(undoRowsArrayforUpdate, undoRowsArray);
                // Update changedRows based on mergedRowsAfterRollupAndPredecessorChange
                const updatedChangedRows = mapUpdatedRows([rowsToUpdate[0]], mergedRowsAfterRollupAndPredecessorChange);
                // Get rows in mergedRowsAfterRollupAndPredecessorChange not in changedRows
                const remainingMergedRows = filterRows(mergedRowsAfterRollupAndPredecessorChange, [rowsToUpdate[0]]);
                const childrenArray = getUniqueChildrenArray(currentSheetRows[fromIndex]);
                const totalChildrenCount = childrenArray?.filter(node => node.rowIndex !== null).length;
                let overNodeForUndo;

                if (direction === "down") {
                  const nextNode = currentSheetRows[fromIndex + 1 + totalChildrenCount];
                  if (nextNode) {
                    overNodeForUndo = nextNode;
                  } else {
                    overNodeForUndo = currentSheetRows[fromIndex - 1];
                  }
                } else {
                  const prevNode = currentSheetRows[fromIndex - 1];
                  if (prevNode) {
                    overNodeForUndo = prevNode;
                  } else {
                    overNodeForUndo = currentSheetRows[fromIndex + 1 + totalChildrenCount];
                  }
                }
                
            let finalDirection = direction === "down"
                ? (currentSheetRows[fromIndex + totalChildrenCount] ? direction : "up")
                : (currentSheetRows[fromIndex - 1] ? direction : "down");

                undoInfo = { type: "row", action: "drag",overNodeId,direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex, overIndex: dropIndex.add[0].rowIndex, cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId,prefixl_idForUndo:l_idForUndo, overNode:overNodeForUndo,draggedNode:dropIndex.add[0]};

                if (currentSheetRows[fromIndex - 1]  && currentSheetRows[fromIndex - 1].expanded !== true && currentSheetRows[fromIndex - 1].childrenAfterGroup.length !== 0) {
                let childrenArray = [];
                // setTimeout(() => {
                    childrenArray = getUniqueChildrenArray(currentSheetRows[fromIndex - 1]);
                    undoInfo = { type: "row", action: "drag",overNodeId,direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex + childrenArray.length - 1, overIndex: (dropIndex.add[0].rowIndex !== null ? dropIndex.add[0].rowIndex : overIndexForTransaction) + (fromIndex < overIndex ? childrenArray.length - 1 : 0), fromIndexAboveNode: currentSheetRows[fromIndex - 1],cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId,prefixl_idForUndo:l_idForUndo, overNode:overNodeForUndo, draggedNode:dropIndex.add[0] };
                    logSpan(`undoStack of single node drag operation-dropIndex`, activeSpan.spanContext(),"INFO",formatUndoRowFordragFunc(undoInfo), formatdropIndexInOutdent(dropIndex));  
                    functionFlow.push("handleSingleRowShift end-dropIndex") 
                    activeSpan.setAttribute("handleSingleRowShift-functionFlow", functionFlow);
                    return {dropIndex : dropIndex.add[0].rowIndex,undoInfo};
                // }, 500);

            }
            else if (dragStartIndex !== undefined) {
                undoInfo = { type: "row", action: "drag",overNodeId,direction:finalDirection, rowData: undoRowsArray, index: dragStartIndex, overIndex: dropIndex.add[0].rowIndex !== null ? dropIndex.add[0].rowIndex : overIndexForTransaction, cellRows: updatedChangedRows, previousRows: undoRowsArrayforUpdateFiltered, updatedRows: remainingMergedRows , belowNodeId,prefixl_idForUndo:l_idForUndo, overNode:overNodeForUndo, draggedNode:dropIndex.add[0] };
                logSpan(`undoStack of single node drag operation-dragStartIndex`, activeSpan.spanContext(),"INFO", formatUndoRowFordragFunc(undoInfo), formatdropIndexInOutdent(dropIndex)); 
                functionFlow.push("handleSingleRowShift end-dragStartIndex")
                activeSpan.setAttribute("handleSingleRowShift-functionFlow", functionFlow); 
                return {dropIndex : dropIndex.add[0].rowIndex,undoInfo};
            }
        }
    }
    functionFlow.push("handleSingleRowShift end") 
    activeSpan.setAttribute("handleSingleRowShift-functionFlow", functionFlow);
};
export function removeDuplicateKeepLast(arr) {
    let ArrayType = typeof arr
    if (ArrayType === 'string') arr = arr.split('.').filter((item)=>item!=="")
    let uniqueElements = {};
    let result = [];

    // Iterate through the array in reverse order
    for (let i = arr.length - 1; i >= 0; i--) {
        let element = arr[i];

        // If the element is not in the uniqueElements object, add it
        if (!uniqueElements.hasOwnProperty(element)) {
            uniqueElements[element] = true;
            result.unshift(element); // Add to the beginning of the result array
        }
    }
    if (ArrayType === 'string') result = result.join('.')
    return result;
}
export function makeTreeForPasting(startIndex, heirarchy, gridRef, span) {
    
    let functionFlow = ["makeTreeForPasting started"]
    const keys = Object.keys(heirarchy)
    .filter((key) => !isNaN(key)) 
    .map(Number)
    .sort((a, b) => a - b);
// to keep check of non continuous rows
  const isNonContinuous = keys.some(
    (key, i, arr) => i > 0 && key !== arr[i - 1] + 1
  );
  functionFlow.push(`Is data non-continuous: ${isNonContinuous}`);
  const correctLength = keys.length;
    //I am taking some assumptions here that you only copy full trees and paste in unindented cells
    let idReplacementObj = {}, fromIndex = -1, largestFromIndex = -1
    let rowData = gridRef.current?.api.getModel().rowsToDisplay, updatedRows = []
    let ids = {}
    let old_L_ids = { ...heirarchy }, idArray = []
    console.log("OLD L_Ids", old_L_ids)
    //stoing all ids to check if the tree copied is not a child and if it is remove the parent's id in the next loop
    functionFlow.push("Starting ID processing");
    heirarchy.forEach((l_id, index) => {
        let temp = l_id.split('.')
        ids[temp[temp.length - 1]] = true
    })

    //case where if I paste the tree inside another tree
    // let firstElement=rowData[startIndex]
    // if(firstElement.l_id.includes('.')){

    // }
    //iterating over new all rows having l_id
    let currIteration = 0
    heirarchy.forEach((l_id, index) => {
        if (fromIndex === -1) fromIndex = index
        largestFromIndex = Math.max(largestFromIndex, index)
        let newl_id = []
        let temp = l_id.split('.')
        // exchanging old id's with new ones as id's need to be unique across sheets
        temp.forEach((id) => {
            if (!idReplacementObj[id] && ids[id]) {
                let newid = rowData[startIndex + currIteration].id
                idReplacementObj[id] = newid
                id = newid
                newl_id.push(id)
            }
            else if (ids[id]) {
                id = idReplacementObj[id]
                newl_id.push(id)
            }

        })
        idArray[index] = newl_id[newl_id.length - 1]
        l_id = newl_id.join('.')
        heirarchy[index] = newl_id.join('.')
        currIteration += 1
    })
    let count = startIndex;
    console.log("New L_ids", heirarchy)
    functionFlow.push(`New hierarchy after ID replacement`);
    //Iterating over all rows starting from fromIndex to update their l_ids
    for (let i = startIndex; i <= startIndex + largestFromIndex - fromIndex; i++) {
        if (rowData[i].data) {
            if(rowData[i].data.l_id.includes('.')) {
                functionFlow.push(`Row ${i} has nested l_id, resetting updatedRows`);
                updatedRows=[];
                break
            }
            else if(rowData[count].childrenAfterGroup?.length>0 && !rowData[count].data.l_id.includes('.')) {
                functionFlow.push(`Row ${count} is top parent, clearing updatedRows`);
                updatedRows=[]; // for top most parent node 
            }
            else if(heirarchy[fromIndex + i - startIndex]){
                rowData[count].data.l_id = heirarchy[fromIndex + i - startIndex]
                updatedRows.push(rowData[count].data);count++;
            }
        }

    }
    if(updatedRows.length > 0) {
    let lastEle = isNonContinuous?rowData[startIndex + correctLength-1].data:rowData[startIndex + largestFromIndex - fromIndex].data
    let lastIndex = isNonContinuous?startIndex + correctLength:startIndex + largestFromIndex - fromIndex + 1
    console.log("lastEle", lastEle, startIndex, largestFromIndex, fromIndex, rowData[lastIndex]?.data)
    functionFlow.push(`Starting expansion from lastIndex: ${lastIndex}, lastEle.id: ${lastEle.id}`);
    let alreadyTraversed = {}
    while (rowData[lastIndex] && rowData[lastIndex].data && rowData[lastIndex].data.l_id.includes(lastEle.id)) {
        alreadyTraversed[rowData[lastIndex].data.id] = true
        console.log("immediate row after tree old l_id,", rowData[lastIndex].data.l_id)
        let currentl_id = rowData[lastIndex].data.l_id.split('.')
        let pIdx = currentl_id.indexOf(lastEle.id)
        currentl_id = lastEle.l_id + '.' + currentl_id.slice(pIdx + 1).join('.')
        rowData[lastIndex].data.l_id = currentl_id
        updatedRows.push(rowData[lastIndex].data)
        functionFlow.push(`Updated l_id at index ${lastIndex}: ${currentl_id}`);
        lastIndex += 1
        console.log("immediate row after tree new l_id,", currentl_id)
    }
    while (rowData[lastIndex] && rowData[lastIndex].data && !alreadyTraversed[rowData[lastIndex].data.id]) {
        let ids = rowData[lastIndex].data.l_id.split('.')
        if (ids.length <= 1) break;
        let parent = ids[ids.length - 2]
        if (idArray.indexOf(parent) > -1) {
            rowData[lastIndex].data.l_id = heirarchy[idArray.indexOf(parent)] + '.' + rowData[lastIndex].data.id
            updatedRows.push(rowData[lastIndex].data)
            idArray.push(rowData[lastIndex].data.id)
            heirarchy.push(rowData[lastIndex].data.l_id)
            functionFlow.push(`Relinked orphan node at index ${lastIndex}: ${rowData[lastIndex].data.l_id}`);
            lastIndex += 1
        }
        else break;
    }
    logSpan('makeTreeForPasting-updatedRows', span.setAttribute(), "INFO", formatArrayforLogs(updatedRows));
    gridRef?.current?.api?.applyTransaction({
        update: updatedRows,
        addIndex: startIndex,
    });
    functionFlow.push(`Updated ${updatedRows.length} rows. Triggering redraw.`);
    setTimeout(() => gridRef.current.api.redrawRows(), 50)
}
span.setAttribute("makeTreeForPasting-functionFlow", functionFlow);
}
export const formatSelectedNodesToExcludeChildIfParentIsPresent = (selectedNodes) => {
    let l_idList = {}
    selectedNodes.forEach((node) => {
        l_idList[node.data.id] = true;
    })
    let newNodeList = []
    selectedNodes.forEach((node) => {
        let parent = node.data.l_id.split('.').slice(0, -1)
        let toBeIncluded = true
        for (let i = 0; i < parent.length; i++) {
            if (l_idList[parent[i]]) toBeIncluded = false;
        }
        if (toBeIncluded) newNodeList.push(node)
    })
    return newNodeList;
}
export const makeRowsForDB = (gridRef, columnDefs) => {
    if (!gridRef.current) return []
    let filters = gridRef.current.api.getFilterModel()
    // if(filters && Object.keys(filters).length){
    let displayedRows = []
    gridRef.current.api.forEachNode((row) => {
        let data = { ...row.data }
        const processColumnDefs = (data, columnDefs) => {
            if (columnDefs && columnDefs.length) {
                columnDefs.forEach((col) => {
                    if(col?.field){
                        // Clone the column data to avoid direct mutation
                        let celldata = data[col.field] ? JSON.parse(JSON.stringify(data[col.field])) : data[col.field]
                        if (celldata) {
                            data[col.field + '_es'] = updateOrCreateObject(data[col.field + '_es'], "value", celldata?.toString())
                        }
                        // Remove the original field after processing
                        if (data[col.field]) delete data[col.field]
                     }   
                     // Recursively process children columns if they exist
                        if (col?.children && col?.children?.length) {
                            processColumnDefs(data, col.children)
                        }
                })
            }
        }
        // Call the recursive function for the current row
        processColumnDefs(data, columnDefs)
        delete data['primaryCol']
        if (data && Object.keys(data).length) displayedRows.push(data)
    })
    return displayedRows
    // }
    // else{
    //     let displayedRows= []
    //     gridRef.current?.api.getModel().rowsToDisplay?.forEach((row)=>{
    //         let data={...row.data}
    //         if(columnDefs && columnDefs.length){
    //             columnDefs.forEach((col)=>{
    //                 if(data[col.field]) delete data[col.field]
    //             })
    //         }
    //         delete data['primaryCol']
    //         if(data && Object.keys(data).length) displayedRows.push(data)
    //     })
    //     return displayedRows
    // }
}
export const SaveRows = (sendClientRowsToDB, selectedSheetId) => {
    //not used
    let storage = localStorage.getItem(selectedSheetId)
    if (storage) storage = JSON.parse(storage)
    if (storage && storage.modified === true && storage.rows && storage.rows.length) {
        sendClientRowsToDB(storage.rows, selectedSheetId)
        localStorage.setItem(selectedSheetId, JSON.stringify({ rows: storage.rows, modified: false }))
    }
}

export const saveUpdateStatusListInStore = (statusList , sharedLists , setSharedListsInStore ) => {
    const newStatusList = statusList;
    let copyOfSharedLists = [...sharedLists]
    let statusListIndex = copyOfSharedLists.findIndex(list => list.name === newStatusList.name);
    if (statusListIndex !== -1) {
        copyOfSharedLists[statusListIndex] = newStatusList;
        setSharedListsInStore(copyOfSharedLists)
    } else {
        copyOfSharedLists.push(newStatusList);
        setSharedListsInStore(copyOfSharedLists)
    }
}

export const addMultipleRowsHelper = (insertRow, noOfRowsToAdd, prefixlid) => {
    let firstRowid = uuidv4()
    let newRows = []
    let indentedL_id = "";
    if (prefixlid) {
        indentedL_id = prefixlid + '.' + firstRowid
    }
    const {loggedInUser} = xTablesStore.getState().gridReducer;
    insertRow( { l_id: prefixlid ? indentedL_id : firstRowid }, (content) => {
        let body = { ...content, id: firstRowid, l_id: prefixlid ? indentedL_id : firstRowid }
        newRows = [body]
        let rowCount = noOfRowsToAdd ? noOfRowsToAdd - 1 : 49
        for (let i = 0; i < rowCount; i++) {
            let rowId = uuidv4()
            let indLid = '';
            if (prefixlid) {
                indLid = prefixlid + '.' + rowId
            }
            let body = { ...content, id: rowId, l_id: prefixlid ? indLid : rowId }
            body = changeUpdatedDateOfRow(body,loggedInUser)
            newRows.push(body)
        }

    })
    return newRows
}
export const addMultipleRowsWithContentHelper = ( rowsContent) => {
    let newRows = []
    const {loggedInUser} = xTablesStore.getState().gridReducer;
        for (let i = 0; i < rowsContent.length; i++) {
            let body = { ...rowsContent[i] }
            body = changeUpdatedDateOfRow(body,loggedInUser)
            newRows.push(body)
        }

    return newRows
}
export const addMultipleRowsToGrid = (gridRef, index, insertRow, noOfRowsToAdd) =>dispatch=> {
    let newRows = addMultipleRowsHelper(insertRow, noOfRowsToAdd)
    if (newRows && newRows.length) {
        gridRef?.current?.api?.applyTransaction({
            add: [...newRows],
            addIndex: index + 1
        })
        dispatch(categorizeAndStoreUpdatedRows({add:{addedRows:newRows ,belowNodeId:'none'}},gridRef))
    }

}
const extractALinkedColumnSeries=(column)=>{
    let startCol,endCol,durationCol,predecessorStartCol,predecessorEndCol,predecessorCol
    if(column.type==='duration'){
        startCol=column.linkedColumns.startDate
        endCol=column.linkedColumns.endDate
        durationCol=column.field
    }
    else  if(column.type==='predecessor'){
        predecessorStartCol=column.linkedColumns.predecessorStartDate
        predecessorEndCol=column.linkedColumns.predecessorEndDate
        predecessorCol=column.field
    }
    else if(column.type==='date' && column.linkedColumns && column.linkedColumns.endDate){
        startCol=column.field
        endCol=column.linkedColumns.endDate
        durationCol=column.linkedColumns.duration
    }
    else if(column.type==='date' && column.linkedColumns && column.linkedColumns.startDate){
        startCol=column.linkedColumns.startDate
        endCol=column.field
        durationCol=column.linkedColumns.duration
    }
    else if(column.type==='date' && column.linkedColumns && column.linkedColumns.predecessorEndDate){
        predecessorStartCol=column.field
        predecessorEndCol=column.linkedColumns.predecessorEndDate
        predecessorCol=column.linkedColumns.predecessor
    }
    else if(column.type==='date' && column.linkedColumns && column.linkedColumns.predecessorStartDate){
        predecessorStartCol=column.linkedColumns.predecessorStartDate
        predecessorEndCol=column.field
        predecessorCol=column.linkedColumns.predecessor
    }
    return {startCol,endCol,durationCol,predecessorStartCol,predecessorEndCol,predecessorCol}
}
const processPasteCalls = (pasteCalls, rows, undoRows, changedPredecessorRows, dateRollupColumns,rollupColumns) => {
    let predecessorColumn;
    let statusColumns=[];
    let isChangeDoneToLinkedColumn = false;
    let isTimeSeriesColumnPresent= false

    if (pasteCalls && (pasteCalls.length)) {
        pasteCalls.forEach(({ row, undoRow }) => {
            if (row) {
                const deepCopy = (obj) => JSON.parse(JSON.stringify(obj));
                if (rows[row.id]) {
                    // Merge row properties, but skip properties where updatedDate matches new Date()
                    Object.keys(row).forEach((key) => {
                        if (
                            key.endsWith('_es') && 
                            rows[row.id][key]?.updatedDate &&
                            (new Date(rows[row.id][key].updatedDate).getMinutes() === new Date().getMinutes()) 
                        ) {
                            
                            // Skip this key to preserve the existing value
                            return;
                        }
                        // Otherwise, merge this key
                        rows[row.id][key] = row[key];
                    });
                } else {
                    // If the row doesn't exist, directly add it
                    rows[row.id] = deepCopy(row);
                }
                if (undoRows[undoRow.id] && undoRow?.column?.field) {
                    undoRows[undoRow.id] = { ...undoRows[undoRow.id], [undoRow.column.field]: undoRow.value }
                }
                else {
                    undoRows[undoRow.id] = undoRow.rowData
                }
                if (undoRow.column.type === 'predecessor') {
                    changedPredecessorRows[row.id] = row[undoRow.column.field];
                    predecessorColumn = undoRow.column
                    rollupColumns.add(undoRow.column);
                }
                if(undoRow.column.block === 'timeseries') isTimeSeriesColumnPresent = undoRow.column
                if (undoRow.column.linkedColumns && Object.keys(undoRow.column.linkedColumns).length > 0) isChangeDoneToLinkedColumn = undoRow.column

                else if (undoRows[undoRow.id][undoRow.column.field + '_es']) {
                    undoRows[undoRow.id][undoRow.column.field + '_es'].value = undoRow.value
                }
                else undoRows[undoRow.id][undoRow.column.field + '_es'] = { value: undoRow.value }
            }
            // Add date columns with rollup logic to the Set
            if (
               ( undoRow.column.type === 'date' &&
                ['Min', 'Max'].includes(undoRow.column?.rollup))||( undoRow.column.type === 'duration')
            ) {
                dateRollupColumns.add(undoRow.column); // Add unique fields to the Set
                rollupColumns.add(undoRow.column)
            }
            // if(undoRow.column?.rollup) rollupColumns.add(undoRow.column);
            else if(undoRow.column?.block === 'timeseries' || (undoRow.column.type ==='number'&&  ['Min', 'Max','Avg','Sum'].includes(undoRow.column?.rollup)) || (undoRow.column.type ==='multi dimensional value') && checkIfRollupEnabledInMDV(undoRow.column?.listData)) rollupColumns.add(undoRow.column);
            else if(undoRow.column?.status || undoRow.column.type ==="shareableRollupList"){
                statusColumns.push(undoRow.column)
                const statusRollupInfo = xTablesStore.getState().gridReducer.statusColumnRollupInfo
                rollupColumns.add({...undoRow.column,statusRollupInfo:statusRollupInfo});
            }
        })
    }
    return { predecessorColumn, isChangeDoneToLinkedColumn,isTimeSeriesColumnPresent ,statusColumns};
};
const processValueGetterCalls = (valueGetterCalls, rows, undoRows, dateRollupColumns,rollupColumns) => {
    if (valueGetterCalls && valueGetterCalls.length) {
        // isChangeDoneToLinkedColumn=false
        valueGetterCalls.forEach(({ row, undoRow, childrenParentnode }) => {
            if (rows[row.id]) rows[row.id] = { ...rows[row.id], ...row }
            else rows[row.id] = { ...row }
            if (undoRows[undoRow.id]) {
                undoRows[undoRow.id] = { ...undoRows[undoRow.id], [undoRow.column.field]: undoRow.value }
            }
            else {
                undoRows[undoRow.id] = undoRow.rowData
            }
            // Add date columns with rollup logic to the Set
            if (
                undoRow.column.type === 'date' &&
                ['Min', 'Max'].includes(undoRow.column?.rollup)
            ) {
                dateRollupColumns.add(undoRow.column); // Add unique fields to the Set
                rollupColumns.add(undoRow.column)
            }
            // if(undoRow.column?.rollup) rollupColumns.add(undoRow.column);
            else if(undoRow.column?.block === 'timeseries') rollupColumns.add(undoRow.column);
        })
    }
};
export const findLinkedColumns = (dateRollupColumns, gridRef) => {
    // Initialize allLinkedColumn as a shallow copy of dateRollupColumns (it will not modify the original)
    let allLinkedColumn = [...dateRollupColumns].filter(column => 
            column.type !== 'predecessor' && column.type !== 'duration'
        )
    
    let visitedFields = new Set();
    dateRollupColumns.forEach(column => {
        if (!column.linkedColumns) {
            return null;
        }
        else {
            // Iterate over all linked fields in the current dateRollupColumn
            Object.entries(column.linkedColumns).forEach(([key, linkedField]) => {
                if (visitedFields.has(linkedField)) {
                    return;
                }
                visitedFields.add(linkedField);
                // Find the linked column in the list of columns
                const linkedColumn = findColumnUsingParamsOrGridRef(gridRef.current, 'date', linkedField)
                if (linkedColumn) {
                    if (!allLinkedColumn.some(col => col.field === linkedColumn.field)) {
                        // Add the linked column to allLinkedColumn
                        allLinkedColumn.push(linkedColumn);
                    }
                }

            })
        }
    })
    return new Set(allLinkedColumn);
};

export const groupPasteCallsByRow = (cellValueCallbackArray, gridRef,loggedInUser) => {
    const span = tracer.startSpan('groupPasteCallsByRow');
    let functionFlow = ["groupPasteCallsByRow started"];
    let rows = {}
    let storedFormatInfo = getCellFormatStyle();
    let pasteCalls = cellValueCallbackArray.current.calls
    let valueGetterCalls = cellValueCallbackArray.current.valueGetterChangedCalls
    let undoRows = {}, isChangeDoneToLinkedColumn
    let changedPredecessorRows = {}
    let predecessorColumn, dateRollupColumns = new Set();
    let rollupColumns = new Set();
    // Process pasteCalls
    const { predecessorColumn: pcFromPasteCalls, isChangeDoneToLinkedColumn: linkedColumnChange,isTimeSeriesColumnPresent:isTimeSeriesPresent ,statusColumns} =
        processPasteCalls(pasteCalls, rows, undoRows, changedPredecessorRows, dateRollupColumns,rollupColumns);
    predecessorColumn = pcFromPasteCalls || predecessorColumn;
    isChangeDoneToLinkedColumn = linkedColumnChange || isChangeDoneToLinkedColumn;
    functionFlow.push("Processed paste calls");
    // Process valueGetterCalls
    processValueGetterCalls(valueGetterCalls, rows, undoRows, dateRollupColumns,rollupColumns);
    functionFlow.push("Processed valueGetterChanged calls");
    let updatedRows = []
    let undoRowsArray = []
    let { startCol, endCol, durationCol } = isChangeDoneToLinkedColumn ? extractALinkedColumnSeries(isChangeDoneToLinkedColumn) : {}
    const extractUniqueColumns = (formatStyleArray) => {
        const columns = formatStyleArray?.map(style => style.column);
        return [...new Set(columns)];  // Removing duplicates
    };

    // Function to check if rowData contains a specific column
    const checkRowContainsColumn = (rowDataObj, column) => {
        return rowDataObj.hasOwnProperty(column);
    };
    let formatIndex = 0; // To keep track of the current storedFormatInfo object
    const api = gridRef?.current?.api;
    const rowNode = api?.getDisplayedRowAtIndex(0);
    if (rowNode) {
        const filterFormatStyleByRowData = (formatStyleArray, rowDataArray) => {
            const uniqueColumns = extractUniqueColumns(formatStyleArray);
            const columnsInAllRows = uniqueColumns?.filter(column =>
                Object.values(rowDataArray).every(row => checkRowContainsColumn(row, column))
            );
            return formatStyleArray?.filter(style => columnsInAllRows.includes(style.column));
        };
        // Filter the formatStyle array
        storedFormatInfo = filterFormatStyleByRowData(storedFormatInfo, rows);
        logSpan('groupPasteCallsByRow-initialRows', span.spanContext(), "INFO", formatPasteRowObjectMap(rows));
        logSpan('groupPasteCallsByRow-storedFormatInfo', span.spanContext(), "INFO", storedFormatInfo);
        functionFlow.push("Filtered stored format info");
    }
    for (let key in rows) {
        if (rows.hasOwnProperty(key)) {
            let row = rows[key];
            for (let columnKey in row) {
                if (row.hasOwnProperty(columnKey) && columnKey !== "#_es") {
                    if (formatIndex < storedFormatInfo?.length) {
                        let formatInfo = storedFormatInfo?.[formatIndex];
                        if (formatInfo?.column + "_es" === columnKey) {

                            // Parse the cellStyle string to an object
                            if (formatInfo.cellStyle) {
                                try {
                                    formatInfo.cellStyle = JSON.parse(formatInfo.cellStyle);
                                } catch (e) {
                                    console.error("Invalid cellStyle JSON string:", formatInfo.cellStyle, e);
                                    formatInfo.cellStyle = {};
                                }
                            } else {
                                formatInfo.cellStyle = {};
                            }

                            // Assign the format and cellStyle to the row's column
                            row[columnKey].format = formatInfo.format;
                            row[columnKey].cellStyle = formatInfo.cellStyle;
                            formatIndex++;

                        }
                    } else {
                        break;
                    }
                }
            }
            
        }
    }
    logSpan('groupPasteCallsByRow-rows', span.spanContext(), "INFO", formatPasteRowObjectMap(rows));
    Object.keys(rows).forEach((id) => {
        if (isChangeDoneToLinkedColumn) {
            if (startCol && endCol && durationCol) {
                if (undoRows[id]) {
                    undoRows[id] = { ...undoRows[id] }
                }
                else if (undoRows[id] && undoRows.column.type === 'predecessor' && undoRows.rowData['predecessorNodes'] != '' && undoRows.value === '') {
                    undoRows[id] = { ...undoRows[undoRows.id], [undoRows.column.field]: undoRows.rowData['predecessorNodes'] }
                }
                else {
                    undoRows[id] = { ...rows[id] }
                }

                rows[id] = changeWholeRowAfterPasting(rows[id][startCol], rows[id][endCol], rows[id][durationCol], rows[id], startCol, endCol, durationCol, "true",loggedInUser)
            
            }
        }

        if(isTimeSeriesPresent){
            let colStateObj = makeColStateObj(gridRef.current.api.getColumnState());
            let focusedColumn = gridRef.current.api.getAllDisplayedColumns();
            let timeSeriesColumn = focusedColumn.find(function (colDef) {
                return colDef.colId === colStateObj[isTimeSeriesPresent.colId].colId;
            });
            let dummyParams ={node:gridRef.current.api.getRowNode(id),colDef:timeSeriesColumn}
            const totalColumnFromTimeSeries = getTotalColumn(gridRef.current)
                let {rowUpdatedWithTotal} = updateTotalIfValueIsChanged(totalColumnFromTimeSeries.timeSeriesColumn,totalColumnFromTimeSeries.totalColumn,dummyParams.colDef,rows[id],timeSeriesColumn)
                rows[id] = rowUpdatedWithTotal
        }
        updatedRows.push(rows[id])
    })
    functionFlow.push(`Updated ${updatedRows.length} rows`);
    let firstRowIndex = undoRowsArray[0] ? gridRef.current.api.getRowNode(undoRowsArray[0].id)?.rowIndex : -1
    logSpan('groupPasteCallsByRow-firstRowIndex', span.spanContext(), "INFO", firstRowIndex);

    Object.keys(undoRows).forEach((id) => {
        undoRowsArray.push(undoRows[id])
    })
    logSpan('groupPasteCallsByRow-applyTransaction', span.spanContext(),"INFO", formatArrayforLogs(updatedRows));
    let transitionedRows = gridRef.current?.api?.applyTransaction({
        update: updatedRows,
        addIndex: firstRowIndex
    })
    functionFlow.push("Applied transaction for initial updates");
    let {highlight} = xTablesStore.getState().gridReducer
    if(highlight){
        setTimeout(() => {
            gridRef.current.api.redrawRows();
        }, 0);
    }
    let rowsUpdatedAfterPredFunc = []
    //predecessor logic
    if (Object.keys(changedPredecessorRows).length && predecessorColumn) {
        functionFlow.push("predecessorColumn");
        let { rowsToUpdate, undoRowsBeforePredecessorsChange } = removeExistingPredecessorsAndApplyNewOnes(changedPredecessorRows, gridRef, transitionedRows.update, { colDef: predecessorColumn }, predecessorColumn.linkedColumns.predecessorStartDate, predecessorColumn.linkedColumns.predecessorEndDate)
        let refinePredecessorNodesInRows = rowsToUpdate;
        handleUndoRowUpdates(undoRowsBeforePredecessorsChange, undoRowsArray, 'id');
        functionFlow.push("handleUndoRowUpdates called");
        let rowsReadyForPredecessorValidation = gridRef.current.api.applyTransaction({
            update: refinePredecessorNodesInRows,
            addIndex: firstRowIndex
        })
        rowsUpdatedAfterPredFunc = JSON.parse(JSON.stringify(refinePredecessorNodesInRows))
        let rowsForPredecessorValidation = deepCopy(rowsReadyForPredecessorValidation.update)
        let { rowsRefinedWithPredecessorChanges, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows } = checkNodesForCircularDependency(rowsForPredecessorValidation, gridRef)

        if (rowsRefinedWithPredecessorChanges.length) {
            transitionedRows = gridRef.current?.api?.applyTransaction({
                update: rowsRefinedWithPredecessorChanges,
                addIndex: firstRowIndex
            })
            rowsUpdatedAfterPredFunc = allRowsIncludingRefinedOnes
        }
        if (arrayOfAdditionalUndoRows?.length) undoRowsArray = undoRowsArray.concat(arrayOfAdditionalUndoRows);
        functionFlow.push("Processed predecessor relationships");
    }
    // rollup logic
    let mergedRowsAfterRollupAndPredecessorChange = []; // Initialize with a default value
    let additionalParentAndExtraRowsForUndo = []; // Also initialize this variable
    let parentRowsAffectedByRollup = [];
    rollupColumns = findLinkedColumns(rollupColumns, gridRef);
    if (rollupColumns.size) {
        const rows = transitionedRows.update.map(node => node.data);
        if (rowsUpdatedAfterPredFunc.length) {
            handleUndoRowUpdates(rows, rowsUpdatedAfterPredFunc, 'id');
        }
        // If rowsUpdatedAfterPredFunc is not present or has no length, assign it to rows
        rowsUpdatedAfterPredFunc = rowsUpdatedAfterPredFunc.length ? rowsUpdatedAfterPredFunc : rows;
        const statusObject = statusColumns.reduce((acc, col) => {
            acc[col.columnElasticid] = col;
            return acc;
        }, {});
        rowsUpdatedAfterPredFunc.map((row) => {
                populateBacklogStatusColumnIfNeeded(row, 'primaryCol_es', true , statusObject, loggedInUser)
        })

        const result = parentRowsAferRollup(rowsUpdatedAfterPredFunc, gridRef, '', '', rollupColumns)
        parentRowsAffectedByRollup = result.parentRowsAffectedByRollup;
        additionalParentAndExtraRowsForUndo = result.additionalParentAndExtraRowsForUndo;
        mergedRowsAfterRollupAndPredecessorChange = result.mergedRowsAfterRollupAndPredecessorChange;

        if (mergedRowsAfterRollupAndPredecessorChange.length)
            applyTransaction(gridRef, mergedRowsAfterRollupAndPredecessorChange, firstRowIndex);
        if (additionalParentAndExtraRowsForUndo?.length) {
            handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowsArray, 'id');
        }
        functionFlow.push("Processed rollup columns and updated parent rows");
    }
    logSpan('groupPasteCallsByRow-undoRowsArray-cellValueCallbackArray', span.spanContext(),"INFO", formatArrayforLogs(undoRowsArray), formatCellValueCallBackArray(cellValueCallbackArray));
    // if (isChangeDoneToLinkedColumn || cellValueCallbackArray?.current?.calls?.length > 0) gridRef.current.api.redrawRows()

    cellValueCallbackArray.current.calls = []
    cellValueCallbackArray.current.valueGetterChangedCalls = []
    span.setAttribute("groupPasteCallsByRow-functionFlow", functionFlow);
    span.end();
    return {
        undoRows: undoRowsArray, updatedRows: mergedRowsAfterRollupAndPredecessorChange.length > 0 ? mergedRowsAfterRollupAndPredecessorChange : updatedRows, firstRowIndex
    }
}
export const draggedOverIndexWhereChildIsPresent = (fromIndex, overIndex, rows, gridRef) => {
    let currIndex = fromIndex
    let overNode = rows[overIndex].data.id
    while (rows[currIndex] &&  rows[currIndex].data.l_id.includes(rows[fromIndex].data.id)) {
        currIndex++;
        if (rows[currIndex] && overNode === rows[currIndex].data.id) return true
        else if(!rows[overIndex]) break
    }
    return false
}
export const changeCellDataHelper = (gridRef, rowId, cell, col, rowData) => dispatch => {
    const { loggedInUser } = xTablesStore.getState().gridReducer;
    const rowNode = gridRef.current.api.getRowNode(rowId);
    //   rowNode.data=rowData
    if (!rowNode || !cell) return;

    // Clone the entire row data to avoid direct mutation
    const updatedRowData = { ...rowData };
    gridRef.current.api.applyTransaction({ update: [updatedRowData] });
    if (!updatedRowData[col]) {
        updatedRowData[col] = {};
        updatedRowData[col.replace(/_es$/, '')] = ''
    }

    Object.keys(cell).forEach((field) => {
        if (field === 'value') {
            updatedRowData[col] = updateCellValue(updatedRowData, col, 'value', cell[field], loggedInUser);
        } else {
            updatedRowData[col] = {
                ...updatedRowData[col],
                [field]: cell[field],
            };
        }
    });
    setTimeout(() => {
        gridRef.current.api.applyTransaction({ update: [updatedRowData] });
        // gridRef.current.api.refreshCells()
        gridRef.current.api.redrawRows();
        dispatch(categorizeAndStoreUpdatedRows({ update: [updatedRowData] }, gridRef));
    }, 10);
};

export const nextMultipleOf50 = (number) => {
    const remainder = number % 50;
    if (remainder === 0) {
        return number; // The input number is already a multiple of 50
    } else {
        return number + (50 - remainder);
    }
}
export function getTextWidth(text, fontSize) {
    const element = document.createElement('span');
    element.textContent = text;
    element.innerText = text
    element.style.fontSize = fontSize;
    element.style.display = 'inline-block';
    document.body.appendChild(element);
    const width = element.getBoundingClientRect().width;

    // Remove the temporary element from the DOM.
    document.body.removeChild(element);

    return width;

}
export const doeslidincludesId = (lid, id) => {
    if (lid.includes('.')) {
        let newl_id = lid.split('.')
        return newl_id[newl_id.length - 1] === id
    }
    else return id === lid
}
export const validatel_id = (lid, elementId, gridRef) => {
    if (!lid) return undefined;
    // This function validates all the parents present in the l_ids to check if they are present.
    let lidarray = lid.split('.')
    let id = lidarray[lidarray.length - 1]
    // if (id !== elementId) { console.log("lid doesn't have id", elementId, id); return undefined }
    let myEle = gridRef.current.api.getRowNode(id)
    let presentEle = lidarray.slice(0, -1)
    let stopExecution = false
    let isElementAlreadyPresent = gridRef.current.api.getRowNode(lid)
    if (isElementAlreadyPresent && isElementAlreadyPresent.id !== myEle.id) { console.log("Element already present", isElementAlreadyPresent, lid, myEle); return undefined } //case where element with same id is already present

    while (presentEle && presentEle.length) {
        let parentl_id = presentEle.join('.')
        let parentid = presentEle[presentEle.length - 1]
        let ele = gridRef.current.api.getRowNode(parentid)
        if (!ele) { stopExecution = true; console.log("ele does not exist", lid, id, ele); break; } //ele does not exist
        if (ele.data.l_id !== parentl_id) { stopExecution = true; console.log("ele lid does not matche", lid, id, ele, parentl_id); break; } //ele lid does not matche
        presentEle = presentEle.slice(0, -1)
    }
    if (!doeslidincludesId(lid, id)) { stopExecution = true; console.log("lid", lid, id); } //
    return lid
}
export const loadGridForSometime = (gridRef, setSelectedCellHelper) => {
    console.log("refresh called")
    gridRef.current.api.showLoadingOverlay()
    gridRef.current.api.redrawRows()
    setTimeout(() => {
        gridRef.current.api.clearFocusedCell();gridRef.current.api.deselectAll(),gridRef.current.api.clearRangeSelection()
        // gridRef.current.api.tabToPreviousCell()
        // gridRef.current.api.setFocusedCell(0, '#')
        //setGridkey((key)=>key+1)
        setSelectedCellHelper('')
        // gridRef.current.api.clearFocusedCell()
        gridRef.current.api.refreshCells()
        gridRef.current.api.hideOverlay()
    }, 3000)
}
function setCellFormatStyle(formatInfo) {
    localStorage.setItem('cellFormatStyle', JSON.stringify(formatInfo));
}
function getCellFormatStyle() {
    const formatInfo = localStorage.getItem('cellFormatStyle');
    return formatInfo ? JSON.parse(formatInfo) : null;
}
const transformPersonValue = (value) => {
    // Check if the value follows the pattern of a person column
    if (value.includes("Username:") && value.includes("User Email:") && value.includes("initials:")) {
        const [dataPart, ...rest] = value.split('⇔≈⊗'); 
        // Split the data part by commas and trim each part
        const entries = dataPart.split(',').map(entry => entry.trim());
        const personArray = [];
        
        // Iterate over the entries to extract and format person information
        for (let i = 0; i < entries.length; i += 3) {
            const usernamePart = entries[i]?.replace('Username:', '').trim();
            const emailPart = entries[i + 1]?.replace('User Email:', '').trim();
            const initialsPart = entries[i + 2]?.replace('initials:', '').trim();
            // Check if the extracted parts are valid
            if (usernamePart && emailPart && emailPart.includes('@')) {
                personArray.push({ username: usernamePart, email: emailPart, initials: initialsPart });
            }
        }
        // Return the formatted JSON string of the person array
        return JSON.stringify(personArray);
    }
    // If it's not a person-type value, return the original value
    return 'notValid';
};
function validatePastedTreeStructure(values) {
    let ismorethanoneindentpresent = false
    values.forEach((l_id, index) => {
        let temp = l_id?.split('.')
        if (temp.length > 2 && !ismorethanoneindentpresent) {
            ismorethanoneindentpresent = true
        }
    })
    // If more than one rootTreeId exists, that means multiple trees are being pasted
    return !ismorethanoneindentpresent;
}

const getProcessedValue = (rawValue, columnType ,secRowValue, columnInfo ) => {
    const avoidPattern = /⇔≈⊗⇔≈⊗/g;
    if (columnType === "date") {
        let updatedDate = processDate(rawValue?.split("⇔≈⊗")[0]);;

        // Validate date format in the first part
        const parsedDate = new Date(updatedDate);
        if (isNaN(parsedDate.getTime()) && updatedDate !== "") {
            updatedDate = 'notValid'; // Replace invalid date with empty string
        }

        return updatedDate;
    }
    
    if(columnType === "shareableRollupList"){
        
         let value = rawValue.replace(avoidPattern, '⇔≈⊗ ⇔≈⊗').replace(/⊗⇔≈/g, ",");
         value = value.split("⇔≈⊗");
        let { listData } = generateListDataForRollupStatus(JSON.parse(columnInfo.listData));
        const parsedValue = typeof value === 'string' && value[0].startsWith('{') ? parseNewValue(value[0]) : null;
        if (value && value[0] !== "") {
            let raw = value[0];
          let isRowIsNone=false
          let defaultStatus= columnInfo?.defaultItems? JSON.parse(columnInfo.defaultItems).value:'Backlog'
            if (typeof raw === "string") {
              try {
                const maybeParsed = JSON.parse(raw);
                if (maybeParsed && typeof maybeParsed === "object" && "value" in maybeParsed) {
                  // 🔁 Remove rowId and keep the rest
                  const { rowId, ...rest } = maybeParsed;
                  isRowIsNone = rowId==='None'?true:false;
                  raw = JSON.stringify(rest);
                }
              } catch {
                // Not JSON, continue with raw
                value[0] = JSON.stringify({ rowId: 'None', value: defaultStatus});
              }
            } else if (typeof raw === "object" && raw !== null && "value" in raw) {
              const { rowId, ...rest } = raw;
              isRowIsNone = rowId==='None'?true:false;
              raw = JSON.stringify(rest);
            }
          
            const parsed = parseNewValue(raw);
          if(isRowIsNone){
           
            if(parsed?.value===defaultStatus)
            value[0] = JSON.stringify({ rowId: 'None', value: defaultStatus});
        else
        value[0] = "";
          }
          else  if (parsed?.value) {
              value[0] = getMatchedValueObject(listData, parsed.value, "");
            } else {
              value[0] = JSON.stringify({ rowId: 'None', value: defaultStatus});
             
            }
          }
          
          
        const cleanedValue = value.join("⇔≈⊗");

        return cleanedValue||'notValid';
    }
    if (columnType === "person" || columnType === "Assignee") {
        let value = rawValue.replace(avoidPattern, '⇔≈⊗ ⇔≈⊗').replace(/⊗⇔≈/g, ",");
         value = value.split("⇔≈⊗");
         if(value[0] === ""){
            return "";
         }
      return transformPersonValue(rawValue);
    }

    if (columnType === "predecessor") {
      return rawValue?.split("⇔≈⊗")[0];
    }
    if(columnType === "dropdown" ||columnType === "dropdownsingle"){
        const DELIMITER = "⊗⇔≈";
        let value =  rawValue.replace( '⇔≈⊗ ⇔≈⊗');
        value = value.split("⇔≈⊗");
        value = value[0];
        const listData = columnInfo.listData;
        if (Array.isArray(listData) && listData.length > 0 && typeof rawValue === 'string' && value !=="") {
          const allowedValues = listData.map(item =>
            (typeof item === 'object' ? item.value : item).toLowerCase().trim()
          );
      
          if (rawValue.includes(DELIMITER) && columnType === "dropdown") {
            const pastedItems = value.split(DELIMITER).map(item => item.toLowerCase().trim());
            const allValid = pastedItems.every(item => allowedValues.includes(item));
            if (!allValid) {
              value = 'notValid';
            }
          } else {
            const normalizedValue = value.toLowerCase().trim();
            if (!allowedValues.includes(normalizedValue)) {
              value = 'notValid';
            }
          }
        }
        return value;
    }
    if (columnType === "multi dimensional value") {
        if (!rawValue || typeof rawValue !== "string") return rawValue;
    
        const delimiter = "⇔≈⊗";
    
        // normalize broken delimiter
        const normalized = rawValue.replace('⇔≈⊗ ⇔≈⊗', delimiter);
        const parts = normalized.split(delimiter);
    
        let mdvArray;
    
        try {
            const mdvString = isStringifiedArrayWithPropName(parts[0])
                ? parts[0]
                : null;

            // CASE 1: encoded MDV (internal cell copy — stringified JSON array)
            if (mdvString) {
                mdvArray = JSON.parse(mdvString);
            }
            // CASE 2: display-format MDV, e.g. "Name [n] [text]: Anish"
            else if (rawValue.includes("[") && rawValue.includes("]")) {
                mdvArray = parseDataString(rawValue);
            }
            else {
                if (parts[0] !== "") {
                    return 'notValid';
                }

                mdvArray = [];
            }
    
            // Validation
            for (const prop of mdvArray) {
                if (
                    (prop.propName === "Planned Time" ||
                     prop.propName === "Actual Time") &&
                    Number(prop.propValue) > 24
                ) {
                    renderAlert(
                        'Hours cannot exceed 24. Please enter a value between 0 and 24.',
                        'error'
                    );
                    return 'notValid';
                }
            }
    
            //  SUCCESS → return normalized string (NOT push)
            return mdvArray.length ?JSON.stringify(mdvArray) + delimiter + (parts[1] || ""):'';
    
        } catch (e) {
            console.error("MDV parse failed", e);
            return 'notValid';
        }
    }
    
    else if (columnType && columnType !== "dropdown") {
      return rawValue.replace(avoidPattern, '⇔≈⊗ ⇔≈⊗').replace(/⊗⇔≈/g, ",");
    } 
    else {
        let newValue = rawValue?.split("⇔≈⊗")[0]
        if (newValue && isStringifiedArrayWithPropName(newValue)) {
            return parseAndSortValues(newValue);
        } else if (newValue && containsRowId(newValue)) {
            return JSON.parse(newValue).value;
        } else if (typeof newValue === 'string' && newValue.startsWith('{')) {
            try {
                const parsedValue = JSON.parse(newValue);
                if (parsedValue && typeof parsedValue === 'object' && parsedValue.value) {
                    return parsedValue.value;
                } else {
                    return newValue;
                }
            } catch (error) {
                console.error("Invalid JSON format in handleDefaultPasteOrDelete:", newValue, error);
                return ''
            }
        }
        else {
            return newValue;
        }

    }
    return secRowValue;
};
function getColumnDetails(hasHashColumn, columnIndex, j, selectedCell, gridRef) {
    const targetColumnIndex = getColumn(selectedCell.column.colDef.field, gridRef);
    const columnInfo = hasHashColumn
        ? getColumnAtIndex(columnIndex, gridRef)
        : getColumnAtIndex(targetColumnIndex + j, gridRef);
    return {
        columnInfo,
        targetColumn: columnInfo?.field
    };
}
function handleTreePaste(tree, selectedCell, gridRef, setIsPasteComplete, sheetType, result, span) {
    setIsPasteComplete(true);
    const rowIndex = selectedCell.rowIndex;
    const validTree = validatePastedTreeStructure(tree);

    if (sheetType !== "rolluplist" || (sheetType === "rolluplist" && validTree)) {
        makeTreeForPasting(rowIndex, tree, gridRef, span);
    } else {
        setTimeout(() => {
            renderAlert("Only one indented hierarchy can be pasted in the status sheet.", 'error');
        }, 100);
        setIsPasteComplete(false);
        return [''];
    }

    setIsPasteComplete(false);
    return result;
}
function shouldHandleTree(selectedCell, tree) {
    return selectedCell && tree.length && selectedCell.column.colId === 'ag-Grid-AutoColumn';
}
const XS_FOOTER_REGEX = /— xSpaces \| ([\d-]+\s[\d:]+) —$/;
export function removeFooterRowIfPresent(data) {
    if (!Array.isArray(data) || data.length === 0) return data;

    const lastRow = data[data.length - 1];

    const isFooterRow =
        Array.isArray(lastRow) &&
        lastRow.some(
            cell =>
                typeof cell === "string" &&
                XS_FOOTER_REGEX.test(cell)
        );

    if (isFooterRow) {
        return data.slice(0, -1); // remove last row
    }

    return data;
}

export const pasteHelper = (params, gridRef, setIsPasteComplete, sheetType, span) => {
    let functionFlow = ["pasteHelper started"];
    let data = params.data;
    let result = [], tree = [];
    let selectedCell = gridRef.current.api.getFocusedCell();
    let startRowIndex = selectedCell.rowIndex;
    let targetPositions = [];
    for (var i = 0; i < data.length; i++) {
        let row = data[i];
        functionFlow.push(`Processing row ${i}`);
        let columnIndex = 0;  // Reset columnIndex for each row
        if (row.length > 6) {
            functionFlow.push("Row has more than 6 columns — showing warning alert");
            renderAlert("Initially, paste operation will apply to 5 columns. Paste again to apply to all columns.", "warning")
        }
        let resultchild = [];
        // Check if the copy data includes the `#` column (optional)
        const hasHashColumn = selectedCell.column.colDef.field === '#' && row.length > 0;
        let targetColumn, targetRowIndex
        targetRowIndex = startRowIndex + i;
        if (hasHashColumn) {
            functionFlow.push(`Row ${i}: Detected '#' column — handling separately`);
            // Handle the first `#` column separately if it exists
            targetRowIndex = startRowIndex + i;
            targetColumn = '#';  // First column is `#`
            let value = "";  // Always empty value for the `#` column
            resultchild.push(value);  // Add empty value for the `#` column to result
            targetPositions.push({
                rowIndex: targetRowIndex,
                column: targetColumn,
                value: value,
                format: "",    // Format for `#` can be empty
                cellStyle: ""  // Cell style for `#` can be empty
            });
            columnIndex++;  // Increment columnIndex since we've handled the first column
        }
        // Now handle all other columns inside the `j` loop
        for (let j = 0; j < row.length; j++) {
            functionFlow.push(`Row ${i}, Column ${j}: Getting column details`);
            // Access field and type
            const { columnInfo, targetColumn } = getColumnDetails(hasHashColumn, columnIndex, j, selectedCell, gridRef);
            const targetColumnType = columnInfo?.type;
            let value = getProcessedValue(data[i][j], targetColumnType,data[j],columnInfo);
            let text;
            if (value === 'notValid') {
              functionFlow.push(`Invalid value detected at Row ${i}, Col ${j}. Retaining old value.`);
              // Fallback to old value from grid
              const existingRowNode = gridRef?.current?.api?.getDisplayedRowAtIndex(targetRowIndex);
              const existingValue = existingRowNode?.data?.[targetColumn];
              text = !existingValue?"": typeof existingValue === 'string' ? existingValue.split("⇔≈⊗") : existingValue;
            } else {
              text = typeof value === 'string' ? value.split("⇔≈⊗") : value;
            }
            resultchild.push(text[0] || "");
            if (text[1] && j === 0) {
                let rowIndex = text[2];
                tree[rowIndex] = text[1];
            }
            let format = data[i][j]?.split("⇔≈⊗")[3];
            let cellStyle = data[i][j]?.split("⇔≈⊗")[4];
            targetPositions.push({
                rowIndex: targetRowIndex,
                column: targetColumn,
                value: value,
                format: format,
                cellStyle: cellStyle
            });
            columnIndex++;  // Increment columnIndex for the next column
        }
        result.push(resultchild);
    }
    functionFlow.push("Setting cell format styles");
    setCellFormatStyle(targetPositions);
    if (shouldHandleTree(selectedCell, tree)) {
        functionFlow.push("Tree paste detected — calling handleTreePaste");
        const treeResult = handleTreePaste(tree, selectedCell, gridRef, setIsPasteComplete, sheetType, result, span);
        functionFlow.push(`Tree paste completed — returning result ${JSON.stringify(treeResult)}`);
        functionFlow.push(`Tree paste completed — targetposition ${JSON.stringify(targetPositions)}`);
        span.setAttribute("pasteHelper-functionFlow", functionFlow);
        return treeResult;
    }
    functionFlow.push("Regular paste completed — returning result");
    span.setAttribute("pasteHelper-functionFlow", functionFlow);
    logSpan("pasteHelper-result", span.spanContext(), "INFO", result);
    return result;
};

// Helper function to get the column field at a specific index
const getColumnAtIndex = (index, gridRef) => {
    const allColumns = gridRef.current.api.getAllGridColumns();
    // Safeguard in case the index is out of range
    if (index < 0 || index >= allColumns.length) {
        return null;
    }
    const targetColumn = allColumns[index];
    // Return both field name and type in an object
    return targetColumn ? { field: targetColumn.colDef.field, type: targetColumn.colDef.type, ...(targetColumn.colDef.listData && { listData: targetColumn.colDef.listData })
} : null;
};
 
const getColumn = (startColumn, gridRef) => {
    // Get all columns from the grid
    const allColumns = gridRef.current.api.getAllGridColumns();
    // Find the index of the column where the field matches startColumn
    const columnIndex = allColumns.findIndex(col => col.colDef.field === startColumn);
    // Return the column index, or -1 if the column is not found
    return columnIndex !== -1 ? columnIndex : null;
};

export function marginAdjusterHelper(value) // function to set adjustment to margins based on zoom value
{
    if (value > 0.75 && value < 1.25) {
        return 2 - value
    }
    else if (value < 0.75 && value > 0.65) {
        return 2.15 - value
    }
    else if (value < 0.65 && value > 0.55) {
        return 2.3 - value
    }
    else if (value < 0.55) {
        return 2.5 - value
    }
    else if (value < 0.55) {
        return 2.5 - value
    }
    else if (value > 1.25 && value < 1.45) {
        return 2.1 - value
    }
    else if (value > 1.45 && value < 1.55) {
        return 2.17 - value
    }
}
export const checkIfSelectedCellisSame = (gridRef, selectedCell) => {
    let visibleSelectedCell = gridRef.current.api.getFocusedCell()
    let visibleRowIndex = visibleSelectedCell?.rowIndex ?? -1
    let actualRowIndex = selectedCell.rowIndex
    let visibleRowData = gridRef.current.api.getDisplayedRowAtIndex(visibleRowIndex)?.data
    // if (visibleRowIndex !== actualRowIndex || visibleRowData.primaryCol !== selectedCell.cellData.primaryCol) {
        let updatedSelectedCell = { rowIndex: visibleRowIndex, dbRowIndex: visibleRowIndex, sheetId: visibleRowData.sheet_id, rowId: visibleRowData.id, column: visibleSelectedCell.column.colDef, cellData: visibleRowData, cellDataForNotes: visibleRowData[visibleSelectedCell.column.colDef.colId + '_es'] }
        return updatedSelectedCell
    // }
    // return selectedCell

}
// I have to set focusedcell as selected cell


export const checkIfNodeIsParentInChildArray = (node) => {
    const childrenArray = getUniqueChildrenArray(node);
    for (let i = 1; i < childrenArray.length; i++) {
        if (childrenArray[i].data.l_id.includes(node.id)) {
            return true
        }
    }
    return false
}

export const isAnyNodeCollapsedHelper = (gridRef, selectedCell, selectedNodes = []) => {
    let isAnyNodeCollapsed = false;
    let visibleSelectedCell = checkIfSelectedCellisSame(gridRef, selectedCell)
    if (selectedNodes.length > 0) {
        let tempRange = gridRef.current.api.getCellRanges()
        let tempColumn = tempRange[0].columns[0]
        selectedNodes.forEach((node) => {
            let tempRowIndex = node.rowIndex
            let tempData = gridRef.current.api.getDisplayedRowAtIndex(tempRowIndex).data
            let visibleSelectedCell = { rowIndex: tempRowIndex, dbRowIndex: tempRowIndex, sheetId: tempData.sheet_id, rowId: tempData.id, column: tempColumn.colDef, cellData: tempData, cellDataForNotes: tempData[tempColumn.colDef.colId + '_es'] }
            const rowData = gridRef.current.api.getModel().rowsToDisplay;
            let l_id_VisibleSelectedCell = visibleSelectedCell.cellData.l_id
            let parent_id_array = l_id_VisibleSelectedCell.split(".")
            let parent_id = parent_id_array[parent_id_array.length - 2]
            let count = visibleSelectedCell.rowIndex
            let row = rowData[visibleSelectedCell.rowIndex];
            let childrenArray = getUniqueChildrenArray(row)
            const alreadyTraversed = []
            while (rowData[count].data.l_id.includes(parent_id)) {
                let rowNodetoExpand = rowData[count];
                if (!rowNodetoExpand.expanded) {
                    let allLeafChildren = getUniqueChildrenArray(rowData[count]);
                    if(allLeafChildren.length>1) childrenArray=[...childrenArray,...allLeafChildren.slice(1)];
                    isAnyNodeCollapsed = true;
                    gridRef.current.api.setRowNodeExpanded(rowNodetoExpand, true)
                    alreadyTraversed.push(rowNodetoExpand)
                }
                count++;
            }
            if (childrenArray && childrenArray.length > 1) {
                for (let currIndex = 0; currIndex < childrenArray.length; currIndex++) {
                    if (!alreadyTraversed[childrenArray[currIndex].data.id] && childrenArray[currIndex].data.l_id.includes(parent_id)) {
                        let rowNodetoExpand = childrenArray[currIndex];
                        gridRef.current.api.setRowNodeExpanded(rowNodetoExpand, true)
                    }
                }
            }

        })
        return isAnyNodeCollapsed
    }
    const rowData = gridRef.current.api.getModel().rowsToDisplay;
    let l_id_VisibleSelectedCell = visibleSelectedCell.cellData.l_id
    let parent_id_array = l_id_VisibleSelectedCell.split(".")
    let parent_id = parent_id_array[parent_id_array.length - 2]
    let count = visibleSelectedCell.rowIndex
    let row = rowData[visibleSelectedCell.rowIndex];
    let childrenArray = getUniqueChildrenArray(row)
    const alreadyTraversed = []
    while (rowData[count].data.l_id.includes(parent_id)) {
        let rowNodetoExpand = rowData[count];
        if (!rowNodetoExpand.expanded) {
            let allLeafChildren = getUniqueChildrenArray(rowData[count]);
            if(allLeafChildren.length>1) childrenArray=[...childrenArray,...allLeafChildren.slice(1)]
            isAnyNodeCollapsed = true;
            gridRef.current.api.setRowNodeExpanded(rowNodetoExpand, true)
            alreadyTraversed.push(rowNodetoExpand)
        }
        count++;
    }
    if (childrenArray && childrenArray.length > 1) {
        for (let currIndex = 0; currIndex < childrenArray.length; currIndex++) {
            if (!alreadyTraversed[childrenArray[currIndex].data.id] && childrenArray[currIndex].data.l_id.includes(parent_id)) {
                let rowNodetoExpand = childrenArray[currIndex];
                gridRef.current.api.setRowNodeExpanded(rowNodetoExpand, true)
            }
        }
    }
    return isAnyNodeCollapsed;
}
export function getParentValueAsPredecessor(node, col) {
    let childArray = node.childrenAfterAggFilter, sum = 0
    childArray.forEach((child) => {
        if (child.data[col]) sum += parseFloat(child.data[col])
        else sum += 0
    })
    let average = sum / childArray.length
    return average
}

export const updateParentPredecessorValue = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex,loggedInUser) => {
    if (parent.data && parent.childrenAfterAggFilter.length) {
        let childArray = parent.childrenAfterAggFilter, sum = 0
        childArray.forEach((child) => {
            if (child.rowIndex === latestIndex) sum += parseFloat(latestValue)
            else if (child.data[col]) sum += parseFloat(child.data[col].value)
            else sum += 0
        })
        let average = sum / childArray.length
        parent.data[col] = updateCellValue(parent.data,col,"value",average,loggedInUser)
        // parent.data[col].value = average
        parent.data[field] = average
        arrayToUpdate.push(parent.data)
        return updateParentPredecessorValue(parent.parent, col, field, arrayToUpdate, average, parent.rowIndex)
    }
    else return arrayToUpdate
}

export function getParentValueAsRollUp(node, col, columnSubType) {
    if (!node || !node.childrenAfterAggFilter) return '';
    let values = [];
    node.childrenAfterAggFilter.forEach((child) => {
        // Recursively process the children of this child node
        if (child.childrenAfterAggFilter && child.childrenAfterAggFilter.length > 0) {
            const childRollupValue = getParentValueAsRollUp(child, col, columnSubType);
            if (childRollupValue !== '') {
                values.push(parseFloat(childRollupValue));
            }
        } else {
            // Handle leaf nodes
            if (child.data && child.data.hasOwnProperty(col)) {
                const childValue = parseFloat(child.data[col]);
                if (!isNaN(childValue)) {
                    values.push(childValue);
                } else if (child.data[col] === '' || child.data[col] === undefined || isNaN(child.data[col])) {
                    values.push('');
                }
            }
        }
    });
    // Filter out invalid values (non-numeric and empty strings)
    values = values.filter(value => !isNaN(value));
    if (values.length > 0) {
        let rollupValue;
        if (columnSubType === 'Max') {
            rollupValue = Math.max(...values);
        }
        return rollupValue?.toString();
    }
    return '';
}
export function getParentMDVValueAsRollUp(node, col, columnSubType) {
    if (!node || !node.childrenAfterAggFilter) return '';

    const values = [];

    const processChild = (child) => {
        if (child.childrenAfterAggFilter && child.childrenAfterAggFilter.length > 0) {
            const childRollupValue = getParentMDVValueAsRollUp(child, col, columnSubType);
            if (childRollupValue) {
                const parsedCellValue = isStringifiedArrayWithPropName(childRollupValue) ? JSON.parse(childRollupValue) : [];
                if (parsedCellValue.length > 0) values.push(parsedCellValue);
            }
        } else if (child.data && child.data.hasOwnProperty(col)) {
            const childValue = isStringifiedArrayWithPropName(child.data[col]) ? JSON.parse(child.data[col]) : [];
            if (childValue.length > 0) values.push(childValue);
        }
    };

    node.childrenAfterAggFilter.forEach(processChild);

    if (values.length === 0) return '';

    const rollupValue = JSON.parse(JSON.stringify(MDVParentColumnRawStructure));
    const results = {
        plannedTotalTime: 0,
        actualTotalTime: 0,
    };
    let isPlannedTimeZeroByUser 
    let isActualTimeZeroByUser

    values.forEach((cellValue) => {
        cellValue.forEach(({ propName, propValue }) => {
            if (propValue != '') {
            if (propName === 'Planned Time') {
                results.plannedTotalTime = addTimes(results.plannedTotalTime, propValue);
                isPlannedTimeZeroByUser = propValue === '0' ? true : false
                if (isPlannedTimeZeroByUser !== true && isPlannedTimeZeroByUser !== undefined && results.plannedTotalTime === 0) {
                    isPlannedTimeZeroByUser = true
                }
            } else if (propName === 'Actual Time') {
                results.actualTotalTime = addTimes( results.actualTotalTime, propValue);
                isActualTimeZeroByUser = propValue === '0' ? true : false
                if (isActualTimeZeroByUser !== true && isActualTimeZeroByUser !== undefined && results.actualTotalTime === 0) {
                    isActualTimeZeroByUser = true
                }
            }
        }    
        });
    });
    rollupValue[0].propValue = results.plannedTotalTime !== 0 ?results.plannedTotalTime : isPlannedTimeZeroByUser ? '0' : '';
    rollupValue[1].propValue = results.actualTotalTime !== 0 ? results.actualTotalTime : isActualTimeZeroByUser ? '0' : '';


    return JSON.stringify(rollupValue);
}


export const updateParentValueAsRollUp = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex, columnSubType,loggedInUser) => {
    if (parent.data && parent.childrenAfterAggFilter.length) {
        //  let childArray = parent.childrenAfterAggFilter;
        let childArray = parent.childrenAfterAggFilter, values = []
        childArray.forEach((child) => {
            if (child.rowIndex === latestIndex) {
                if (latestValue == null || latestValue == undefined || latestValue == NaN) {
                    values.push("");
                } else {
                    values.push(parseFloat(latestValue));
                }
            }
            else if(child.data && col in child.data ){
           if ( (child.data[col].value === "" || child.data[col].value == null || child.data[col].value == undefined || child.data[col].value == NaN)) {
                values.push("");
            } else {
                values.push(parseFloat(child.data[col].value));
            }}
            else {
                values.push(parseFloat(child.data[field]));
            }
        });
         values = values.filter(value => value !== '' && !isNaN(value));
        let rollupValue;
      if(values.length>0) {
        if (columnSubType === 'Max') {
            rollupValue = Math.max(...values);
          } else if (columnSubType === 'Min') {
            rollupValue = Math.min(...values);
          } else if (columnSubType === 'Avg') {
            rollupValue = (values.reduce((acc, values) => acc + Number(values), 0) / values.length).toFixed(3);
            rollupValue = Number(rollupValue);
        } else if (columnSubType === 'Sum') {
            rollupValue = (values.reduce((acc, values) => acc + Number(values), 0)).toFixed(3);
          }
    }
        parent.data[col] = updateCellValue(parent.data,col,"value",rollupValue?.toString(),loggedInUser)
        // parent.data[col] = { value: rollupValue?.toString() };
        parent.data[field] = rollupValue?.toString();
        arrayToUpdate.push(parent.data);
        return updateParentValueAsRollUp(parent.parent, col, field, arrayToUpdate, rollupValue, parent.rowIndex, columnSubType,loggedInUser);
    } else {
        return arrayToUpdate;
    }
}


export const updateMDVParentValueAsRollup = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex, loggedInUser, listData) => {
    try {
        if (parent.data && parent.childrenAfterAggFilter.length) {
            let childArray = parent.childrenAfterAggFilter;
            
            const rollupFields = returnRollUpFields(JSON.parse(JSON.stringify(listData)));
            childArray.forEach((child) => {
                if (child.rowIndex === latestIndex) {
                    if (!(latestValue == null || latestValue == undefined)) {
                    
                        let rowRollUpFields = returnRollUpFields(JSON.parse(latestValue));
                         rowRollUpFields.filter((entity)=> entity.propValue).map((entity) => {
                            let objToUpDate = rollupFields.find((field) => field.propId === entity.propId);
                            updateMDVRollUpValue(objToUpDate, entity)
                         })
                        
                    }
                }
                else if (child.data && col in child.data) {
                    if (!(!child.data[col] || child.data[col].value === "" || child.data[col].value == null || child.data[col].value == undefined)) {
                        let rowRollUpFields = returnRollUpFields(JSON.parse(child.data[col].value));
                         rowRollUpFields.map((entity) => {
                            let objToUpDate = rollupFields.find((field) => field.propId === entity.propId);
                            updateMDVRollUpValue(objToUpDate, entity)
                         })
                    }
                }
                else {
                    if (child.data[field]){
                        let rowRollUpFields = returnRollUpFields(JSON.parse(child.data[field]));
                         rowRollUpFields.map((entity) => {
                            let objToUpDate = rollupFields.find((field) => field.propId === entity.propId);
                            updateMDVRollUpValue(objToUpDate, entity)
                         })
                    }                    
                }
            });
            checkIfAvgRollUpFieldExistsAndUpdate(rollupFields);
            parent.data[col] = updateCellValue(parent.data,col,"value",JSON.stringify(rollupFields),loggedInUser)
            // parent.data[col] = { value: rollupValue?.toString() };
            parent.data[field] = JSON.stringify(rollupFields);
            arrayToUpdate.push(parent.data);
            return updateMDVParentValueAsRollup(parent.parent, col, field, arrayToUpdate, JSON.stringify(rollupFields), parent.rowIndex, loggedInUser, listData);
        }else {
            return arrayToUpdate;
        }
    } catch (error) {
        console.error("Error in updateMDVParentValueAsRollup",error);
        
    }
}

function checkIfAvgRollUpFieldExists (rollupFields) {
    try {
        if(typeof rollupFields === 'string'){
            rollupFields = JSON.parse(rollupFields);
        }
        if(rollupFields && rollupFields.length > 0){
            return rollupFields.some(obj => {
                const isValidPropType =  obj.propType === 'number';
                const isValidRollup = obj.rollup && obj.rollup === 'Avg';
                return isValidPropType && isValidRollup;
              });
        }else{
            return false;
        }

    } catch (error) {
        console.error("Error in checkIfRollupEnabledInMDV", error);
    }
}

function checkIfSumRollUpFieldExists (rollupFields) {
    try {
        if(typeof rollupFields === 'string'){
            rollupFields = JSON.parse(rollupFields);
        }
        if(rollupFields && rollupFields.length > 0){
            return rollupFields.some(obj => {
                const isValidPropType =  obj.propType === 'number';
                const isValidRollup = obj.rollup && obj.rollup === 'Sum';
                return isValidPropType && isValidRollup;
              });
        }else{
            return false;
        }

    } catch (error) {
        console.error("Error in checkIfRollupEnabledInMDV", error);
    }
}

export function checkIfAvgRollUpFieldExistsAndUpdate (rollupFields){
    try {
        if(checkIfAvgRollUpFieldExists(rollupFields)){
            rollupFields.forEach(field => {
                if (field.rollup === 'Avg' && Array.isArray(field.numbers) && field.numbers.length) {
                  const avg =
                    field.numbers.reduce((sum, num) => sum + num, 0) / field.numbers.length;
                  field.propValue = JSON.stringify(avg);
                  delete field.numbers;   
                }
              });
        }
        
        if(checkIfSumRollUpFieldExists(rollupFields)){
            rollupFields.forEach(field => {
                if (field.rollup === 'Sum' && Array.isArray(field.numbers) && field.numbers.length) {
                  const sum =
                    field.numbers.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
                  field.propValue = JSON.stringify(sum);
                  delete field.numbers;   
                }
              });
        }
    } catch (error) {
        console.error("Error in checkIfAvgRollUpFieldExistsAndUpdate",error);
    }
}

export function updateMDVRollUpValueAddNewProp(baseObj, rowObj) {
    try {
      if (!baseObj || !rowObj) return;
  
      if (baseObj.propType !== rowObj.propType) return;
  
      const colType = baseObj.propType;
      const columnSubType = baseObj.rollup; // e.g. "Avg", "Min", "Max", "Sum"
      // Keep numbers for Avg/Sum; for Min/Max just compute scalar
  
      if (colType === "number") {
        // parse carefully (allow 0)
        const parseMaybeNumber = (v) => {
          if (v === undefined || v === null || v === "") return undefined;
          const n = typeof v === "number" ? v : parseFloat(v);
          return Number.isFinite(n) ? n : undefined;
        };
  
        const baseVal = parseMaybeNumber(baseObj.propValue);
        const rowVal = parseMaybeNumber(rowObj.propValue);
  
        if (columnSubType === "Max") {
          if (baseVal !== undefined && rowVal !== undefined) baseObj.propValue = JSON.stringify(Math.max(baseVal, rowVal));
          else if (baseVal !== undefined) baseObj.propValue = JSON.stringify(baseVal);
          else if (rowVal !== undefined) baseObj.propValue = JSON.stringify(rowVal);
        } else if (columnSubType === "Min") {
          if (baseVal !== undefined && rowVal !== undefined) baseObj.propValue = JSON.stringify(Math.min(baseVal, rowVal));
          else if (baseVal !== undefined) baseObj.propValue = JSON.stringify(baseVal);
          else if (rowVal !== undefined) baseObj.propValue = JSON.stringify(rowVal);
        } else if (columnSubType === "Avg" || columnSubType === "Sum") {
          // push numeric entries into baseObj.numbers (one entry per immediate child)
          const toPush = rowVal;
          if (toPush !== undefined) {
            if (!Array.isArray(baseObj.numbers)) baseObj.numbers = [];
            baseObj.numbers.push(toPush);
          }
        }
  
        // done; for Avg/Sum we will compute final values elsewhere
      }
  
      else if (colType === "date") {
        // work using timestamps (Date.parse) but guard invalid parses
        const parseTimestamp = (v) => {
          if (!v) return undefined;
          const t = Date.parse(v);
          return isNaN(t) ? undefined : t;
        };
  
        const baseTs = parseTimestamp(baseObj.propValue);
        const rowTs = parseTimestamp(rowObj.propValue);
  
        if (baseTs === undefined && rowTs === undefined) {
          // nothing to do
        } else if (columnSubType === "Max") {
          const maxTs = (baseTs !== undefined && rowTs !== undefined) ? Math.max(baseTs, rowTs) : (baseTs !== undefined ? baseTs : rowTs);
          if (maxTs !== undefined) baseObj.propValue = formatDateToMMDDYYYY(new Date(maxTs));
        } else if (columnSubType === "Min") {
          const minTs = (baseTs !== undefined && rowTs !== undefined) ? Math.min(baseTs, rowTs) : (baseTs !== undefined ? baseTs : rowTs);
          if (minTs !== undefined) baseObj.propValue = formatDateToMMDDYYYY(new Date(minTs));
        }
      }
    } catch (error) {
      console.error("Error in updateMDVRollUpValue", error);
    }
  }


export function updateMDVRollUpValue(baseObj, rowObj) {
    try {
        if(!baseObj) return 

        if (baseObj.propType === rowObj.propType) {

            let colType = baseObj.propType;
            let columnSubType = baseObj.rollup;

            let rollupValue = baseObj.propValue;
            if (colType === "number") {
                 let rowValue =rowObj.propValue

                if (columnSubType === 'Max') {
                    if(rollupValue && rowValue){
                        rollupValue = Math.max(parseFloat(rollupValue), parseFloat(rowValue));
                    }else if(rollupValue && !rowValue){
                        rollupValue = parseFloat(rollupValue);
                    }else if(!rollupValue && rowValue){
                        rollupValue = parseFloat(rowValue);
                    }   
                } else if (columnSubType === 'Min') {
                    if(rollupValue && rowValue){
                        rollupValue = Math.min(parseFloat(rollupValue), parseFloat(rowValue));
                    }else if(rollupValue && !rowValue){
                        rollupValue = parseFloat(rollupValue);
                    }else if(!rollupValue && rowValue){
                        rollupValue = parseFloat(rowValue);
                    }   
                    
                } else if (columnSubType === 'Avg') {
                    if(rowValue){
                        if(baseObj.numbers){
                            baseObj.numbers.push(parseFloat(rowValue));
                        }
                        else {
                            baseObj.numbers = [];
                            baseObj.numbers.push(parseFloat(rowValue));
                        }
                    }                    
                } else if (columnSubType === 'Sum') {
                    if(rowValue){
                        if(baseObj.numbers){
                            baseObj.numbers.push(parseFloat(rowValue));
                        }
                        else {
                            baseObj.numbers = [];
                            baseObj.numbers.push(parseFloat(rowValue));
                        }
                    }         
                }
            }

            else if (colType === 'date') {
                const rowValue = rowObj.propValue;
                if (!rowValue) return;
                // rollupValue = rollupValue || rowValue;

                if (!baseObj.propValue) {
                    rollupValue = rowValue; // start fresh
                } else {
                    const timestamp1 = Date.parse(rowValue);
                    const timestamp2 = Date.parse(baseObj.propValue);
            
                    if (columnSubType === 'Max') {
                        rollupValue = formatDateToMMDDYYYY(new Date(Math.max(timestamp1, timestamp2)));
                    } else if (columnSubType === 'Min') {
                        rollupValue = formatDateToMMDDYYYY(new Date(Math.min(timestamp1, timestamp2)));
                    }
                }

            }

            baseObj.propValue = colType === "number" ? JSON.stringify(rollupValue) : rollupValue
        }
    } catch (error) {
        console.error("Error in updateMDVRollUpValue", error);
    }
}

function formatDateToMMDDYYYY(date) {
    const d = new Date(date);
    const mm = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
}


function isValidDate(dateString) {
    const date = new Date(dateString);
    return !isNaN(date);
}
export function findDate(datesArray, dateType) {
    if (!Array.isArray(datesArray) || datesArray.length === 0) {
        return null; // Handle the case where the input is not a valid array or is an empty array
    }
    // Convert the array of date strings to an array of Date objects
    // Filter out invalid dates or empty strings
    const validDates = datesArray.filter(dateString => {
        if (typeof dateString === 'object' && typeof dateString === 'number') return false;
        const trimmedDateString = dateString?.trim();
        return trimmedDateString && isValidDate(trimmedDateString);
    });
    if (validDates.length === 0) {
        return null; // If there are no valid dates, return null
    }
    // Convert valid date strings to Date objects
    const dateObjects = validDates.map(dateString => new Date(dateString));
    // Find the minimum or maximum date based on the dateType
    let selectedDate;
    if (dateType === "minDate") {
        selectedDate = new Date(Math.min(...dateObjects));
    } else {
        selectedDate = new Date(Math.max(...dateObjects));
    }
    // Format the selected date as MM/DD/YYYY
    const options = { month: '2-digit', day: '2-digit', year: 'numeric' };
    const formattedDate = selectedDate.toLocaleDateString('en-US', options);

    return formattedDate;
}

export function getParentDateAsPredecessor(node, col) {
   
    let childArray = node.childrenAfterAggFilter, dates = []
    childArray.forEach((child) => {
        if (child.data[col]) dates.push(child.data[col])
    })
    let minDate = findDate(dates, minDate)
    return minDate
}
export function checkIfAllPropValuesEmpty(dataStr) {
    if(dataStr === "" || dataStr === undefined) return true;
    // Parse the input string into a JSON array
    let data = JSON.parse(dataStr);
  
    return data.every(item => item.propValue === "");
  }

const handleShareableRollup = (column, node, parentNodeData, col, loggedInUser,updatedChildRowDate) => {
    if (column.type === 'shareableRollupList' && node.data) {
        const value = parentNodeData[col];
        let statusValue = []
        if (value !== undefined && value !== null && value !== "" && !Number.isNaN(value)) {
            processAndPush(value, statusValue)
            if (statusValue[0]?.parentMinPrecedence && statusValue[0]?.parentMaxPrecedence) {
                parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", '', loggedInUser)
                // parentNodeData[col + '_es'].value = parentDate
                parentNodeData[col] = ''
                if (updatedChildRowDate[parentNodeData.id]) {
                    delete updatedChildRowDate[parentNodeData.id]
                    updatedChildRowDate[parentNodeData.id] = parentNodeData
                }
                else updatedChildRowDate[parentNodeData.id] = parentNodeData
            }
        }
    }
    else return '';
};
export const processChildValues = (children, updatedChildRowDate, col, dates, cardView) => {
    let emptyChildrenValue = false;

    children.forEach((child) => {
        if (updatedChildRowDate[child.id]) {
            const value = updatedChildRowDate[child.id][col];
            if (value !== undefined && value !== null && value !== "" && !Number.isNaN(value)) {
                dates.push(value);
            } else {
                emptyChildrenValue = true;
            }
        } else if (child.data ||cardView) {
            const value = cardView?child[col]: child.data[col];
            if (value !== undefined && value !== null && value !== "" && !Number.isNaN(value)) {
                dates.push(value);
            } else {
                emptyChildrenValue = true;
            }
        } else {
            emptyChildrenValue = true;
        }
    });

    return emptyChildrenValue;
};
function filterValidDates(dates) {
    return dates.filter(date => date !== '' && date!==null && date !== undefined);
}
function handleDateType(dates, columnSubType) {
    if (columnSubType === 'Min') return findDate(dates, "minDate");
    if (columnSubType === 'Max') return findDate(dates, "maxDate");
    return '';
}
function handleNumberType(dates, columnSubType) {
    switch (columnSubType) {
        case 'Max':
            return Math.max(...dates.map(Number));
        case 'Min':
            return Math.min(...dates.map(Number));
        case 'Avg':
            return (dates.reduce((acc, date) => acc + Number(date), 0) / dates.length).toFixed(3);
        case 'Sum':
            return (dates.reduce((acc, date) => acc + Number(date), 0)).toFixed(3);
        default:
            return '';
    }
}

export function findDefaultItem(listData,defaultStatus){
    if (!Array.isArray(listData) || !defaultStatus) return null;
    const targetValue = typeof defaultStatus === 'object' ? defaultStatus.value : defaultStatus;

    return listData.find(
      item => String(item.value).trim() === String(targetValue).trim()
    ) || null;
}

export function determineParentDate(column, columnSubType, dates, parentNodeData, emptyChildrenValue) {
    let parentDate;

    if (column) {
        switch (column.type) {
            case 'date': {
                dates = filterValidDates(dates);
                parentDate = handleDateType(dates, columnSubType);
                break;
            }
            case 'multi dimensional value': {
                dates = filterValidDates(dates);
                if (column.block === 'timeseries')
                    parentDate = getRolledUpValueForTimeSeriesCell(dates)
                else if(checkIfRollupEnabledInMDV(column?.listData)){
                    parentDate = getRolledUpValueForMDV(dates, column.listData)
                }
                break;
            }
            case 'number': {
                dates = filterValidDates(dates);
                parentDate = handleNumberType(dates, columnSubType);
                // Convert parentDate to string
                parentDate = parentDate?.toString();
                break;
            }
            case 'shareableRollupList': {
                let columnListData = JSON.parse(column.listData)
                let { listData, precedenceMapping } = generateListDataForRollupStatus(columnListData);
                let defaultStatus = column?.defaultStatus ?JSON.parse(column?.defaultStatus):{
                    value: 'Backlog',
                    parent: 'Default Status',
                    precedence: '0:0',
                    rowId: 'None',
                }
                listData = listData.filter(
                    item => !(item.parent === 'Default Status' && item.rowId === 'None')
                );
                let defaultItem= findDefaultItem(listData, defaultStatus)
                // Now push the updated backlogItem
                if (!defaultItem) {
                    listData.push(defaultStatus);
                } else {
                    defaultStatus = defaultItem
                }
            
               if (emptyChildrenValue) parentDate = ''
                else {
                    let parsedDates = []
                    dates.forEach((date) => {
                        let processedDate;
                        // If date is a string starting with '{', try parsing
                        if (typeof date === 'string' && date.trim().startsWith('{')) {
                            try {
                                processedDate = JSON.parse(date);
                            } catch (e) {
                                // If parsing fails, treat as empty object
                                processedDate = {};
                            }
                        } else {
                            processedDate = date;
                        }
                        // If rowId is 'None' or no value, replace with defaultStatus
                        if (!processedDate || processedDate?.rowId === 'None') {
                            processedDate = JSON.stringify({
                                rowId: defaultStatus.rowId,
                                value: defaultStatus.value,
                            });
                        }
                        // Push processed date
                        processAndPush(processedDate, parsedDates);
                    });

                    parentDate = determineParentRollupStatus(parsedDates, precedenceMapping, listData);
                }
                break;
            }
            default: {
                parentDate = parentNodeData[column.field];
                break;
            }
        }
    }
    else {
        parentDate = handleDateType(dates, columnSubType);
    }
    return parentDate;
}
export function processParentNodeData(column, col, parentNodeData, parentDate, loggedInUser) {
    const isTimeSeries = column?.block === "timeseries";

    if (parentNodeData && !parentNodeData.hasOwnProperty(col + '_es')) {
        updateParentNodeData(parentNodeData, col, parentDate, loggedInUser, isTimeSeries);
    }

    if (parentNodeData && parentNodeData[col + '_es']) {
        updateParentNodeData(parentNodeData, col, parentDate, loggedInUser, isTimeSeries);
    }
}
function updateParentNodeData(parentNodeData, col, parentDate, loggedInUser, isTimeSeries) {
    if (isTimeSeries) {
        let allPropValueEmpty = checkIfAllPropValuesEmpty(parentDate);
        if (!allPropValueEmpty) {
            if (parentNodeData[col]) {
                let timeSeriesProps = JSON.parse(parentNodeData[col]).filter(
                    (item) => !((item.propName === "TaskEnded" && (!item.propValue || item.propValue === "No"))||item.propName === "Reason")
                );
                if (parentNodeData[col + "_es"]?.value) {
                    parentNodeData[col + "_es"].value = JSON.stringify(timeSeriesProps);
                }
            }
            parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", parentDate, loggedInUser);
        }
        parentNodeData[col] = parentDate;
        parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", parentDate, loggedInUser);
    } else {
        parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", parentDate, loggedInUser);
        parentNodeData[col] = parentDate;
    }
}
export function handleEmptyParentNodeData(column, col, parentNodeData, loggedInUser) {
    const isTimeSeries = column?.block === "timeseries";
    if (isTimeSeries) {
        let shouldUpdate = !checkIfAllPropValuesEmpty(parentNodeData[col]);

        if (parentNodeData && !parentNodeData.hasOwnProperty(col + '_es') && shouldUpdate) {
            parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", "", loggedInUser);
        }

        if (parentNodeData && parentNodeData[col + '_es'] && shouldUpdate) {
            parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", "", loggedInUser);
        }

        parentNodeData[col] = "";
    }
    else{
        parentNodeData[col + '_es'] = updateCellValue(parentNodeData, col + '_es', "value", "", loggedInUser);
        parentNodeData[col] = "";
    }
}
export function getParentStatusAsRollUp(node, parentNodeData, col, columnSubType, updatedChildRowDate, column, loggedInUser) {
    const { listData, precedenceMapping } = generateListDataForRollupStatus(JSON.parse(column.listData));
    let defaultStatus = column?.defaultStatus ? JSON.parse(column?.defaultStatus) : {
        value: 'Backlog',
        parent: 'Default Status',
        precedence: '0:0',
        rowId: 'None',
    }
    let defaultItem= findDefaultItem(listData, defaultStatus)
    // Now push the updated backlogItem
    if (!defaultItem) {
        listData.push(defaultStatus);
    } else {
        defaultStatus = defaultItem
    }

    if (node?.childrenAfterGroup?.length > 0) {
        updateStatusRecursively(node, col, listData, precedenceMapping, '', updatedChildRowDate, loggedInUser,defaultStatus);
    } else {
        processLeafNode(node, col, listData, '', updatedChildRowDate, loggedInUser,defaultStatus);
    }
}
export function getParentDateAsRollUp(node, parentNodeData, col, columnSubType, updatedChildRowDate, column, loggedInUser) {
    if (!node || !node.childrenAfterGroup || node.childrenAfterGroup.length === 0) return '';
    let dates = [];
    // Assuming `node.childrenAfterGroup` is the children array, and `dates` is initialized before calling.
    const emptyChildrenValue = processChildValues(node.childrenAfterGroup, updatedChildRowDate, col, dates);
    // Filter out invalid dates
    if (dates.length > 0) {
        const parentDate = determineParentDate(column, columnSubType, dates, parentNodeData, emptyChildrenValue);
        processParentNodeData(column, col, parentNodeData, parentDate, loggedInUser);
    }
    else {
        handleEmptyParentNodeData(column, col, parentNodeData, loggedInUser);
    }
}
 
export const updateParentPredecessorDate = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex) => { 
    if (parent.data && parent.childrenAfterAggFilter.length) {
        let childArray =  parent.childrenAfterGroup, dates = []
        childArray.forEach((child) => {
            if (child.rowIndex === latestIndex) dates.push(latestValue)
            else if (child.data[col]) dates.push(child.data[col].value)
        })
        let minDate = findDate(dates, "minDate")
        if (!parent.data[col]) {
            parent.data[col] = { value: minDate }
            parent.data[field] = minDate
        }
        parent.data[col].value = minDate
        parent.data[field] = minDate
        arrayToUpdate.push(parent.data)
        return updateParentPredecessorDate(parent.parent, col, field, arrayToUpdate, minDate, parent.rowIndex)
    }
    else return arrayToUpdate
}
export const updateParentRollupDate = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex, columnSubType,loggedInUser) => {
    if (parent.data && parent.childrenAfterAggFilter.length) {
        let childArray = parent.childrenAfterAggFilter, dates = []
        childArray.forEach((child) => {
            if (child.rowIndex === latestIndex) dates.push(latestValue)
            else if (child.data && col in child.data) {
                if (child.data[col].value === "" || child.data[col].value == null || child.data[col].value == undefined || child.data[col].value == NaN) {
                    dates.push("")
                }
                else if (child.data[col]?.value != null) {
                    dates.push(child.data[col].value)
                }
            }
            else {
                dates.push(child.data[field]);
            }
        })
        dates = dates.filter(value => value !== '');
        let updateDate;
        if (columnSubType == 'Min') updateDate = findDate(dates, "minDate")
        else if (columnSubType == 'Max') updateDate = findDate(dates, "maxDate")
        if (updateDate) {
            parent.data[field] = updateDate?.toString()
            parent.data[col] = updateCellValue(parent.data, col, "value", updateDate?.toString(), loggedInUser)
        }
        else {
            parent.data[col] = updateCellValue(parent.data, col, "value", '', loggedInUser)
            parent.data[field] = ''
        }
        arrayToUpdate.push(parent.data)
        return updateParentRollupDate(parent.parent, col, field, arrayToUpdate, updateDate, parent.rowIndex, columnSubType)
    }
    else return arrayToUpdate
}
export function calculateDayDifference(date1, date2) {
    try {
        // Parse the input dates if they are strings
        const parsedDate1 = new Date(date1);
        const parsedDate2 = new Date(date2);

        if (!parsedDate1 || !parsedDate2) return Number.MAX_SAFE_INTEGER

        // Calculate the time difference in milliseconds
        const timeDifference = parsedDate2 - parsedDate1;

        // Convert milliseconds to days
        const dayDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

        return dayDifference;
    }
    catch (err) {
        console.warn('err:', err);
        return Number.MAX_SAFE_INTEGER
    }
}
export const updateDurationCell = (row, col, field, { start, end }) => {
    let startDate = row[start]
    let endDate = row[end]
    let newVal = calculateDayDifference(startDate, endDate) + "d"
    if (!row[col]) {
        row[col] = { value: newVal }
        row[field] = newVal
    }
    else {
        row[col].value = newVal
        row[field] = newVal
    }
    return row

}

export const processStatusListData = (data) => {
    const parentChildMap = {};

    data.forEach(item => {
        if (!parentChildMap[item.parent]) {
            parentChildMap[item.parent] = {
                precedence: item.precedence,
                children: []
            };
        }
        parentChildMap[item.parent].children.push(item.value);
    });

    const sortedParentKeys = Object.keys(parentChildMap).sort((a, b) => {
        return parentChildMap[a].precedence - parentChildMap[b].precedence;
    });

    const sortedParentChildMap = {};

    sortedParentKeys.forEach(parent => {
        const sortedChildren = parentChildMap[parent].children;
        sortedParentChildMap[parent] = sortedChildren;
    });

    return sortedParentChildMap;
};

const statusOrder = ['To Do', 'In Progress', 'Reopened', 'Done', 'Closed', 'Duplicate','Released To QA','QA Complete'];
export const getParentValueAsStatus = (node, col,precedenceMapping, listData) => {
    // Check if parent node has data and children
    if (node.data && node.childrenAfterGroup.length) {
        let childArray = node.childrenAfterGroup;
        let statuses = [];
        // Gather statuses from children
        childArray.forEach((child) => {
            if (child.childrenAfterGroup && child.childrenAfterGroup.length > 0) {
                const childRollupStatus = getParentValueAsStatus(child, col);
                if (childRollupStatus !== '') {
                    statuses.push(childRollupStatus);
                }
            } else if (child.data && child.data[col] && statusOrder.includes(child.data[col]))
            {
                statuses.push(child.data[col]);
            }
        });
        if (statuses.length === 0) {
            return "";
          }
          const parentStatus = determineParentStatus(statuses,precedenceMapping, listData);
        return parentStatus;
    } else {
        return null;
    }
};
export const generateListDataForRollupStatus = (statusColumnList) => {
    const listData = [];
    const precedenceMapping = {};
    let precedenceCounter = 1; // Start with 1 for the ascending order precedence
    statusColumnList.forEach(item => {

        const parent = item.parent ?? item.value; // Use value if parent is undefined
        const precedence = precedenceCounter++; // Assign ascending order precedence if undefined
        const newChildPrecedence = Number.isInteger(item.precedence) ? `${item.precedence}:${precedence}` : item.precedence;

        listData.push({
            value: item.value,
            parent: parent,
            precedence: newChildPrecedence,
            ...(item.rowId && { rowId: item.rowId })
        });

        if (!precedenceMapping[item.value]) {
            precedenceMapping[item.value] = newChildPrecedence;
        }
    });

    return { listData , precedenceMapping 
    };
};

export const getParentValueAsRollupStatus = (node, col, precedenceMapping, listData, gridRef, valueChangedByValueGetter) => {
    const filterModel = gridRef.current?.api?.getFilterModel();  // Get the filter model
    if (Object.keys(filterModel).length>0) return node.data[col];
    if (!listData) {
        console.error("listData is undefined or null");
        return null;
    }

    if (node.data && node.childrenAfterGroup.length) {
        let childArray = node.childrenAfterGroup;
        let statuses = [];

        // Gather statuses from children
        childArray.forEach((child) => {
            if (child.childrenAfterGroup && child.childrenAfterGroup.length > 0) {
                const childRollupStatus = getParentValueAsRollupStatus(child, col,precedenceMapping, listData, gridRef, valueChangedByValueGetter);
                if (childRollupStatus !== '') {
                    statuses.push(childRollupStatus);
                }
            } else if (child.data && child.data[col] && listData.map(item => item.rowId).includes(JSON.parse(child.data[col]).rowId)) {
                statuses.push(child.data[col]);
            }
        });

        if (statuses.length === 0 || statuses[0] === null) {
            return "";
        }

        const parentStatus = determineParentRollupStatus(statuses, precedenceMapping, listData);
        if(!node.data[col] || node?.data?.[col]?.value !== parentStatus){
            valueChangedByValueGetter(node, col, parentStatus, gridRef?.current)
        }
        return parentStatus;
    } else {
        return null;
    }
};

export const updateParentStatus = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex, gridRef, valueChangedByValueGetter,loggedInUser) => {
    if (parent.data && parent.childrenAfterAggFilter.length) {
        const childArray = parent.childrenAfterAggFilter;
        let statuses = [];
        childArray.forEach((child) => {
            if (child.rowIndex === latestIndex) {
                statuses.push(latestValue);
            } else if (child.data && col in child.data) {
                let childStatus = child.data[col];
                if (childStatus !== "" && childStatus !== null && childStatus !== undefined && !isNaN(childStatus)&& statusOrder.includes(child.data[col])){
                    statuses.push(childStatus);
                }
            }
        });
        // Implementing the specified rules
        if(statuses !== null){
            const parentStatus = emptyChildren ? "" : determineParentStatus(statuses);
            if(!parent.data[col] || parent?.data?.[col]?.value !== parentStatus){
            let columnField = col.replace(/_es$/, '')
            valueChangedByValueGetter(parent, columnField, parentStatus, gridRef.current)
        // Update parent status
        parent.data[col] = updateCellValue(parent.data,col,"value",parentStatus,loggedInUser)
        // parent.data[col] = { value: parentStatus };
        parent.data[field] = parentStatus;
        arrayToUpdate.push(parent.data);
        }
        // Recursive call to update the parent of the parent
        return updateParentStatus(parent.parent, col, field, arrayToUpdate,parentStatus,parent.rowIndex, gridRef, valueChangedByValueGetter);
    } else {
        return arrayToUpdate;
    }
};}
export const processAndPush = (value,statuses) => {
    if (typeof value === 'string' && value.startsWith('{')){
        try {
            const parsedValue = JSON.parse(value);
           
            statuses.push((parsedValue.rowId||(parsedValue?.parentMinPrecedence!==undefined && parsedValue?.parentMinPrecedence!==''&& parsedValue?.parentMaxPrecedence!==undefined &&parsedValue?.parentMaxPrecedence!==''))?parsedValue:parsedValue.value); // Parse if it's a stringified object
        } catch (error) {
            console.error("Invalid JSON format in processAndPush:", value, error);
            statuses.push(value); // Push as normal string if parsing fails
        }
    } else {
        statuses.push(value); // Push as-is if it's already an object
    }
};

export const updateParentRollupStatus = (parent, col, field, arrayToUpdate = [], latestValue, latestIndex, precedenceMapping, listData, params, valueChangedByValueGetter, loggedInUser) => {
    if (parent.data && parent.childrenAfterGroup.length) {
        let defaultStatus = params.colDef?.defaultStatus ?JSON.parse(params.colDef?.defaultStatus):{
            value: 'Backlog',
            parent: 'Default Status',
            precedence: '0:0',
            rowId: 'None',
        }
     
        let defaultItem= findDefaultItem(listData, defaultStatus)
        // Now push the updated backlogItem
        if (!defaultItem) {
            listData.push(defaultStatus);
        } else {
            defaultStatus = defaultItem
        }
        const childArray = parent.childrenAfterGroup;
        let statuses = [];
        let emptyChildrenValue = false;
        let childStatus = "";
        childArray.forEach((child) => {
            childStatus = child.data[col];
            if (child.rowIndex === latestIndex) {
                if (latestValue === "" || latestValue === null || latestValue === undefined) {
                    emptyChildrenValue = true
                }
                else {
                    processAndPush(latestValue,statuses);
                }
            } else if (child.data && col in child.data) {
                if (childStatus.value !== "" && childStatus.value !== null && childStatus.value !== undefined && child?.childrenAfterGroup?.length) {
                    processAndPush(childStatus.value,statuses);
                }
                else if (childStatus.value !== "" && childStatus.value !== null && childStatus.value !== undefined && (
                    (typeof childStatus.value === "string" && childStatus.value.startsWith("{") &&
                        listData.some(item => item.rowId === JSON.parse(childStatus.value)?.rowId)) ||
                    listData.some(item => item.value === childStatus.value)|| listData.some(item => item.value === JSON.parse(childStatus.value).value)
                )) {
                    processAndPush(childStatus.value,statuses);
                }
                else if (childStatus.value === "" || childStatus.value === null || childStatus.value === undefined) emptyChildrenValue = true
            }
            else if (childStatus === "" || childStatus === null || childStatus === undefined) emptyChildrenValue = true
        });
        // Implementing the specified rules
        const parentStatus = emptyChildrenValue ? "" : determineParentRollupStatus(statuses, precedenceMapping, listData);
        if (!parent.data[col] || parent?.data?.[col]?.value !== parentStatus) {
            parent.data[col] = updateCellValue(parent.data, col, "value", parentStatus, loggedInUser)
            //valueChangedByValueGetter(parent, columnField, parentStatus, params)
            // Update parent status

            // parent.data[col] = updateOrCreateObject(parent.data[col],"value",parentStatus )
            parent.data[field] = parentStatus;
            arrayToUpdate.push(parent.data);
        }

        // Recursive call to update the parent of the parent
        return updateParentRollupStatus(parent.parent, col, field, arrayToUpdate, parentStatus, parent.rowIndex, precedenceMapping, listData, params, valueChangedByValueGetter, loggedInUser);
    } else {
        return arrayToUpdate;
    }
};
const updatePrecedence = (parent, child, numericPrecedence, isMin, state) => {
    if (isMin) {
        if (numericPrecedence < state.minPrecedence) {
            state.minPrecedence = numericPrecedence;
            state.minPrecedenceChild = child.trim()
            state.minPrecedenceParent = parent.trim()
        }
    }
    if (numericPrecedence > state.maxPrecedence) {
        state.maxPrecedence = numericPrecedence;
        state.maxPrecedenceChild = child.trim()
        state.maxPrecedenceParent = parent.trim()
    }
};
const getParent = (status,listData) => {
   
    let item = status?.value && status.rowId ? listData?.find((item) =>item.rowId === status.rowId): listData?.find((item) => item.value === status);
    if (item && item.parent) {
        return item;
    } else {

        item =  status?.value ? listData?.find((item) => item.parent === status.value):listData?.find((item) => item.parent === status);
        return item;
    }
};
const handleDirectPrecedence = (status,precedenceMapping,listData,state) => {
   
    const item = getParent(status,listData);
    let parent= item?.parent
    let value= item?.value;
    // let value= status?.value?status.value:status
    let defaultStatusPredence='0:0'
    const precedence = parent==="Default Status"?defaultStatusPredence?.split(':')[1]: precedenceMapping[value]?.split(':')[1];
    if (precedence !== undefined && precedence !== null) {
        const numericPrecedence = parseFloat(precedence);
        updatePrecedence(parent, value, numericPrecedence, true,state);
        updatePrecedence(parent, value, numericPrecedence, false,state);
    } else {
        state.invalidChildrenValue = true;
    }
};

function extractMinMaxParts(status) {
    let minPart, maxPart;

    if (status.value?.includes('=>') && status.value?.includes(':')) {
        const arrowIndex = status.value.indexOf('=>');

        // Check if there's a `:` before and after the `=>`
        const beforeArrow = status.value.slice(0, arrowIndex);
        const afterArrow = status.value.slice(arrowIndex + 2);

        if (beforeArrow.includes(':') && afterArrow.includes(':')) {
            minPart = beforeArrow.trim();
            maxPart = afterArrow.trim();
            return { minPart, maxPart };
        } else {
            minPart = maxPart = status.value;
            return { minPart, maxPart };
        }

    } else {
        minPart = maxPart = status.value;
        return { minPart, maxPart };
    }
}

const handleParentPrecedence = (status,state) => {
    let { parentMinPrecedence, parentMaxPrecedence } = status;
    if (parentMinPrecedence!==''&& parentMinPrecedence!==undefined && parentMaxPrecedence!==undefined &&parentMaxPrecedence!=='') {
       
        const { minPart, maxPart } = extractMinMaxParts(status);
       
    const [minParent, minChild] = minPart?.includes(': ') 
        ? minPart.split(': ') 
        : [status.value, status.value]; // If no ':', use the value itself

    const [maxParent, maxChild] = maxPart?.includes(': ') 
        ? maxPart.split(': ') 
        : [status.value, status.value]; // If no ':', use the value itself


        updatePrecedence(minParent, minChild, parseFloat(parentMinPrecedence), true,state);
        updatePrecedence(maxParent, maxChild, parseFloat(parentMaxPrecedence), false,state);
    } else {
        state.invalidChildrenValue  = true;
    }
};


// Function to determine parent status based on child statuses
export const determineParentRollupStatus = (statuses, precedenceMapping, listData) => {
    if (statuses.length === 0 || statuses[0] === "") {
        return '';
    }
    if (statuses.some(status => !status)) {
        return ''; // Return empty if even one status lacks a parent
    }
    // Helper function to get the parent of a status
    const state = {
        minPrecedence: Infinity,
        maxPrecedence: -Infinity,
        minPrecedenceParent: null,
        maxPrecedenceParent: null,
        minPrecedenceChild: null,
        maxPrecedenceChild: null,
        invalidChildrenValue: false
    };
    // Iterate through statuses to find the min and max precedence
    statuses.forEach(status => {
        if(status.parentMinPrecedence != null && status.parentMinPrecedence !== '' && status.parentMaxPrecedence != null && status.parentMaxPrecedence !== ''){
            handleParentPrecedence(status,state);
        }
        else {
            handleDirectPrecedence(status,precedenceMapping,listData,state);
        }
    });
    if (state.minPrecedence === state.maxPrecedence) {
        return JSON.stringify({
            value: `${state.minPrecedenceParent}: ${state.minPrecedenceChild}`,
            parentMaxPrecedence: state.maxPrecedence,
            parentMinPrecedence: state.minPrecedence
        });
    }

    if (!state.invalidChildrenValue) {
        return JSON.stringify({ 
            value: `${state.minPrecedenceParent}: ${state.minPrecedenceChild} => ${state.maxPrecedenceParent}: ${state.maxPrecedenceChild}`,
            parentMaxPrecedence:state.maxPrecedence,
            parentMinPrecedence:state.minPrecedence
        });
    }
    return '';
};


const determineParentStatus = (statuses) => {
    // const hasOnly = (status) => {
    //     return statuses.every(s => s === status);
    // };
    if (statuses.length === 0) {
        return '';
    }
    const statusPriority = {
        'In Progress': 1,
        'To Do': 2,
        'Reopened': 3,
        'Done': 4,
        'Closed': 5,
        'Duplicate': 6,
        'Released To QA': 7,
        'QA Complete': 8
    };
 
    // Check if any specific statuses should take precedence
    if (statuses.includes('Reopened')) {
        return 'Reopened';
    }
    // Find the status with the minimum priority
    let minStatus = statuses[0];
    const StatusesLength= statuses.length;
    for (let i = 1; i < StatusesLength; i++) {
        if (statusPriority[statuses[i]] < statusPriority[minStatus]) {
            minStatus = statuses[i];
        }
    }
    return minStatus;
};
// Function to determine parent status when specific statuses are present
// const determineSpecificParentStatus = (statuses) => {
//     if (statuses.includes('In Progress')) {
//         return 'In Progress';
//     } else if (statuses.includes('Reopened')) {
//         return 'Reopened';
//     } else if (statuses.includes('Duplicate')) {
//         return 'Duplicate';
//     } else if (statuses.includes('Done')) {
//         return 'Done';
//     } else if (statuses.includes('Closed')) {
//         return 'Closed';
//     } else if (statuses.includes('Released To QA')) {
//         return 'Released To QA';
//     } else if (statuses.includes('QA Complete')) {
//         return 'QA Complete';
//     } else {
//         return 'To Do';
//     }
// };

export const hideOverlay = (gridRef, time) => {
    setTimeout(() => {
        gridRef?.current?.api?.hideOverlay();
    }, time)
}


export const storeLastRenderedRow=(gridRef,sheetId)=>{
    if(!gridRef || !gridRef.current || !gridRef.current.api) return;
    const renderedNodes=gridRef.current.api.getRenderedNodes()
    if(renderedNodes.length && renderedNodes.length<39 && renderedNodes[0].rowIndex===0){
        sessionStorage.setItem('storedIndex$'+sheetId, renderedNodes[0].id);
    }
    else if(renderedNodes.length){
        const firstRenderedRow = renderedNodes.length<39 ?renderedNodes[0]:renderedNodes[0]; // Get the first rendered row
        const indexToStore = firstRenderedRow && firstRenderedRow.id ; // Get the index of the first rendered row
        // Store the index in sessionStorage
        sessionStorage.setItem('storedIndex$'+sheetId, indexToStore);
    }
}
export const debounce = (func, delay) => {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), delay);
  };
};

export const getLidAfterLastOccurenceOfParentId = (value,id) => {
    let values = value.split(id+'.');
    let length = values.length;
    return values[length-1]
}
export function removeAllOccurencesOfCorruptedNode(value,id){
    let values = value.split('.');
   return values.filter((key)=>key!=id).join('.');
}
export const correctChildsOfCorruptedNode=async(params,node,gridRefreshFunction)=>{
    try{
        params.api.showLoadingOverlay()
        if (!params.api) return
        if(node.expanded===false) {
            params.api.setRowNodeExpanded(node,true)
            return
        }
        if (!node.key) {
            let correctedNodes = []
            let firstRowToBeCorrected = -1;
            let rowNode = params.api.getRowNode(node.id)
            const childrenArray = getUniqueChildrenArray(rowNode)
            let childArray = childrenArray.filter(item => item.id !== node.id)
            childArray.forEach(childNode => {
                let tempIdArray = childNode.data.l_id.split(".")
                if (tempIdArray.includes("")) {
                    let filteredArray = tempIdArray.filter(item => item !== "")
                    let correctedL_Id = filteredArray.join(".")
                    childNode.data.l_id = correctedL_Id
                    childNode.data.l_id=syncLidWithId(childNode.data)
                    if (correctedNodes.length === 0) firstRowToBeCorrected = childNode.rowIndex
                    correctedNodes.push(childNode.data)
                }
            })
    
            params.api.applyTransaction({
                update: correctedNodes,
                index: firstRowToBeCorrected
            })
    
            params.api.applyTransaction({
                remove: [{ id: node.id }]
            })
    
            setTimeout(() => {
                params.api.redrawRows()
            }, 100)
            return;
        }
            let originalNode=params.api.getRowNode(node.key)
            let correctedRows=originalNode ? [originalNode.data]:[],firstRowToBeCorrected=-1
            console.log("original",originalNode)
            let nullAndDuplicateNodes=[]
            const childrenArray = getUniqueChildrenArray(node) //if original node is present

            if(originalNode && node.rowIndex!==originalNode.rowIndex){
                childrenArray.forEach((child,index) => {
                    if(child.key!==originalNode.key){
                        if (child.data.l_id.includes(node.key)) {
                            let l_idWthCorruptedIdRemoved = getLidAfterLastOccurenceOfParentId(child.data.l_id,node.key)
                            let newL_id=originalNode.data.l_id + '.'+l_idWthCorruptedIdRemoved
                            child.data.l_id=newL_id
                            child.data.l_id=syncLidWithId(child.data)
                            if(correctedRows.length===1 || firstRowToBeCorrected===null ) firstRowToBeCorrected=child.rowIndex
                            correctedRows.push(child.data)
                        }
                    }
                    else if(child.key==originalNode.key && node.rowIndex!=child.rowIndex ) {
                        console.log("Case where corrupted node has a rowIndex")
                        nullAndDuplicateNodes.push(child)
                    }   
                    else if(child.key==originalNode.key && child.rowIndex===null) {
                        console.log("Case where corrupted node has no rowIndex and child index is null",child,node)
                        // params.api.applyTransaction({
                        //     remove:[{id:child.id},{id:node.id}]
                        // })
                        nullAndDuplicateNodes.push(child)
                        // params.api.applyTransaction({
                        //     add:[child.data],
                        //     addIndex:child.rowIndex
    
                        // })
                       
                    }
                })
            }
            else{ // if original parent node is not present
                childrenArray.forEach((child,index) => {
                    // if(child.key!==originalNode.key){
                    //     if (child.data.l_id.includes(node.key)) {
                            let l_idWthCorruptedIdRemoved = removeAllOccurencesOfCorruptedNode(child.data.l_id,node.key)
                            let newL_id=l_idWthCorruptedIdRemoved
                            child.data.l_id=newL_id
                            child.data.l_id=syncLidWithId(child.data)
                            if(correctedRows.length===1 || firstRowToBeCorrected===null) firstRowToBeCorrected=child.rowIndex
                            if(child.key===node.key) nullAndDuplicateNodes.push(child)
                            correctedRows.push(child.data)
                    //     }
                    // }
                    
                })
            }
            if(nullAndDuplicateNodes.length===0 && originalNode && originalNode.rowIndex!==node.rowIndex) {
                nullAndDuplicateNodes.push(originalNode)
            }
            if(nullAndDuplicateNodes.length){
                console.log("Case nullAndDuplicateNodes",nullAndDuplicateNodes,node)
                let nodesToDelete=[{id:node.id}],data,addIndex=nullAndDuplicateNodes[0].rowIndex,nodeWithIDAndKeyDiff
                nullAndDuplicateNodes.forEach((child)=>{
                    nodesToDelete.push({id:child.id})
                    child.data.l_id=syncLidWithId(child.data)
                    data=[child.data]
                    if(child.id!==child.key) nodeWithIDAndKeyDiff=child
                    if(child.rowIndex!=null) addIndex=child.rowIndex
                })
                if(nodeWithIDAndKeyDiff)data.push(nodeWithIDAndKeyDiff.data)
                if(addIndex==null) addIndex=node.rowIndex
                console.log("nodesToDelete", nodesToDelete,"data",data,addIndex)
         
                if(data[0] && data[0].l_id){
                    let response=params.api.applyTransaction({
                        remove:nodesToDelete
                    })
                    data[0].l_id=removeDuplicateKeepLast(data[0].l_id)
                    if(addIndex===null || !addIndex) addIndex=0
                    if(addIndex!==null) params.api.applyTransaction({
                        add:data,
                        addIndex:addIndex
                    })
                    await new Promise(resolve => setTimeout(resolve, 100));
                    correctedRows=correctedRows.filter((n)=>n.id!==node.id)
                    console.log("response of duplicate node removal",response)
                    if(nodesToDelete.length - response.remove.length>1) {
                        setTimeout(()=>{
                            gridRefreshFunction()
                        },500)
                    }
                }
                
            }
            console.log(firstRowToBeCorrected,"firstRowToBeCorrected",correctedRows,"correctedRows")
            if (!originalNode) {
                params.api.applyTransaction({
                    remove: [{ id: node.id }]
                })
            }
            if(correctedRows.length>1 && firstRowToBeCorrected!=-1){
                params.api.applyTransaction({
                    remove:correctedRows,
                })
                params.api.applyTransaction({
                    add:correctedRows,
                    addIndex:firstRowToBeCorrected
                })
                setTimeout(()=>{
                    params.api.redrawRows()
                },100)
            }
            else params.api.redrawRows()
    }
    catch(err){
        console.log(err,"Something went wrong during autocorrect")
        setTimeout(()=>{
            gridRefreshFunction()
        },100)
    }
    // if(!node.parent.data && node.parent.id!='ROOT_NODE_ID')correctChildsOfCorruptedNode(params,node.parent);
    
   

}
export const debouncedcorrectChildsOfCorruptedNode=(params,node,gridRefreshFunction)=>{
    debounce(correctChildsOfCorruptedNode(params,node,gridRefreshFunction),2000);
}
export function filterDistinctById(array) {
    const uniqueIds = new Set(); // Set to store unique IDs
    return array.filter(obj => {
        if (uniqueIds.has(obj.key)) {
            return false; // Skip if the ID has already been encountered
        } else {
            uniqueIds.add(obj.key); // Add the ID to the Set
            return true; // Include this element in the filtered array
        }
    });
}
export const processDuration = (row, durationCol, startCol, endCol, colDef,oldValue, predecessorData, isParent,loggedInUserEmail) => {
    const loggedInUser = loggedInUserEmail ||  xTablesStore.getState().gridReducer.loggedInUser
    const { duration, endDate, startDate, predecessorEndDate } = colDef?.linkedColumns || {};
    let startValue = row[startCol] || row[startCol + '_es']?.value;
    let endValue = row[endCol] || row[endCol + '_es']?.value
    let newValForDuration = row[durationCol], newValueForEndDate = endValue, newValueForStartDate = startValue;

    // Update startValue based on predecessorData
    if (predecessorData) {
        const predecessorEnd = predecessorData[endCol];
        if (!predecessorEnd) return "Predecessor error"
        startValue = new Date(startValue) < new Date(predecessorEnd) ? predecessorEnd : startValue;
        newValueForStartDate = startValue;
    }

    // Ensure endDate is always after startDate
    if (startValue && new Date(startValue) && colDef?.field != endCol) {
        newValueForEndDate = (endValue && new Date(endValue) && new Date(endValue) < new Date(startValue)) ? startValue : (endValue || startValue);
    } else if (!isParent && endValue && new Date(endValue) && colDef?.field?.trim() !== startCol?.trim() && (new Date(endValue) >= newValueForStartDate || !newValueForStartDate) && !newValForDuration) {
        newValueForStartDate = endValue;
    }

    // Update row start date and associated '_es' value
    const updateRowValue = (col, value) => {
        if (row[col + "_es"]) {
            row[col + "_es"].value = oldValue?oldValue:row[col];
          }
        row[col + '_es'] = updateCellValue(row,col + '_es',"value",value,loggedInUser)
        row[col] = value;
        // row[`${col}_es`] = row[`${col}_es`] ? { ...row[`${col}_es`], value } : { value };
    };

    if (newValueForStartDate) updateRowValue(startCol, newValueForStartDate);

    // If the column being processed isn't the endCol, calculate end date and update duration
    if (!isParent && newValueForEndDate && newValueForStartDate && colDef?.field !== endCol && (predecessorEndDate || endDate) && duration && newValForDuration !== null && newValForDuration !== '' && newValForDuration !== undefined) {
        let updatedRow = calculateDates(newValueForStartDate, newValueForEndDate, newValForDuration, row, startCol, endCol, durationCol,loggedInUser);
        updateRowValue(endCol, updatedRow[endCol]);

        // Check if the start date falls on a weekend
        const dayOfWeek = new Date(newValueForStartDate).getDay();
        if (newValForDuration === "0d" || (newValueForStartDate === updatedRow[endCol] && (dayOfWeek === 0 || dayOfWeek === 6))) {
            newValForDuration = (dayOfWeek === 0 || dayOfWeek === 6) ? "0d" : dateDifference(newValueForStartDate, updatedRow[endCol], newValForDuration);
        }
        updateRowValue(durationCol, newValForDuration);
    } else {
        if (newValueForEndDate && endCol) updateRowValue(endCol, newValueForEndDate);
        if (!isParent && newValueForEndDate && new Date(newValueForEndDate) && newValForDuration && colDef?.field?.trim() !== startCol?.trim() && !newValueForStartDate) {
            let updatedRow = calculateDates(newValueForStartDate, newValueForEndDate, newValForDuration, row, startCol, endCol, durationCol,loggedInUser);
            updateRowValue(startCol, updatedRow[startCol]);
        }
        else if (newValueForStartDate && new Date(newValueForStartDate) && newValueForEndDate && new Date(newValueForEndDate)) {
            newValForDuration = newValueForEndDate ? dateDifference(newValueForStartDate, newValueForEndDate, newValForDuration) : "1d";
            updateRowValue(durationCol, newValForDuration);
        } else if (row[durationCol]) {
            updateRowValue(durationCol, '');
        }
    }
    return row;
};

  function isEmptyOrNotNumber(str) {
    // Check if the string is empty or only contains whitespace
    if (str.trim() === "") {
      return true;
    }
    
    // Check if the string contains a valid number
    return isNaN(Number(str));
  }
  export const processAndPriortizeDuration=(row,durationCol,startCol,endCol)=>{
    let startValue=row[startCol]
    let endValue=row[endCol]
    let newValForDuration=row[durationCol],newValueForEndDate=row[endCol],newValueForStartDate=row[startCol]
    if(isEmptyOrNotNumber(newValForDuration)){
        newValueForEndDate=''
        newValueForStartDate=''
        newValForDuration=''
    }

    //format endDate to be always more than startDate
      if(startValue && new Date(startValue)){ // update end date
        if(endValue && new Date(endValue) && new Date(endValue)<new Date(startValue)){
          newValueForEndDate=startValue
        }
        else if(!endValue) newValueForEndDate=startValue
      }
      else if(endValue && new Date(endValue) ){ //update start date
        newValueForStartDate=endValue
      }
      if(newValueForEndDate){
        row[endCol]=newValueForEndDate
        if(row[endCol+'_es']){
          row[endCol+'_es'].value=newValueForEndDate
        }
        else row[endCol+'_es']={value:newValueForEndDate}
      }
      if(newValueForStartDate){
        row[startCol]=newValueForStartDate
        if(row[startCol+'_es']){
          row[startCol+'_es'].value=newValueForStartDate
        }
        else row[startCol+'_es']={value:newValueForStartDate}
      }
    

    if(newValueForStartDate && new Date(newValueForStartDate)){ //update durartion Column
      if(newValueForEndDate && new Date(newValueForEndDate)){
        newValForDuration= dateDifference(newValueForStartDate,newValueForEndDate,newValForDuration)
      }
      else newValForDuration="1d"
      row[durationCol]=newValForDuration
      if(row[durationCol+'_es']){
        row[durationCol+'_es'].value=newValForDuration
      }
      else row[durationCol+'_es']={value:newValForDuration}
      row[durationCol]=newValForDuration
    }
    else if(row[durationCol]) {
      row[durationCol]=''
      if(row[durationCol+'_es']){
        row[durationCol+'_es'].value=''
      }
      else row[durationCol+'_es']={value:''}
    }
  
    return row
  }
  function returnDateInAgGridFormat(date){
    const parsedDate = new Date(date?.replace('-', '/'));
    const formattedDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}/${parsedDate.getFullYear()}`;
    const newDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}/${parsedDate.getFullYear()}`;
    return newDate
}

export function calculateDates(startDate, endDate, duration, row, startCol, endCol, durationCol,loggedInUserEmail) {
    const loggedInUser = loggedInUserEmail ||  xTablesStore.getState().gridReducer.loggedInUser
    let enddate = endDate, startdate = startDate
        if (duration) {
            const durationValue = parseInt(duration.match(/\d+/)[0]);
            const durationType = duration.match(/[a-zA-Z]+/) ? duration.match(/[a-zA-Z]+/)[0] : 'x';
            if (endDate && duration && !startDate) {
                // Calculate start date based on end date and duration
                const end = new Date(endDate);
                let start = new Date(end);

                switch (durationType) {
                    case 'd':
                    case 'D':
                        start = subtractWeekdays(end, durationValue);
                        break;
                    case 'h':
                    case 'H':
                        start = subtractWorkHours(end, durationValue);
                        break;
                    case 'w':
                    case 'W':
                        start = subtractWeekdays(end, durationValue * 5); // 1 week = 5 weekdays
                        break;
                    default:
                        duration = durationValue + 'd';
                        start = subtractWeekdays(end, durationValue);
                }

                startdate = String(start.getMonth() + 1).padStart(2, '0') + '/' + String(start.getDate()).padStart(2, '0') + '/' + start.getFullYear();
            }
            else if (startDate && duration) {
                const start = new Date(startDate);
                let end = new Date(start);


                // If startDate is a weekday, apply weekday logic
                switch (durationType) {
                    case 'd':
                        end = addWeekdays(start, durationValue);
                        break;
                    case 'D':
                        end = addWeekdays(start, durationValue);
                        break;
                    case 'h':
                        end = addWorkHours(start, durationValue);
                        break;
                    case 'H':
                        end = addWorkHours(start, durationValue);
                        break;
                    case 'w':
                        end = addWeekdays(start, durationValue * 5); // 1 week = 5 weekdays
                        break;
                    case 'W':
                        end = addWeekdays(start, durationValue * 5); // 1 week = 5 weekdays
                        break;
                    default:
                        duration = durationValue + 'd'; //
                        end = addWeekdays(start, durationValue);
                }
                enddate = String(end.getMonth() + 1).padStart(2, '0') + '/' + String(end.getDate()).padStart(2, '0') + '/' + end.getFullYear();
            }
        }
        else {
            enddate = ''
        }

    row[`${endCol}_es`] = updateCellValue(row,`${endCol}_es`,"value",enddate,loggedInUser)
    // if (row[endCol + '_es']) row[endCol + '_es'].value = enddate;
    // else row[endCol + '_es'] = {
    //     value: enddate,
    //     "attachments": [],
    //     notes: "",
    //     format: '',
    //     cellStyle: {}
    // }
    row[endCol] = enddate

    row[durationCol + '_es'] = updateCellValue(row,durationCol + '_es',"value",duration,loggedInUser)
    // if (row[durationCol + '_es']) row[durationCol + '_es'].value = duration;
    // else row[durationCol + '_es'] = {
    //     value: duration,
    //     "attachments": [],
    //     notes: "",
    //     format: '',
    //     cellStyle: {}
    // }
    row[durationCol] = duration

    row[startCol + '_es'] = updateCellValue(row,startCol + '_es',"value",startdate,loggedInUser)
    // if (row[startCol + '_es']) row[startCol + '_es'].value = startdate;
    // else row[startCol + '_es'] = {
    //     value: startdate,
    //     "attachments": [],
    //     notes: "",
    //     format: '',
    //     cellStyle: {}
    // }
    row[startCol] = startdate
    return row; // Returning the date in YYYY-MM-DD format
}


export function handleDurationUpdate(params, newValue, props, gridRef, row, col, colToEdit,loggedInUserEmail) {
   if (!colToEdit.includes("_es")) {colToEdit = colToEdit+"_es"}

    const validDurationRegex = /^(\d+)([dDhHwW])?$/;
    const { endDate, startDate } = params.colDef.linkedColumns;

    // Ensure that if newValue is just a number, it appends 'd' as the default unit
    if (newValue && /^\d+$/.test(newValue)) {
        newValue = `${newValue}d`;  // Append 'd' if no unit is provided
    }

    // Validate the new duration value
    const isInvalidDuration = newValue && (!validDurationRegex.test(newValue) || newValue.startsWith('0')|| !/^[\d]+[dDwWhH]$/.test(newValue));
    const isExceedingTwoYears = exceedsTwoYears(newValue) || newValue.length > 4;
    const {loggedInUser} =  xTablesStore.getState().gridReducer
    const oldValueIsValidDuration = params.oldValue && (!validDurationRegex.test(params.oldValue) || params.oldValue.startsWith('0') || params.oldValue.length > 4);
    // Handle invalid duration or exceeding 2 years
    if (newValue && (isInvalidDuration || isExceedingTwoYears)) {
        if (isInvalidDuration) {
            newValue='';
            props.renderAlert("Invalid Duration value entered", "error");
        } else if (isExceedingTwoYears) {
            newValue='';
            props.renderAlert("Duration value cannot exceed 2 years", "info");
        }

        // Revert to old value if the new value is invalid
        if (!col.endsWith('_es')) {
            row[col] = oldValueIsValidDuration ? "" : params.oldValue || "";
        }  
        // let oldRowData = {
        //     ...row,
        //     [colToEdit]: {
        //       ...row[colToEdit],
        //       value: params.oldValue
        //     }
        //   };
        row[colToEdit] = updateCellValue(row,colToEdit,"value",oldValueIsValidDuration ? "" : params.oldValue || "",loggedInUser)
        // if (row[colToEdit]) {
        //     row[colToEdit].value = oldValueIsValidDuration ? "" : params.oldValue || "";
        // } else {
        //     row[colToEdit] = {
        //         value: oldValueIsValidDuration ? "" : params.oldValue || "",
        //         notes: "",
        //         format: '',
        //         cellStyle: {}
        //     };
        // }
        return row;
        // // Update the grid with reverted data
        // gridRef.current.api.applyTransactionAsync({
        //     update: [row],
        // });
       
    } else {
        // Calculate the end date based on the valid duration
        if (col != startDate && col != endDate) 
        row = calculateDates(row[startDate], row[endDate], newValue, row, startDate, endDate, col,loggedInUser);
    return row
        // Update the grid with the new data
        // gridRef.current.api.applyTransactionAsync({
        //     update: [row],
        // });
    }
    // setTimeout(() => {
    //         gridRef?.current?.api?.redrawRows();
    //     }, 50)
}
function changeWholeRowAfterPasting(startDate, endDate, duration, row, startCol, endCol, durationCol, updatewholeRow,loggedInUser) {
    let enddate = endDate, startdate = startDate
    if ((!startDate && !enddate) || (enddate === '' && startDate === '')) {
        duration = duration;
    }
    else if (startDate && ((endDate && duration) || (!endDate && !duration))) {
        startdate = startDate;
    }
    else if (endDate && !duration && !startDate) {
        startdate = '', enddate = endDate, duration = '';
    }
    else if (!duration) {
        enddate = ''; duration = '';
    }
    else if ((!duration && (!startDate || !endDate)) && updatewholeRow) duration = ''
    else {
        let start = returnDateInAgGridFormat(startDate);
        let end = returnDateInAgGridFormat(start);
        start = new Date(start);
        end = new Date(end);

        const durationValue = parseInt(duration.match(/\d+/)[0]);
        const durationType = duration.match(/[a-zA-Z]+/) ? duration.match(/[a-zA-Z]+/)[0] : 'x';

        const isWeekend = (day) => day === 0 || day === 6; // 0 is Sunday, 6 is Saturday
        // If startDate is a weekday, apply weekday logic
        switch (durationType) {
            case 'd':
                end = addWeekdays(start, durationValue);
                break;
            case 'D':
                end = addWeekdays(start, durationValue);
                break;
            case 'h':
                end = addWorkHours(start, durationValue);
                break;
            case 'H':
                end = addWorkHours(start, durationValue);
                break;
            case 'w':
                end = addWeekdays(start, durationValue * 5); // 1 week = 5 weekdays
                break;
            case 'W':
                end = addWeekdays(start, durationValue * 5); // 1 week = 5 weekdays
                break;
            default:
                duration = durationValue + 'd'; //
                end = addWeekdays(start, durationValue);
        }
        enddate = end.toISOString().split('T')[0]
    }
    row[endCol + '_es'] = updateCellValue(row,endCol + '_es',"value",enddate,loggedInUser)
    // if (row[endCol + '_es']) row[endCol + '_es'].value = enddate;
    // else row[endCol + '_es'] = {
    //     value: enddate,
    //     "attachments": [],
    //     notes: "",
    //     format: '',
    //     cellStyle: {}
    // }
    row[endCol] = enddate

    row[durationCol + '_es'] = updateCellValue(row,durationCol + '_es',"value",duration,loggedInUser)
    // if (row[durationCol + '_es']) row[durationCol + '_es'].value = duration;
    // else row[durationCol + '_es'] = {
    //     value: duration,
    //     "attachments": [],
    //     notes: "",
    //     format: '',
    //     cellStyle: {}
    // }
    row[durationCol] = duration

    row[startCol + '_es'] = updateCellValue(row,startCol + '_es',"value",startdate,loggedInUser)
    // if (row[startCol + '_es']) row[startCol + '_es'].value = startdate;
    // else row[startCol + '_es'] = {
    //     value: startdate,
    //     "attachments": [],
    //     notes: "",
    //     format: '',
    //     cellStyle: {}
    // }
    row[startCol] = startdate
    return row; // Returning the date in YYYY-MM-DD format
}
function addWeekdays(startDate, days) {
    let count = 1;
    let currentDate = new Date(startDate);

    while (count < days) {
        currentDate.setDate(currentDate.getDate() + 1);
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Skip weekends
            count++;
        }
    }

    return currentDate;
}
function subtractWeekdays(startDate, days) {
    let count = 1;
    let currentDate = new Date(startDate);

    while (count < days) {
        currentDate.setDate(currentDate.getDate() - 1);
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Skip weekends
            count++;
        }
    }

    return currentDate;
}

function addWorkHours(startDate, hours, oldValue = null) {
    let currentDate = new Date(startDate);
    let remainingHours = hours;
    const startHours = currentDate.getHours();
    let totalHoursAdded = 0;

    while (remainingHours > 0) {
        const dayOfWeek = currentDate.getDay();
        const currentHour = 9;

        if (dayOfWeek !== 0 && dayOfWeek !== 6) { // Only count work hours on weekdays
            const workHoursLeftToday = 17 - currentHour; // Assuming work day ends at 5 PM
            if (remainingHours <= workHoursLeftToday) {
                currentDate.setHours(currentDate.getHours() + remainingHours);
                totalHoursAdded += remainingHours;
                remainingHours = 0;
            } else {
                currentDate.setHours(currentDate.getHours() + workHoursLeftToday);
                totalHoursAdded += workHoursLeftToday;
                remainingHours -= workHoursLeftToday;
            }
        }

        if (remainingHours > 0) {
            currentDate.setDate(currentDate.getDate() + 1);
            currentDate.setHours(9); // Reset to start of work day (9 AM)
        }
    }

    // Adjust based on oldValue if provided
    if (oldValue) {
        const oldHoursValue = parseInt(oldValue.match(/\d+/)[0]);
        const oldHoursMultiple = Math.floor(oldHoursValue / 8) * 8;
        const newHoursMultiple = Math.floor(totalHoursAdded / 8) * 8;

        if (oldHoursValue < newHoursMultiple && oldHoursValue >= oldHoursMultiple) {
            const adjustment = totalHoursAdded - oldHoursValue;
            currentDate.setHours(currentDate.getHours() - adjustment);
        }
    }

    return currentDate;
}
const updateColumn = (col) => {
    col.type = 'text'
    col.cellRenderer = CustomCellRenderer
    col.comparator = myComparator
    col.cellDataType = 'false';
    col.cellEditor = CustomCellEditor;
    col.cellEditorPopup = true;
    col.filter = CustomTextNumberFilter;
    delete col.rollup
    delete col.valueGetter

}
export const removeLinkedColumns = (columns, linkedColumns, updateColumnWithId,gridRef) => {
    let linkedColumnsBeforeUpdation =[]
    let processColumns = (columns) => {
        let startCol, endCol, durationCol, predecessorStartCol, predecessorEndCol, predecessorCol;
        let { startDate, endDate, duration, predecessorStartDate, predecessorEndDate, predecessor } = linkedColumns;
        columns.forEach((col, index) => {  
        if(col.field)   {
             switch (col.field) {
                case startDate:
                    startCol = index;
                    break;
                case endDate:
                    endCol = index;
                    break;
                case duration:
                    durationCol = index;
                    break;
                case predecessorStartDate:
                    predecessorStartCol = index;
                    break;
                case predecessorEndDate:
                    predecessorEndCol = index;
                    break;
                case predecessor:
                    predecessorCol = index;
                    break;
                default:
                    // No action needed for other fields
                    break;
            }}
        });
        
        if (startCol !== undefined && columns[startCol].linkedColumns) {
                linkedColumnsBeforeUpdation.push(JSON.parse(JSON.stringify(columns[startCol])))
            if (columns[startCol].linkedColumns.duration) delete columns[startCol].linkedColumns.duration;
            if (columns[startCol].linkedColumns.endDate) delete columns[startCol].linkedColumns.endDate;
            if (Object.keys(columns[startCol].linkedColumns).length === 0) delete columns[startCol].linkedColumns;
            updateColumnWithId(columns[startCol]);
        }
        if (endCol !== undefined && columns[endCol].linkedColumns) {
            linkedColumnsBeforeUpdation.push(JSON.parse(JSON.stringify(columns[endCol])))
            if (columns[endCol].linkedColumns.duration) delete columns[endCol].linkedColumns.duration;
            if (columns[endCol].linkedColumns.startDate) delete columns[endCol].linkedColumns.startDate;
            if (columns[endCol].linkedColumns.predecessor) delete columns[endCol].linkedColumns.predecessor;
            if (columns[endCol].linkedColumns.predecessorStartDate) delete columns[endCol].linkedColumns.predecessorStartDate;
            if (Object.keys(columns[endCol].linkedColumns).length === 0) delete columns[endCol].linkedColumns;
            updateColumnWithId(columns[endCol]);
        }
        if (durationCol !== undefined && columns[durationCol].linkedColumns) {
                linkedColumnsBeforeUpdation.push(JSON.parse(JSON.stringify(columns[durationCol])))
            if (columns[durationCol].linkedColumns.endDate) delete columns[durationCol].linkedColumns.endDate;
            if (columns[durationCol].linkedColumns.startDate) delete columns[durationCol].linkedColumns.startDate;
            if (Object.keys(columns[durationCol].linkedColumns).length === 0) delete columns[durationCol].linkedColumns;
            updateColumn(columns[durationCol])
            updateColumnWithId(columns[durationCol]);

        }
        if (predecessorStartCol !== undefined && columns[predecessorStartCol].linkedColumns) {
            linkedColumnsBeforeUpdation.push(JSON.parse(JSON.stringify(columns[predecessorStartCol])))
            if (columns[predecessorStartCol].linkedColumns.predecessorEndDate) delete columns[predecessorStartCol].linkedColumns.predecessorEndDate;
            if (columns[predecessorStartCol].linkedColumns.predecessor) delete columns[predecessorStartCol].linkedColumns.predecessor;
            if (Object.keys(columns[predecessorStartCol].linkedColumns).length === 0) delete columns[predecessorStartCol].linkedColumns;
            updateColumnWithId(columns[predecessorStartCol]);
        }
        if (predecessorEndCol !== undefined && columns[predecessorEndCol].linkedColumns) {

            linkedColumnsBeforeUpdation.push(JSON.parse(JSON.stringify(columns[predecessorEndCol])))
            if (columns[predecessorEndCol].linkedColumns.predecessorStartDate) delete columns[predecessorEndCol].linkedColumns.predecessorStartDate;
            if (columns[predecessorEndCol].linkedColumns.predecessor) delete columns[predecessorEndCol].linkedColumns.predecessor;
            if (Object.keys(columns[predecessorEndCol].linkedColumns).length === 0) delete columns[predecessorEndCol].linkedColumns;
            updateColumnWithId(columns[predecessorEndCol]);
        }
        if (predecessorCol !== undefined && columns[predecessorCol].linkedColumns) {
            linkedColumnsBeforeUpdation.push(JSON.parse(JSON.stringify(columns[predecessorCol])))
      
            if (columns[predecessorCol].linkedColumns.predecessorStartDate) delete columns[predecessorCol].linkedColumns.predecessorStartDate;
            if (columns[predecessorCol].linkedColumns.predecessorEndDate) delete columns[predecessorCol].linkedColumns.predecessorEndDate;
            if (Object.keys(columns[predecessorCol].linkedColumns).length === 0) delete columns[predecessorCol].linkedColumns;
            delete columns[predecessorCol].valueSetter
            let column = columns[predecessorCol]
            updateColumn(columns[predecessorCol]) 
            updateColumnWithId(columns[predecessorCol]);
            let rows = gridRef.current.api.getModel().rootNode.allLeafChildren
            rows.forEach((rowNode) => {
                const rowData = rowNode.data;
                if (rowData?.hasOwnProperty(column.field)) {
                    let { indexString } = getIndexesFromNodeArray(rowData[column.field], gridRef.current)
                    rowData[column.field] = indexString
                    rowData[column.field + '_es'].value = indexString
                    delete rowData.successorNodes                    ;
                    delete rowData.predecessorNodes;
                }
            })
    }
        return {columns,linkedColumnsBeforeUpdation};
    }

    return processColumns(columns);
};

export const calculateDuration = (row, durationCol, startCol, endCol, params) => {
    if (!row || !durationCol || !startCol || !endCol) return '';
    let newValForDuration = row[durationCol], newValueForEndDate = row[endCol], newValueForStartDate = row[startCol]

    if (newValueForStartDate && new Date(newValueForStartDate)) { //update durartion Column
        if (newValueForEndDate && new Date(newValueForEndDate)) {
            newValForDuration = dateDifference(newValueForStartDate, newValueForEndDate, newValForDuration)
        }
        else if (newValueForEndDate !== '') newValForDuration = "1d"
        row[durationCol] = newValForDuration
        if (row[durationCol + '_es']) {
            row[durationCol + '_es'].value = newValForDuration
        }
        else row[durationCol + '_es'] = { value: newValForDuration }
    }
    if (!newValueForStartDate && !newValueForEndDate) return ''
    return newValForDuration
}
export const convertDurationColumnToTextColumn=(column)=>{
    if(!column) return column;
    if(column.type==='duration'){
        column.type='text'
        column.cellRenderer = CustomCellRenderer
        // focusedColumn.comparator = myComparator
        column.cellDataType = 'false';
        column.cellEditor = CustomCellEditor;
        column.cellEditorPopup=true;
        column.filter=CustomTextNumberFilter;
        delete column.rollup
        if (column.cellEditorParams) {
          delete column.cellEditorParams
        }
        delete column.linkedColumns
    }
    return column;
}
export const updateDurationIfCellIsUpdatedFromCellEditStopped = (params,newVal) => {
    let linkedColumns = params.column.colDef.linkedColumns 
    const oldDateValue = params.oldValue && String(params.newValue) === String(params.value) ? params.oldValue : params.value
    let newValue = linkedColumns ? validateAndFormatDate(params, newVal, oldDateValue) : newVal
    let singlerow;
    if (linkedColumns && Object.keys(linkedColumns).length > 0) {
        let { duration, endDate, startDate } = linkedColumns
        if (startDate) {
            let rowdata = { ...params.node.data, [params.column.colDef.field]: newValue }
            singlerow = processDuration(rowdata, duration, startDate, params.column.colDef.field,params?.colDef,params?.oldValue)
        }
        else {
            let rowdata = { ...params.node.data, [params.column.colDef.field]: newValue }
            singlerow = processDuration(rowdata, duration, params.column.colDef.field, endDate,params?.colDef,params?.oldValue)
        }
    }
    else {
        singlerow = { ...params.node.data, [params.column.colDef.field]: newValue }
    }
    params.api.applyTransaction({
        update: [singlerow],
        addIndex: params.node.rowIndex
    });
    params.api.redrawRows()
}
function getUniqueElementsFromFirstArray(str1, str2) {
    if(!str1 || typeof str1!=='string') return []
    // Convert the comma-separated strings to arrays
    const array1 = str1.split(',').map(item => item.trim());
    const array2 = str2.split(',').map(item => item.trim());
  
    // Filter out elements from array1 that are not in array2
    const uniqueElements = array1.filter(item => !array2.includes(item));
  
    return uniqueElements;
  }
  
export const updatePredecessorAndSuccessorRows = (column, row, params, newVal, oldValue,rowObj) => {
    let linkedColumns = column.colDef.linkedColumns, rowsForUndo = []
    if (linkedColumns.predecessorStartDate && linkedColumns.predecessorEndDate) {
        let rowData = row
        // let predecessorNodeString=getNodesArrayFromIndex(newVal,params,row)
        let predecessorNodeString = removeDurationFromValue(newVal);
        if (predecessorNodeString === false) return false
        else {
            rowData['predecessorNodes'] = predecessorNodeString
        }
        // Add this node as a successor to other rows
        let { nodesWithSuccessorUpdated, undoRowsSuccessor } = addThisNodeAsSuccessorToOtherRows(rowData['predecessorNodes'], params, row.id,rowObj)
        if (undoRowsSuccessor != undefined)
            rowsForUndo = rowsForUndo.concat(undoRowsSuccessor)
        let updateOldValue = removeDurationFromValue(oldValue);
        // Get the difference between old and new values
        let differenceNodes = getUniqueElementsFromFirstArray(updateOldValue, predecessorNodeString)
        // Update nodesWithSuccessorUpdated with successor removed rows
        let successorRemovedRows = removeThisNodeAsSuccessorFromOtherRows(differenceNodes, params, row.id, rowsForUndo)
        nodesWithSuccessorUpdated = nodesWithSuccessorUpdated && successorRemovedRows ? nodesWithSuccessorUpdated.concat(successorRemovedRows.nodesWithSuccessorUpdated) : successorRemovedRows.nodesWithSuccessorUpdated
        return { predecessorRows: nodesWithSuccessorUpdated, currentRow: rowData, rowsForUndo: rowsForUndo || [] }

    }

}
export const getColumnByField=(gridRef, field)=>{
    if(gridRef && gridRef.current && gridRef.current.api){
        let allColumns=gridRef.current.props.columnDefs.slice();
        for(let i=0; i<allColumns.length; i++){
            if(allColumns[i].field===field) return allColumns[i]
        }
    }
}
export const getDurationFromStartCol = (startCol, gridRef) => {
    // Fetch all the columns using grid options instead
    const columnDefs = gridRef.current.props.columnDefs;
    const findColumnByField = (columns, field) => {
        for (let col of columns) {
            if (!col.children) {
                // If the field matches, return the column definition
                if (col.field === field) return col;
            } else {
                // If the column has children, search recursively
                const result = findColumnByField(col.children, field);
                if (result) return result;
            }
        }
        return null;
    };
    // Search for the column definition
    var startColDef = findColumnByField(columnDefs, startCol);
    if (startColDef && startColDef.linkedColumns && startColDef.linkedColumns.duration) {
        return startColDef.linkedColumns.duration;
    }
    return '';
}

export const exceedsTwoYears = (newValue) => {
    const durationMatch = newValue.match(/\d+/);
    const typeMatch = newValue.match(/[dDhHwW]/);

    // Check if the matches are found
    if (!durationMatch || !typeMatch) {
        return false; // Invalid format or no matches found
    }
    const durationValue = parseInt(durationMatch[0], 10);
    const durationType = typeMatch[0].toLowerCase();
  
    switch (durationType) {
        case 'd':
            return durationValue > 730; // 730 days in 2 years
        case 'w':
            return durationValue > 104; // 104 weeks in 2 years
        case 'h':
            return durationValue > 17520; // 17520 hours in 2 years
        default:
            return false;
    }
};
export function getNodeAncestors(node,parentArray=[]) { 
    if(node.parent && node.parent.id==='ROOT_NODE_ID') return parentArray
    parentArray.push(node.parent.data)
    return getNodeAncestors(node.parent,parentArray)
}
export function getNodesFromPredeceessorValueArray(value,params){
    let valueArray=value.split(","),nodes=[]
    if(valueArray.length){
        valueArray.forEach((element,index)=>{
            let ele=params.api.getRowNode(element)
            if(ele && ele.data) nodes.push(ele)
        })
        
    }
    return nodes;
}

export function checkIfColumnTypeIsAlreadyPresent(columns, type, currentColumn) {
    const isTypePresent = (columns) =>
        columns.some((column) =>
            (column.type === type && column.colId !== currentColumn) ||
            (!column.hasOwnProperty('block') && column.children?.length && isTypePresent(column.children))
        );

    return Array.isArray(columns) && isTypePresent(columns);
}

export function returnEndDateIfStartIsChanged(startCol,endCol,durationCol,row){
    let startDate =row[startCol] ? new Date(row[startCol]) :"",duration=durationCol ? row[durationCol]:''
    if(!startDate) return ""
    const start = new Date(startDate);
    let end = new Date(start);
    const durationValue = duration ===undefined || duration ==='' ||duration ===null? parseInt(dateDifference(startDate,end,duration)?.match(/\d+/)[0]): parseInt(duration?.match(/\d+/)[0]);
    const durationType =duration ? duration.match(/[a-zA-Z]+/) ? duration.match(/[a-zA-Z]+/)[0] : 'x':"x";
    if(durationValue){
        switch (durationType) {
            case 'd':
                end = addWeekdays(start, durationValue);
                break;
            case 'D':
                end = addWeekdays(start, durationValue);
                break;
            case 'h':
                end = addWorkHours(start, durationValue);
                break;
            case 'H':
                end = addWorkHours(start, durationValue);
                break;
            case 'w':
                end = addWeekdays(start, durationValue * 5); // 1 week = 5 weekdays
                break;
            case 'W':
                end = addWeekdays(start, durationValue * 5); // 1 week = 5 weekdays
                break;
            default:
                duration = durationValue + 'd'; //
                end = addWeekdays(start, durationValue);
        }
    }
    else end=maxDate(start, end)===start ?start:end
    return end ? String(end.getMonth() + 1).padStart(2, '0') + '/' + String(end.getDate()).padStart(2, '0')+ '/' +end.getFullYear() :"" ;
}
export function updateRowWithPredecessorAndSuccessors(params, validatedPredecessorValue, formattedDate, row, startDate, endDate, gridRef, undoData, setUndoStack) {
    let { currentRow, predecessorRows, rowsForUndo } = updatePredecessorAndSuccessorRows(params.column, row, params, validatedPredecessorValue, params.oldValue);
    row = currentRow
    row[startDate] = formattedDate
    rowsForUndo.push(undoData)
    let rowsToUpdate = [row]
    if (predecessorRows)
        rowsToUpdate = rowsToUpdate.concat(predecessorRows)
    // for recursibly uddate the successor node
    let { duration, predecessor, predecessorStartDate, predecessorEndDate } = params.colDef.linkedColumns
    let isPredecessorColumnEdit = true
    let result = processSuccessorNodes(row[endDate], row, params.colDef, rowsToUpdate, gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate, isPredecessorColumnEdit);
    // Merge results into parentRowsToUpdate and rowsForUndo only if they exist
    if (result?.changedSuccessorRows?.length > 0) {
        rowsToUpdate = [...rowsToUpdate, ...result.changedSuccessorRows]; // Flatten array
    }
    if (result?.undoRows?.length > 0) {
        rowsForUndo = [...rowsForUndo, ...result.undoRows]; // Flatten array
    }
    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(rowsToUpdate, gridRef, '', '')
    handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, rowsForUndo, 'id');
    setUndoStack([{ type: 'row', action: 'transaction', index: params.node.rowIndex, previousRows: rowsForUndo, cellRows: mergedRowsAfterRollupAndPredecessorChange, dontSelectCell: true }])
    params.api.applyTransactionAsync({
        update: mergedRowsAfterRollupAndPredecessorChange,
    })
}
// Helper function to update all related row dates
function updateRowValues(row, startDate, endDate, formattedDate, gridRef,loggedInUser) {
    const durationCol = getDurationFromStartCol(startDate, gridRef);
    row[startDate] = formattedDate;
    row[`${startDate}_es`] = updateCellValue(row,`${startDate}_es`,"value",formattedDate,loggedInUser)
    // row[`${startDate}_es`] = updateOrCreateObject(row[`${startDate}_es`], 'value', formattedDate);

    row[endDate] = formattedDate === '' ? '' : returnEndDateIfStartIsChanged(startDate, endDate, durationCol, row)
    row[`${endDate}_es`] = updateCellValue(row,`${endDate}_es`,"value",row[endDate],loggedInUser)
    // row[`${endDate}_es`] = updateOrCreateObject(row[`${endDate}_es`], 'value', row[endDate]);

    row[durationCol] = formattedDate === '' ? row[durationCol] : dateDifference(row[startDate], row[endDate])
    row[`${durationCol}_es`] = updateCellValue(row,`${durationCol}_es`,"value",row[durationCol],loggedInUser)
    // row[`${durationCol}_es`] = updateOrCreateObject(row[`${durationCol}_es`], 'value', row[durationCol]);
}

export function predecessorCellValidation(params, row, newValue, rowData, startDate, endDate, gridRef) {
    let validatedPredecessorValue = newValue
    let formattedDate
    const {loggedInUser} = xTablesStore.getState().gridReducer
    if (!validatedPredecessorValue) formattedDate = row[startDate]
    else {
        let rowsToProcess = getNodeListFromIdList(validatedPredecessorValue === '' ? [] : validatedPredecessorValue?.split(','), gridRef)
        let endDates = rowsToProcess.map(item => {
            let date = new Date(item.node.data[endDate + '_es']?.value);
            return isNaN(date.getTime())
                ? ''
                : new Date(increaseDateByOne(date, `${item.node.id}+${item.duration}`));
        });
        // Check if any date is invalid or empty
        // If any end date is invalid, reset all related values
        if (endDates.includes(null) || endDates.includes('') || endDates.includes(undefined)) {
            updateRowValues(row, startDate, endDate, '', gridRef,loggedInUser);
            return { formattedDate: '', validatedPredecessorValue, updatedRow: row };
        }
        // Calculate the maximum end date
        const maxDate = new Date(Math.max(...endDates.map(date => new Date(date).getTime())));
        formattedDate = dayjs(maxDate).format('MM/DD/YYYY');
        // Update row dates
        updateRowValues(row, startDate, endDate, formattedDate, gridRef,loggedInUser);
    }
    return { formattedDate, validatedPredecessorValue, updatedRow: row }

}

export const applyTransaction = (gridRef, update, addIndex) => {
    return gridRef?.current?.api?.applyTransaction({ update, addIndex });
};

export const redrawRows = (gridRef) => {
    gridRef.current.api.redrawRows();
};

export const showLoadingOverlay = (gridRef) => {
    gridRef.current.api.showLoadingOverlay();
};

export const hideLoadingOverlay = (gridRef, delay) => {
    setTimeout(() => {
        gridRef.current.api.hideOverlay();
    }, delay);
};

export const getSelectedNodes = (gridRef) => {
    return gridRef.current.api.getSelectedNodes();
};
export const getSelectedNodesFromCellRanges=(gridRef,selectedNodes,newRowData,cellRanges)=>{
    if (cellRanges && cellRanges.length > 0 && selectedNodes.length === 0) {
        let start = Math.min(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex),
          end = Math.max(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex);
        if (end - start > 0) {
          for (let i = start; i <= end; i++) {
            selectedNodes.push(newRowData[i]);
          }
        }
      }

    selectedNodes.sort((row1, row2) => parseInt(row1.rowIndex) - parseInt(row2.rowIndex));
    return selectedNodes;
}
export function getUniqueObjectsById(array) {
    const uniqueObjects = {};
    
    // Iterate through the array and update the object with the last occurrence of each id
    array.forEach(item => {
        uniqueObjects[item.id] = item;
    });

    // Convert the uniqueObjects dictionary back into an array
    return Object.values(uniqueObjects);
}
export function checkIfSelectedColumnsCanBeGrouped(selectedColIds,gridRef){
    if(!gridRef.current) return {canBeGrouped:false,truncatedSelectedColumns:selectedColIds};
    let colObj=makeColStateObj(gridRef.current.api.getAllDisplayedColumns())
         let count=0,truncatedSelectedColumns=[]
    selectedColIds.forEach(colId=>{
            if(colId!=='#' && colId!='ag-Grid-AutoColumn' && !colObj[colId]?.colDef?.parent){
                count++
                truncatedSelectedColumns.push(colId)
            }
        
    })
    return {canBeGrouped:count>1,truncatedSelectedColumns}
}
export const groupColumns=(selectedColumns,gridRef,updateColumns,addColumnToIndex,columnDefs,setColumnDefs,clickSave) => {
    let {columnGroup,childrenColumns}=makeColumnGroup(selectedColumns,gridRef)
    const newColDefsRaw = gridRef.current.props.columnDefs.slice();
    const autoGroupColumnDefRaw = gridRef.current.api.getColumnDef("ag-Grid-AutoColumn");

    let updatedColumnDefs=newColDefsRaw
    let minIndexOfColumnsToBeGrouped=newColDefsRaw.length-1
    // setTimeout(()=>{
    //     let colsAfterRemovalofSelectedOnes=removeColumnsFromGrid(childrenColumns,gridRef)
    //     setColumnDefs({colDefs:colsAfterRemovalofSelectedOnes})
    // },1000)
    updateColumns(childrenColumns)

    childrenColumns.forEach((childrenCol) => {
        let { slicedColumnDefs, colIndex } = removeAColumnFromColumnDefs(updatedColumnDefs, childrenCol.colId)
        updatedColumnDefs = slicedColumnDefs
        minIndexOfColumnsToBeGrouped = Math.min(minIndexOfColumnsToBeGrouped, colIndex)

    })
    updatedColumnDefs.splice(minIndexOfColumnsToBeGrouped, 0, columnGroup)
    gridRef.current.api.setGridOption('maintainColumnOrder',false)

    setColumnDefs({ colDefs: updatedColumnDefs,reset:'true' })
    let updatedColumnDefsForOuterLayer=[updatedColumnDefs[0],autoGroupColumnDefRaw,...updatedColumnDefs.slice(1)]
    if(clickSave)clickSave()
    setTimeout(async ()=>{
        await addColumnToIndex(minIndexOfColumnsToBeGrouped + 2, [columnGroup], '', updatedColumnDefsForOuterLayer)   
        gridRef?.current?.api?.setColumnGroupOpened(columnGroup.groupId,true);   
    },1000)
}
export const removeAColumnFromColumnDefs = (columnDefs, colToRemove) => {
    if (colToRemove === 'ag-Grid-AutoColumn') return { slicedColumnDefs:columnDefs, colIndex: 0 }
    let slicedColumnDefs = [], colIndex
    columnDefs.forEach((columnDef, index) => {
        if (columnDef?.colId && columnDef.colId !== colToRemove) slicedColumnDefs.push(columnDef)
        else colIndex = index
    })
    return { slicedColumnDefs, colIndex }
}

export function sortAscending(gridRef, undoStack, params, colId) {
    // Apply sorting state to the column
    gridRef.current.api.applyColumnState({
        state: [{ colId: colId, sort: 'asc' }],
        defaultState: { sort: null },
    });

    // Show loading overlay while sorting happens
    gridRef.current.api.showLoadingOverlay();

    // Make sure all rows are visible (expand groups if needed)
    gridRef.current.api.expandAll();

    // Delay to simulate asynchronous process (e.g., server-side sorting)
    setTimeout(() => {
        // Get the sorted data
        let rowNodes = gridRef.current.api.getModel().rootNode.allLeafChildren.map((row) => row.data);

        // Remove sorting state after fetching sorted data
        gridRef.current.api.applyColumnState({
            defaultState: { sort: null },  // Remove any sort after operation
        });

        // Redraw rows and hide overlay
        setTimeout(() => {
            gridRef.current.api.setGridOption('rowData', rowNodes);  // Reset sorted data to grid
            setTimeout(() => {
                gridRef.current.api.redrawRows();  // Redraw rows to reflect sorting
                gridRef.current.api.hideOverlay(); // Hide loading overlay
            }, 500);  // Slightly reduce the delay for better performance
        }, 500); // Adjust timeout as needed
    }, 500);  // Adjust timeout as needed
}


// Function for sorting in descending order
export function sortDescending(gridRef, undoStack, params, colId) {
    gridRef.current.api.applyColumnState({
        state: [{ colId: colId, sort: 'desc', sortable: true }],
        defaultState: { sort: null },
    });
    gridRef.current.api.showLoadingOverlay();
    gridRef.current.api.expandAll();
    setTimeout(() => {
        let rowNodes =gridRef.current.api.getModel().rootNode.allLeafChildren.map((row) => row.data);

        gridRef.current.api.applyColumnState({
            defaultState: { sort: null, sortable: false },
        });
        setTimeout(() => {
            gridRef.current.api.setGridOption('rowData', rowNodes);
                setTimeout(() => {
                gridRef.current.api.redrawRows();
                gridRef.current.api.hideOverlay();
            }, 1000);
        }, 1000);
    }, 1000);
}
export function unGroupColumn({
    gridRef, 
    undoStack, 
    params, 
    setColumnDefs, 
    updateColumnWithId, 
    deleteColumn, 
    addToRoot, 
    dontCallDeleteAPI, 
    parentColDef, 
    selectedColumns
  }) {
    
    gridRef ? gridRef.current.api.setGridOption('maintainColumnOrder',false)  : params.api.setGridOption('maintainColumnOrder',false)// for pinning primary Column
    let columnParent=recursivelyCalculateParent(params.column)
    let {childrenColumns,groupCanBeDeleted}=removeColumnFromGroup(parentColDef?parentColDef: columnParent,params.column.colId)
    let childColumn=removeGroupInfoFromColumn(params.column)
    const autoGroupColumnDefRaw =gridRef ?  gridRef.current.api.getColumnDef("ag-Grid-AutoColumn"): params.api.getColumnDef("ag-Grid-AutoColumn");
    let parentColumn
    let columnDefs=dontCallDeleteAPI ? dontCallDeleteAPI :gridRef ? gridRef.current.api.getColumnDefs(): params.api.getColumnDefs();
    let updatedColDefs=[]
    let condition = typeof columnParent === 'string' ? columnParent : columnParent.groupId
    columnDefs.forEach((col)=>{
        if(col.groupId===condition) {
            if(!groupCanBeDeleted) {
                childrenColumns=makeFirstColumnAlwaysVisibleUnderAGroup(childrenColumns)
                parentColumn={...col,children:childrenColumns}
                updatedColDefs.push(parentColumn)
            } else if (groupCanBeDeleted) {
                childrenColumns = []
                parentColumn = { ...col, children: childrenColumns }
            }
            if (addToRoot) updatedColDefs.push(childColumn.colDef); // push child column to main column array
        }
        else {
            updatedColDefs.push(col);
        }
    });

    if (addToRoot) {
        if (childColumn.colDef?.headerComponentParams) {
            delete childColumn.colDef?.headerComponentParams
            delete childColumn.colDef?.parent
        }
        updateColumnWithId(childColumn.colDef, makeColumnArrayForDB(autoGroupColumnDefRaw, updatedColDefs));
    } else if (!dontCallDeleteAPI) {
        deleteColumn({colDef:childColumn}, makeColumnArrayForDB(autoGroupColumnDefRaw,updatedColDefs) )
    }
    if(parentColumn && groupCanBeDeleted && !dontCallDeleteAPI){
        deleteColumn({colDef:parentColumn}, makeColumnArrayForDB(autoGroupColumnDefRaw,updatedColDefs) )
    }

    if (!dontCallDeleteAPI) {
      setColumnDefs({ colDefs: updatedColDefs,reset:'true' });
    }
    // Ensure we return something at the end in all cases
    return dontCallDeleteAPI ? parentColumn : updatedColDefs;
  }
  
export const changeColumnVisibilityUnderParentGroup=(hide,params,column,setColumnDefs)=>{
    let columnDefs=params.api.columnDefs
    let parentColumn=column.parent
    let updatedColumn={...column.colDef,columnGroupShow:hide?"open":"closed"}

    let childrenColumnsUpdated=column.parent.children.map((col)=>{
        if(col.colId===column.colId) return updatedColumn
        else return col.colDef
    })

    let updatedColDefs=columnDefs.map((col)=>{
        if(col.colId===parentColumn.groupId) return {...col,children:childrenColumnsUpdated}
        else return col
    })
    setColumnDefs({colDefs:updatedColDefs})

}



const colorOptions = [
      // Lighter shades of #134157
      "#1B5667",
      "#234C5D",
      "#2B4253",
      "#334849",
      "#3B3E3F",
  
      // Lighter shades of blue
      "#3333FF",
      "#4D4DFF",
      "#6666FF",
      "#8080FF",
      "#9999FF",
  
      // Lighter shades of green
      "#339933",
      "#4DA64D",
      "#66B266",
      "#80BF80",
      "#99CC99",
  
      // Lighter shades of purple
      "#993399",
      "#B34DB3",
      "#CC66CC",
      "#E680E6",
      "#FF99FF"
];
export const generateRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * colorOptions.length);
    return colorOptions[randomIndex]
};

export const removeAllColumnsOfAGroup=(group,params,setColumnDefs,deleteColumn,updateColumns, clickSave)=>{
    let columnDefs=params.api.getColumnDefs();
    let updatedColDefs=[],childrenColumns=[],groupToDelete
    let parentGroup = group
    const autoGroupColumnDefRaw =params.api.getColumnDef("ag-Grid-AutoColumn");
    columnDefs.forEach((col)=>{
        if(col.colId===parentGroup.groupId) {
            childrenColumns=col.children.map((child)=>removeGroupInfoFromColumn(child))
            updatedColDefs=[...updatedColDefs,...childrenColumns]
            groupToDelete=col
        }
        else updatedColDefs.push(col)
    })
    setColumnDefs({colDefs:updatedColDefs})
    if(clickSave)clickSave()
    setTimeout(()=>{
        deleteColumn({colDef:groupToDelete}, makeColumnArrayForDB(autoGroupColumnDefRaw,updatedColDefs) )
    },1000)
    updateColumns(childrenColumns)

}
export const findAndUpdateColumn = (columns, col, changedCol) => {
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].colId === col.colId) {
        columns[i].headerName = col.colDef.headerName;
        changedCol= columns[i];
        return changedCol;
      }
      if (columns[i].children) {
        return findAndUpdateColumn(columns[i].children, col, changedCol)
      }
    }
    return false;
  };
  export const findGroupByGroupId = (columns, groupId) => {
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].colId === groupId) {
        return columns[i];
      }
    }
    return false;
  };
export function deleteColumnGroup(
    group,
    { params, setColumnDefs, gridRef, isBlock, setUndoStack, dispatch },
    apiFunctions
) { 
    const { deleteColumnsAPIFunction, updateColumnWithId,filterMapping,setFilterMapping,clickSave} = apiFunctions;
    const isGroup = isBlock === false
    let columnDefs = params?.api?.getColumnDefs();
    const groupToDelete = !isGroup && group.parent ? group.parent : group;
    let updatedColumnDefs = deepCopy(sanitizeColumnDefs(columnDefs))
    let linkedColumnsBeforeColumnDelete = []
    let parentGroupChildren = traverseChildrenRecursivelyForColumnsWhereGroupingIsMultiLevel(groupToDelete)
    let updatedColDefs = []
    // TODO: The commented-out code is required for undo functionality. Do not remove.
    // childrenColumns = []
    // const autoGroupColumnDefRaw = params?.api?.getColumnDef("ag-Grid-AutoColumn");

    let { updatedRowData,previousRows, changedRows } = clearColumnsFromRows(gridRef, parentGroupChildren)
    parentGroupChildren.forEach(column => {
        if (column.colDef?.linkedColumns) {
            let { columns, linkedColumnsBeforeUpdation } = removeLinkedColumns(updatedColumnDefs, column.colDef.linkedColumns, updateColumnWithId, gridRef);
            updatedColumnDefs = columns
            if (linkedColumnsBeforeColumnDelete) {
                // Loop through linkedColumnsBeforeUpdation
                linkedColumnsBeforeUpdation.forEach(column => {
                    // Check if the column is not already in linkedColumnsBeforeColumnDelete
                    if (!linkedColumnsBeforeColumnDelete.some(existingColumn => existingColumn.field === column.field)) {
                        linkedColumnsBeforeColumnDelete.push(column); // Add the column
                    }
                });
            } else {
                // If linkedColumnsBeforeColumnDelete does not exist, assign linkedColumnsBeforeUpdation
                linkedColumnsBeforeColumnDelete = linkedColumnsBeforeUpdation;
            }
        }
    })
    //  let colIndex
    columnDefs.forEach((col, index) => {
        let deleteTimeSeries
        if (col.block !== undefined) {
            deleteTimeSeries = !isGroup ? true : false
        }
        let deleteGroup = isGroup && col.block === undefined && col.colId === group.groupId
        if (deleteTimeSeries || deleteGroup) {
            console.log("Deleting Groups");
            //  colIndex = index
        }
        else updatedColDefs.push(col)
    })

    if (updatedRowData?.length) {
        params?.props?.gridRef?.current?.api?.applyTransaction({ update: changedRows });
    }

    setTimeout(() => {
        setColumnDefs({ colDefs: updatedColDefs , reset:true})
    }, 100);

    const groupColDef = groupToDelete?.providedColumnGroup?.colGroupDef
        ? { colDef: groupToDelete.providedColumnGroup.colGroupDef }
        : groupToDelete;
    const colsToDelete = [groupColDef, ...parentGroupChildren];
    const updatedFilterMapping = removeDeletedColumnFilters(filterMapping, parentGroupChildren.map((column) => { return {colDef :column.colDef } }));
   if(setFilterMapping ) setFilterMapping(updatedFilterMapping)
   if(clickSave)clickSave();
   setTimeout(() => {
    deleteColumnsAPIFunction(colsToDelete, updatedColDefs);
   }, 200);
   

    // deleteColumnsAPIFunction([{ colDef: groupToDelete.providedColumnGroup.colGroupDef  }, ...parentGroupChildren], updatedColDefs)
    // let childColumnsToDeleteArray = parentGroupChildren.map(child => child.colDef)
    if (changedRows.length)
        dispatch(categorizeAndStoreUpdatedRows({ update: changedRows },gridRef))
    // setUndoStack([{ type: 'column', action: 'delete', previousRows: previousRows, cellRows: changedRows, columnsForUndo: columnDefs, columnsForRedo: updatedColDefs, autoColumnGroupDefs: autoGroupColumnDefRaw, columnsToDeleteArray: [group.providedColumnGroup.colGroupDef, ...childColumnsToDeleteArray], index: [colIndex], isGroupDeleted: true, linkedColumnsBeforeColumnDelete: linkedColumnsBeforeColumnDelete }],
    // )

}

export const clearColumnsFromRows = (gridRef, columnsToClear) => {
    let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren;
    let previousRows=[],changedRows=[];
    const updatedRows = rowData.map((row) => {
        if (row.data) {
            let dataCopy = { ...row.data }
            let isRowDataUpdated = false
            columnsToClear.forEach((column) => {
                const colName = column.colDef?.field || column.field;
                if (dataCopy[colName] !== undefined) {
                    previousRows.push(row.data)
                    
                   delete dataCopy[colName]
                   delete dataCopy[colName + '_es']
                   isRowDataUpdated = true
                }
            });
          if(isRowDataUpdated) { 
            changedRows.push(dataCopy)
        }
            return dataCopy;
        }
    });

    return {updatedRowData:updatedRows,previousRows,changedRows};
}


// Utility function to get selected rows
export const getSelectedRows = (gridRef) => {
    return gridRef.current.api.getSelectedNodes();
};

// Utility function to get focused cell
export const getFocusedCell = (gridRef) => {
    return gridRef.current.api.getFocusedCell();
};

// Utility function to get row data
export const getRowData = (gridRef) => {
    return gridRef.current.api.getModel().rowsToDisplay;
};

// Utility function to get all columns excluding "#"
export const getFilteredColumns = (gridRef) => {
    const allColumns = gridRef.current.api.getAllGridColumns();
    return allColumns.filter(item => item.colId !== "#");
};

// Function to update the global style
export const updateGlobalStyleFunction = (globalStyle, type) => {
    let temp = { ...globalStyle };
    let temp_format = temp.format;
    let temp_type = type.trim();
    temp_format[temp_type] = !temp_format[temp_type];
    temp.format = temp_format;
    return temp;
};

// Function to create cell ranges from selected rows
export const createCellRangesFromSelectedRows = ( filteredColumns, selectedCellsOrg) => {

    selectedCellsOrg = selectedCellsOrg.map(obj => ({
        ...obj,
        columns: filteredColumns
    }));

    return selectedCellsOrg;
};

// Function to determine if all rows are selected
export const areAllRowsSelected = (data, selectedRows, selectedCells) => {
    return (data.length === selectedRows.length) || 
           (selectedCells[0] && data.length - 1 === Math.max(selectedCells[0].startRow.rowIndex, selectedCells[0].endRow.rowIndex) - Math.min(selectedCells[0].startRow.rowIndex, selectedCells[0].endRow.rowIndex));
};

// Function to format a cell
export const formatCell = (cellRow, colId, type) => {
    const format = cellRow[colId]?.format;
    let newFormat = cellRow[colId]?.format || "";
    const isTypeIncluded = format?.includes(type);
    const isUntypeIncluded = format?.includes(`UN${type.toUpperCase().trim()}`);
    if (isTypeIncluded) {
        if (newFormat.includes("underline") || newFormat.includes("strikethrough")) {
            newFormat = newFormat.replace(" strikethroughandunderline ", "");
        }
        newFormat = newFormat.replace(type, "");
        newFormat = newFormat + ` UN${type.toUpperCase().trim()} `;
    } else if (isUntypeIncluded) {
        newFormat = newFormat.replace(` UN${type.toUpperCase().trim()} `, "");
        newFormat = newFormat + type;
        if (newFormat.includes("underline") && newFormat.includes("strikethrough")) {
            newFormat += " strikethroughandunderline ";
        }
    } else {
        newFormat = newFormat + type;
        if (newFormat.includes("underline") && newFormat.includes("strikethrough")) {
            newFormat += " strikethroughandunderline ";
        }
    }
    if (cellRow[colId]) {
        // If the cell exists, update its format
        cellRow[colId].format = newFormat;
    } else {
        // If the cell doesn't exist, create it with the new format
        cellRow[colId] = { format: newFormat };
    }
    return newFormat;
};

// Function to update selected cells
export const updateSelectedCells = (selectedCells, gridRef, focusedCell, focusedColumn, cellRow, undoRow_focused, type, newFormat, previousRows, cellRows, addIndex) => {
    selectedCells.forEach((cellRange) => {
        const { columns, startRow, endRow } = cellRange;
        for (let rowIndex = Math.min(startRow.rowIndex, endRow.rowIndex); rowIndex <= Math.max(startRow.rowIndex, endRow.rowIndex); rowIndex++) {
            let row = rowIndex;
            let data = gridRef.current.api.getModel().rootNode.allLeafChildren;
            let cellRow_selected;
            let undoRow;
            if (focusedCell && rowIndex === focusedCell.rowIndex) {
                cellRow_selected = cellRow;
                undoRow = undoRow_focused;
            } else {
                cellRow_selected = data[rowIndex].data;
                undoRow = JSON.parse(JSON.stringify(cellRow_selected));
            }

            for (const column of columns) {
                if (!focusedColumn || !(rowIndex === focusedColumn.rowIndex && column.colDef.field === focusedColumn.colDef.field)) {
                    let colId_selected = column.colDef.field + "_es";
                    const format_selected = cellRow_selected[colId_selected]?.format || "";
                    let newFormat_selected = cellRow_selected[colId_selected]?.format || "";
                    if (column.colDef.field !== "#") {
                        if (newFormat.includes(type)) {
                            if (!newFormat_selected.includes(type)) {
                                newFormat_selected = format_selected === "" ? type : format_selected + type;
                                newFormat_selected = newFormat_selected.replace(` UN${type.toUpperCase().trim()} `, "");
                            }
                        } else if ( !newFormat.includes(type)) {
                            if (newFormat_selected.includes(type)) {
                                newFormat_selected = newFormat_selected.replace(type, `UN${type.toUpperCase().trim()}`);
                            }
                        }
                        if (newFormat_selected.includes("strikethroughandunderline")) {
                            newFormat_selected = newFormat_selected.replace(" strikethroughandunderline ", "");
                        }
                        if (newFormat_selected.includes("underline") && newFormat_selected.includes("strikethrough")) {
                            newFormat_selected += " strikethroughandunderline ";
                        }

                        if (cellRow_selected[colId_selected]?.format !== undefined) {
                            cellRow_selected[colId_selected].format = newFormat_selected;
                        } else {
                            cellRow_selected[colId_selected] = { format: newFormat_selected };
                        }
                    }
                }
            }

            previousRows.push(undoRow);
            cellRows.push(cellRow_selected);
            addIndex.push(row);
        }
    });
};

export function updateChildOfParentColumn(parentColumn,childColumn) {
    if(!parentColumn || !childColumn || parentColumn.children.length === 0) return false;

    let parentColDef= recursivelyCalculateParent(parentColumn)?.providedColumnGroup?.colGroupDef
    let childColumnIndex = parentColDef.children.findIndex(child => child.colId === childColumn.colId);
    if(childColumnIndex === -1) return false;
    parentColDef.children.splice(childColumnIndex, 1, childColumn);
    return parentColDef
}
export function getIndexOfColumn(columns,selectedColumn){
    return columns.findIndex(col=>col.colId === selectedColumn.colId);
}

export const expandAllColumnGroups = (api) => {
    api.getColumnDefs().forEach(col => {
      if (col.children) {
        api.setColumnGroupState([{ groupId: col.colId, open: true }]);
      }
    });
};

export const collapseAllColumnGroups = (api) => {
    api.getColumnDefs().forEach(col => {
      if (col.children) {
        api.setColumnGroupState([{ groupId: col.colId, open: false }]);
      }
    });
};

export const getColumnOrderArray = (columns, autoColumnGroupDef) => {
    let newColDefs = [];
    let columnOrder = [];
    let columnOrderSet = new Set();
    let newColDefsSet = new Set();

    // Helper function to process a column and its children recursively
    const processColumn = (column) => {
        if (!columnOrderSet.has(column.columnElasticid)) {
            columnOrderSet.add(column.columnElasticid);
            columnOrder.push(column.columnElasticid);
        }

        if (!newColDefsSet.has(column)) {
            newColDefsSet.add(column);
            newColDefs.push(column);
        }

        if (column.children) {
            column.children.forEach(child => {
                processColumn(child); // Recursively process each child
            });
        }
    };

    // Process each top-level column
    columns?.forEach(column => {
        processColumn(column);
    });

    // Handle autoColumnGroupDef if provided
    if (autoColumnGroupDef) {
        if (!columnOrderSet.has(autoColumnGroupDef.columnElasticid)) {
            columnOrderSet.add(autoColumnGroupDef.columnElasticid);
            columnOrder.splice(1, 0, autoColumnGroupDef.columnElasticid);
        }

        if (!newColDefsSet.has(autoColumnGroupDef)) {
            newColDefsSet.add(autoColumnGroupDef);
            newColDefs.splice(1, 0, autoColumnGroupDef);
        }
    }
    return { columnOrder, newColDefs };
};

export const makeFirstColumnAlwaysVisibleUnderAGroup=(childrenColumns) =>{
    return childrenColumns.map((column,index) => {
        let currentColumn=column.colDef || column
        if(index === 0) delete currentColumn.columnGroupShow
        else currentColumn.columnGroupShow='open'
        return currentColumn
    })
}
export const expandAndFlattenColumnArray=(columnDefs) =>{ 
    if(!columnDefs || columnDefs.length==0) return [];
    let flattenedColumns=[];
    columnDefs.forEach(column => {
        flattenedColumns.push(column);
        if (column.children) {
            let childrenList=column.children
            flattenedColumns = flattenedColumns.concat(childrenList);
        }
    });
    return flattenedColumns
}
export const findStartColumnAndEndColumnForDuration = (columnDefs, durationInfo) => {
    let startColumn, endColumn;
    const flattenedColumns = [];
  
    for (let i = 0; i < columnDefs.length; i++) {
      const column = columnDefs[i];
      flattenedColumns.push(column);
  
      if (column.headerName === durationInfo.startDate) {
        startColumn = column;
      }
      if (column.headerName === durationInfo.endDate) {
        endColumn = column;
      }
  
      if (column.children) {
        for (let j = 0; j < column.children.length; j++) {
          const child = column.children[j];
  
          if (child.headerName === durationInfo.startDate) {
            startColumn = child;
          }
          if (child.headerName === durationInfo.endDate) {
            endColumn = child;
          }
          if(startColumn && endColumn) return { startColumn: startColumn, endColumn: endColumn };
        }
      }
      if(startColumn && endColumn) return { startColumn: startColumn, endColumn: endColumn };
    }
  
    return { startColumn: startColumn, endColumn: endColumn };
  };
  //make a fucnction that takes a date and tells if it is less than an hour
    export const HighlightBasedOnTimeRange=(date)=>{
        let {gridInitializationTime,highlight,timeRange,customDate} = xTablesStore.getState().gridReducer
        if(!highlight) return false
        const currentTime = new Date(gridInitializationTime) ;
        const inputTime = new Date(date);
        switch (timeRange) {
            case "LastHour":
                // Highlight if the change occurred in the last hour
                const oneHourInMilliseconds = 60 * 60 * 1000;
                return currentTime - inputTime <= oneHourInMilliseconds;
    
            case "Today":
                // Highlight if the change occurred on the same day (from midnight to now)
                const startOfToday = new Date();
                startOfToday.setHours(0, 0, 0, 0); // Set time to 12:00 AM
                return inputTime >= startOfToday;
    
            case "ThisSession":
                // Highlight if the change occurred since the grid was initialized
                const sessionStartTime = new Date(gridInitializationTime);
                return inputTime >= sessionStartTime;

            case "Custom":
                const startDate = new Date(customDate);
                return inputTime >= startDate && inputTime <= new Date();
            default:
                return false; // No highlighting if no valid option is selected
        }
        const timeDifference = inputTime - currentTime; // Difference in milliseconds
        console.log(inputTime,currentTime,timeDifference)
        return timeDifference>0
        const oneHourInMilliseconds = 60 * 60 * 1000; // 1 hour = 60 minutes * 60 seconds * 1000 milliseconds

        return timeDifference < oneHourInMilliseconds;
    }
  export function getCellClass(params,selectedColumns){
    if(params.colDef.field==='#') return 'HashColumn';
    let isWeekend=false
    if(params.colDef.block && params.colDef.parent){
        let day=new Date(params.colDef.field).getDay()
        isWeekend=day===0 || day===6
    }
    let classArray=["global-style"]
    if(isWeekend) classArray.push('weekend')
    let cellObj =  params?.data && params.data[params.colDef.field + "_es"]
    if (cellObj) {
        classArray=[...classArray,params.data[params.colDef.field + "_es"].format]
    }
    //if(selectedColumns && selectedColumns.includes(params.column.colId)) classArray.push('columnSelected')
    return classArray
  }
export const getCellStyle = (params) => {
    let styles = {}
    let { color } = xTablesStore.getState().gridReducer
    if (params.data) {
        let cellInfo = { ...params.data[params.colDef.field + "_es"] }
        if (cellInfo && cellInfo.cellStyle && typeof cellInfo.cellStyle === 'object') {
            styles = cellInfo.cellStyle
        }
        if (cellInfo.updatedDate && HighlightBasedOnTimeRange(cellInfo.updatedDate)) styles = { ...styles, backgroundColor: color }
        return styles
    }
    return styles
};
export function SetTimeSeriesColumnProperties(columnDef, valueChangedByValueGetter,childIndex, listData) {
    let highlightTScellOnFilter = JSON.parse(localStorage.getItem("highlightTSCellState") || '{}');

    columnDef.editable = true;
    columnDef.cellRenderer = 'multiDimensionalColumnRenderer';
    columnDef.cellDataType = false;
    columnDef.cellClassRules= {
        'highlighted-ts-cell': (params) => {
          return (
            params.colDef.block === "timeseries" &&
            highlightTScellOnFilter?.[params.node.sourceRowIndex]?.includes(
              params.colDef.field + "_es"
            )
          );
        },};
    columnDef.cellEditor = 'multiDimensionalValueTypeEditor';
    columnDef.cellEditorPopup = true;
    if (childIndex != undefined) {
        if (childIndex == 0) delete columnDef.columnGroupShow
        else columnDef.columnGroupShow = 'open'
    }
    columnDef.type = 'multi dimensional value';
    columnDef.suppressMovable=false

    if (!columnDef.width) columnDef.width = 200;
    if (columnDef.cellEditorParams) delete columnDef.cellEditorParams;
    if (!columnDef.listData) columnDef.listData = listData && listData.length > 0 ? listData : timeSeriesChildColumnListData;
    else{
        columnDef.listData= Array.isArray(columnDef.listData) ? JSON.stringify(columnDef.listData) : columnDef.listData
    }
    columnDef.editable= columnDef.editable === false ? false : (params) =>  makeParentCellNotEditable(params, columnDef)
    // columnDef.valueGetter = (params) => {
    //     // if (params.data && params.node.childrenAfterAggFilter && params.node.childrenAfterAggFilter.length) {
    //     //     let oldValue = params?.data[params.colDef.field]
    //     //     if (oldValue)
    //     //         oldValue = JSON.parse(JSON.stringify(oldValue))

    //     //     let newValue = getParentMDVValueAsRollUp(params.node, params.colDef.field, params.colDef?.rollup, params)
    //     //     if (newValue !== oldValue && typeof valueChangedByValueGetter === 'function')  valueChangedByValueGetter(params.node, params.colDef.field, newValue, params);

    //     //     return newValue
    //     // }

    //     // else 
    //     if (params.data && params.colDef.field in params.data) return params?.data[params.colDef.field];
    // }
    columnDef.cellStyle = getCellStyle
}
export function SetTotalTimeSeriesColumnProperties(columnDef, coldefObj) {
    columnDef.editable = false;
    // if (!columnDef.listData)
     columnDef.listData = timeSeriesChildColumnListData;
    delete columnDef.columnGroupShow
    columnDef.suppressMovable=false
    let parentBlock = coldefObj[columnDef?.parent]?.block;
    if (parentBlock && parentBlock.length) {
        parentBlock = JSON.parse(parentBlock);
        let start = new Date(parentBlock.startDate);
        let end = new Date(parentBlock.endDate);

        // columnDef.valueGetter = (params)=>valueGetterForTotalTimeSeriesColumn(params,start,end)
    }
}
export const getFilteredRowIds = (gridRef) => {
    let filteredRowIds = [];
    gridRef.current.api.forEachNodeAfterFilter((node) => {
        filteredRowIds.push(node.data.id); 
    });
    return filteredRowIds;
};
export const createListObject = (listArray, currentSheetId, user, accessLevel, listName) => {
    let listObj = {
        id: uuidv4(),
        name: listName,
        options: processListValues(listArray),
        sheetid: currentSheetId,
        ispublic: false,
        accesslevel: accessLevel,
        created_date: new Date(),
        user_email: user,
        type: null,
        rollup: false
    }
    return listObj
}

export const processListValues=(listValues)=>{
    const transformedList = listValues.map(val => ({ value:val }));
    return JSON.stringify(transformedList);
}

export const updateOrCreateFilterMapping = (
    prevMapping,
    filterIdToMatch,
    filterName,
    filters,
    isPublic,
    setCurrentFilter,
    owner,
    operators,
    splitView
) => {
    const index = prevMapping.findIndex(filter => filter.id === filterIdToMatch);

    if (index !== -1) {
        
        const updatedMapping = [...prevMapping];
        updatedMapping[index] = {
            ...updatedMapping[index],
            filterName: filterName,
            filters: filters,
            isPublic: isPublic,
            operators: operators,
            splitView:splitView
        };
        
        setCurrentFilter(updatedMapping[index]);

        return updatedMapping;
    } else {
        
        const newFilter = {
            id : Date.now(), 
            filterName : filterName,
            filters : filters,
            isPublic : isPublic,
            owner : owner,
            operators: operators,
            splitView:splitView
        };
        
        if (prevMapping.length === 1 && prevMapping[0].filterName === '') {
            
            setCurrentFilter(newFilter);
            return [newFilter];
        }
        
        const updatedMapping = [...prevMapping, newFilter];
        setCurrentFilter(newFilter);

        return updatedMapping;
    }
};

export const extendValuesToWholeRow = async (valuesToBeExtended, cellData, params, gridRef) => {
    const {loggedInUser} =   xTablesStore.getState().gridReducer

    let updatedRow = JSON.parse(JSON.stringify(params.data))
    let columns = params.api.getColumnDefs()
    //find task end date column and value

    let endDateColumnField = findEndDateColumnField(columns)
    let endDateValue = updatedRow[endDateColumnField]
    let updatedCellData = JSON.parse(JSON.stringify(cellData));
    let startDateColumnField = findStartDateColumnField(columns)
    let startDateValue = updatedRow[startDateColumnField]

    if (endDateColumnField && endDateValue) {
        //find all visible columns from current date till enddate
        let { allTimeSeriesFieldsTillEndDate, rollupColumns, isTimeSeriesTotalColumnPresent } = await findAllTimeSeriesColumnFieldsTillSpecifiedEndDate(params.column.parent.parent, startDateValue, endDateValue)

        if (allTimeSeriesFieldsTillEndDate && allTimeSeriesFieldsTillEndDate.length) {
            allTimeSeriesFieldsTillEndDate.forEach((field) => {
                let cellValue = updatedRow[field]
                if (!cellValue) cellValue = timeSeriesChildColumnListData
                else cellValue = JSON.parse(cellValue)
                valuesToBeExtended.forEach((indice) => {
                    cellValue[indice] = updatedCellData[indice]
                })
                cellValue = JSON.stringify(cellValue)
                updatedRow[field] = cellValue
                updatedRow[`${field}_es`] = updateCellValue(updatedRow,`${field}_es`,"value",cellValue,loggedInUser)
                // updatedRow[field + '_es'] = updateOrCreateObject(updatedRow[field + '_es'], "value", cellValue)
            })

            const TimeSeriesParent = gridRef.current.api.getColumnGroup(isTimeSeriesTotalColumnPresent.parent)
            if (isTimeSeriesTotalColumnPresent) {
                let { rowUpdatedWithTotal, totalColumn } = updateTotalIfValueIsChanged(TimeSeriesParent.providedColumnGroup.colGroupDef, isTimeSeriesTotalColumnPresent, '', updatedRow, '', '')
                updatedRow = rowUpdatedWithTotal
            }
            const result = parentRowsAferRollup([updatedRow], gridRef, '', '', rollupColumns)

            let mergedRowsAfterRollupAndPredecessorChange = result.mergedRowsAfterRollupAndPredecessorChange;
            params.api.applyTransactionAsync({
                update: mergedRowsAfterRollupAndPredecessorChange,
            })
        }
        else {
            renderAlert("There are no timeseries columns that include this range ", 'error')
        }
    }
    else {
        renderAlert("Cannot copy values as this row does not have any end Date ", 'error')
    }
}

export const getStartAndEndDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
  
    // Get the Monday of the current week
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const daysSinceMonday = (dayOfWeek + 6) % 7; // Calculate days since the last Monday
    const startDate = new Date(today);
    startDate.setDate(today.getDate() - daysSinceMonday);
    startDate.setHours(0, 0, 0, 0);
  
    // Get the last date of the current month
    const endDate = new Date(year, month + 1, 0);
  
    return {
      startDate: startDate,
      endDate: endDate,
    };
  };
      
export const valueChangedByValueGetter = (node, col, newValue, params, predecessorCellValue,valuechangebyvalueSetter) => {
    let data = node.data;
    let oldValue = data[col] || ""
    let undoData = { ...node.data }
    data[col] = newValue;
    if (data[col + '_es']) data[col + '_es'].value = newValue;
    else data[col+'_es'] = {
        value: newValue
    };
    let { duration, endDate, predecessor, predecessorEndDate } = params?.colDef?.linkedColumns || {};
    const hasPredecessor = predecessor !== undefined && predecessor !== '' && predecessor !== null;
    const hasDuration = duration !== undefined && duration !== '' && duration !== null;

    // Handle duration and predecessor updates 
    const sourceNotRange = params.source !== 'rangeService' && params.source !== undefined;
    if (oldValue != newValue && hasDuration && hasPredecessor) {
        data = processDuration(params.data, duration, col, endDate, params?.colDef,params?.oldValue)
    }
    if (hasPredecessor && predecessorCellValue) {

        const linkedPredecessor = params.colDef.linkedColumns.predecessor;

        data[predecessor] = sourceNotRange ? predecessorCellValue : data[linkedPredecessor];
        if (data[predecessor + '_es']?.value) {
            data[predecessor + '_es'].value = sourceNotRange ? predecessorCellValue : data[linkedPredecessor];
        }
    }
    let childrenPresent = node.allChildrenCount > 0
    // Group calls by row if no previous value getter changed calls
    if (cellValueCallbackArray.current.valueGetterChangedCalls.length === 0) {
        setTimeout(() => {
            let { undoRows, updatedRows, firstRowIndex } = groupPasteCallsByRow(cellValueCallbackArray, gridRef, params?.source)
            if (undoRows.length > 0) setUndoStack([{ type: 'row', action: 'transaction', index: firstRowIndex, previousRows: undoRows, cellRows: updatedRows, dontSelectCell: true }])
        }, [1000])
    }


    const shouldTrackChange = sourceNotRange && hasPredecessor || params.colDef?.block || oldValue !== newValue;
    if (Array.isArray(valuechangebyvalueSetter)) {
        valuechangebyvalueSetter.forEach((setterValue) => {
            cellValueCallbackArray.current.calls.push({
                row: setterValue.row,
                undoRow: setterValue.undoRow,
                childrenParentnode: node.allChildrenCount > 0,
            });
        });
    }
  
      else  if (shouldTrackChange) {
        cellValueCallbackArray.current.valueGetterChangedCalls.push({
            row: data,
            undoRow: {
                id: node.data.id,
                column: col,
                value: oldValue || "",
                rowData: undoData,
                index: node.rowIndex,
            },
            childrenParentnode: node.allChildrenCount > 0,
        });
    }
}


export const returnSharedWorkbookObject = (workbookId, userData, sheetList) => async(dispatch)  =>{
    try {
        const checkIfWorkbookIsShared = await dispatch(getAccessInfoByEntityId(workbookId));
        let loggedInUserInfo;
        if (!userData) {
            loggedInUserInfo = await getLoggedInUser();
         }else{
           loggedInUserInfo = userData;
        }
        
        if(checkIfWorkbookIsShared && loggedInUserInfo){
            let access = checkIfWorkbookIsShared.find(wbInfo => wbInfo.user_id === loggedInUserInfo?.email);
            if(access){
            const sharedWbObj = formatSharedWbObject(access, sheetList);
            return sharedWbObj
        }
        }
        return null;
    } catch (error) {
        console.log("Error in returnSharedWorkbookObject", error);
    }
}

export const getAccessInfoByWorkbook = async (workbookId, userData, dispatch) => {
    try {
        const checkIfWorkbookIsShared = await getAccessInfoByEntityIdFprManageAccess(workbookId);
        let loggedInUserInfo;
        if (!userData) {
            loggedInUserInfo = await getLoggedInUser();
         }else{
           loggedInUserInfo = userData;
        }
        
        if(checkIfWorkbookIsShared && loggedInUserInfo){
            let access = checkIfWorkbookIsShared.find(wbInfo => wbInfo.user_id === loggedInUserInfo?.email);
            if(access){
                dispatch(setAccessByEntityId(checkIfWorkbookIsShared));
            return access;
        }
        }
        return {};
        
    } catch (error) {
        console.log("Error in returnSharedWorkbookObject", error);
    }
}

const ensureRowIsProcessed = (processedRows, child) => {
    if (!processedRows[child.id]) {
        delete processedRows[child.id]
        processedRows[child.id]=child
    }
  }; 
export const updateChildStatus = (child, col, listData, rowNodes, statuses, processedRows, loggedInUser, defaultStatus,isParent) => {
    let childStatus = parseRowData(child[col])
    if (isParent) {
        statuses.push(childStatus);
        ensureRowIsProcessed(processedRows, child);
    }

    else {
        if (!childStatus || childStatus?.rowId === 'None') {
            const backlogItem = defaultStatus ? defaultStatus : listData.find(item => item.parent === 'Default Status' && item.rowId === 'None');
            if (backlogItem && ((child["primaryCol_es"]?.value && child["primaryCol_es"]?.value.trim() !== ''))) {
                let rowData = { rowId: backlogItem.rowId, value: backlogItem.value }
                resetCell(child, col, rowNodes, loggedInUser, JSON.stringify(rowData));
                childStatus = rowData
            }
        }
        let newValue = '';

        if (childStatus?.rowId) {
            let listDataItem = listData.find(item => item.rowId === childStatus.rowId);
            if (listDataItem && listDataItem.value !== childStatus.value) {
                updateNodeData(child, col, childStatus, listDataItem.value, rowNodes, loggedInUser);
                statuses.push({ rowId: childStatus.rowId, value: listDataItem.value });
            } else if (listDataItem && listDataItem.value === childStatus.value) {
                statuses.push(childStatus);
            }
            else {
                resetCell(child, col, rowNodes, loggedInUser);
                statuses.push('')
            }
        } else if (childStatus && childStatus?.parentMaxPrecedence === null && childStatus?.parentMaxPrecedence === '' && childStatus.parentMinPrecedence === null && childStatus.parentMinPrecedence === '') {
            let listDataItem = listData.find(item => item.value === childStatus);
            if (listDataItem) {
                statuses.push({ rowId: listDataItem.rowId, value: listDataItem.value });
                child[col] = JSON.stringify({ rowId: listDataItem.rowId, value: listDataItem.value });
                child[col + '_es'] = updateCellValue(child, col + '_es', "value", child[col]);
            }
            else if (newValue !== childStatus) {
                resetCell(child, col, rowNodes, loggedInUser);
                statuses.push('');
            }

        } else {
            statuses.push(childStatus);
        }
        ensureRowIsProcessed(processedRows, child);
    };
}

const updateStatusRecursively = (node, col,listData,precedenceMapping,rowNodes,processedRows,loggedInUser,defaultStatus) => {
    if (!node || !node.childrenAfterGroup || node.childrenAfterGroup.length === 0) {
        return;
    }
    // First, update all children recursively
    node.childrenAfterGroup.forEach((childNode) => {
        if(!processedRows[childNode.data.id])
        updateStatusRecursively(childNode, col,listData,precedenceMapping,rowNodes,processedRows,loggedInUser,defaultStatus);
    });

    // Now, update the parent node after updating all children
    let statuses = [];
    node.childrenAfterGroup.forEach((child) => {
        if (child.data && col in child.data) {
            if (!processedRows[child.data.id]) {
                updateChildStatus(child.data, col, listData, rowNodes, statuses,processedRows,loggedInUser,defaultStatus);
            }
            else {
                let updatedChild = processedRows[child.data.id]
                let isParent= child.allChildrenCount>0
                updateChildStatus(updatedChild, col, listData, rowNodes, statuses, processedRows, loggedInUser,defaultStatus,isParent);
            }
        }
        else {
            if (child.data["primaryCol_es"]) {

                const backlogItem = defaultStatus ?defaultStatus :listData.find(item => item.parent === 'Default Status'&& item.rowId === 'None');
                if (backlogItem && ((child.data["primaryCol_es"]?.value && child.data["primaryCol_es"]?.value.trim() !== ''))) {
                 let rowData = { rowId: backlogItem.rowId, value: backlogItem.value }
                resetCell(child.data, col, rowNodes,loggedInUser,JSON.stringify(rowData));
                    statuses.push(rowData)
                }
            }
            else statuses.push('')
        }
    });

    // Determine the new status for the parent based on children's statuses
    let parentStatus = statuses.length > 0 ? determineParentRollupStatus(statuses, precedenceMapping, listData) : ""; 
    node.data[col] = parentStatus
    node.data[col + '_es'] = updateCellValue(node.data, col + '_es', "value", parentStatus,loggedInUser)
 
    if(rowNodes)rowNodes.push(node.data)
    processedRows[node.data.id]=node.data
};
export const parseRowData = (rowData) => {
    if (typeof rowData === 'string' && rowData.startsWith('{')) {
        try {
            let parsedValue = JSON.parse(rowData);
            return (
                parsedValue.rowId != null ||
                (
                    parsedValue.parentMinPrecedence != null && parsedValue.parentMinPrecedence !== '' &&
                    parsedValue.parentMaxPrecedence != null && parsedValue.parentMaxPrecedence !== ''
                )
            )
                ? parsedValue
                : parsedValue.value;
        } catch (e) {
            console.error("Error parsing rowData:", e);
            return null;
        }
    }
    return rowData;
};


export const updateNodeData = (child, col, rowData, newValue, rowNodes,loggedInUser) => {
    child[col] = JSON.stringify({ rowId: rowData.rowId, value: newValue });
    child[col + '_es'] = updateCellValue(child, col + '_es', "value", child[col],loggedInUser);
    if(rowNodes) rowNodes.push(child);
}; 
export const resetCell = (nodeData, col, rowNodes,loggedInUser , value='') => {
    nodeData[col] = value;
    nodeData[col + '_es'] = updateCellValue(nodeData, col + '_es', "value", value,loggedInUser);
   if (rowNodes) rowNodes.push(nodeData);
  }; 
const processLeafNode = (node, col, listData, rowNodes, processedRows,loggedInUser,defaultStatus) => {
    const backlogItem = defaultStatus?defaultStatus: listData.find(item => item.parent === 'Default Status'&& item.rowId=='None');
    if (!node.data || !(col in node.data) || !node.data[col]){
       
        if (backlogItem && ((node.data["primaryCol_es"]?.value && node.data["primaryCol_es"]?.value.trim() !== ''))) {
            let rowData= { rowId: backlogItem.rowId, value: backlogItem.value }
            resetCell(node.data, col, rowNodes,loggedInUser, JSON.stringify(rowData));
        }
    }
    processedRows[node.data.id]=node.data
    let rowData = parseRowData(node.data[col]);
    if (!rowData||rowData?.rowId==='None') {
        if (backlogItem && ((node.data["primaryCol_es"]?.value && node.data["primaryCol_es"]?.value.trim() !== ''))) {
            rowData = JSON.stringify({ rowId: backlogItem.rowId, value: backlogItem.value });
            resetCell(node.data, col, rowNodes,loggedInUser,rowData);
        }
    }
    let newValue = '';

    if (rowData?.rowId) {
        let listDataItem = listData.find(item => item.rowId === rowData.rowId);
        if (listDataItem && listDataItem.value !== rowData.value) {
            updateNodeData(node.data, col, rowData, listDataItem.value, rowNodes,loggedInUser);
        }else if(!listDataItem){
            resetCell(node.data, col, rowNodes,loggedInUser);
        }
    } else {
        let listDataItem = listData.find(item => item.value === rowData);
        if (listDataItem) newValue = listDataItem.value;

        if (newValue !== rowData) {
            if (backlogItem && ((node.data["primaryCol_es"]?.value && node.data["primaryCol_es"]?.value.trim() !== ''))) {
                rowData = JSON.stringify({ rowId: backlogItem.rowId, value: backlogItem.value });
            resetCell(node.data, col, rowNodes,loggedInUser,rowData);
        }else{
            resetCell(node.data, col, rowNodes,loggedInUser);
        }
        }
    }
};        
function updateColDefRecursively(columns, updatedColDef) {

    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];
      const colId = col.colId || col.field;
      if (colId === (updatedColDef.colId || updatedColDef.field)) {
        columns[i] = updatedColDef;
        return columns; // Found and updated

      }

      // If column has children, search recursively
      if (Array.isArray(col.children)) {
        const found = updateColDefRecursively(col.children, updatedColDef);
        if (found) return columns;
      }
    }
  
    return columns; // Not found
  }
export const handleStatusRecalulation = async (params, colDef, dispatch,setUndoStack,loggedInUser,updateColumnWithId,autoColumnGroupDefs,saveRowsViaUserActivity,setColumnDefs,newSheetSetColumnDefs) => {
    let rowNodes = []
    let { listData, precedenceMapping } = generateListDataForRollupStatus(JSON.parse(colDef.listData));
    let col = colDef.field
    if(colDef.headerComponentParams){
        delete colDef.headerComponentParams
    }
    let processedRows = {};
    let defaultStatus = colDef?.defaultStatus ?JSON.parse(colDef?.defaultStatus):{
        value: 'Backlog',
        parent: 'Default Status',
        precedence: '0:0',
        rowId: 'None',
    }
    let defaultItem= findDefaultItem(listData, defaultStatus)
    // Now push the updated backlogItem
    if (!defaultItem) {
        listData.push(defaultStatus);
    } else {
        defaultStatus = defaultItem
    }

    // listData.push(backlogItem)
    params?.api?.forEachNode(function (node) {
        if (processedRows[node.data.id]) {
            return;
        }
        if (node.childrenAfterGroup.length > 0) {
            updateStatusRecursively(node, col, listData, precedenceMapping, rowNodes, processedRows,loggedInUser,defaultStatus);
        } else {
            processLeafNode(node, col, listData, rowNodes, processedRows,loggedInUser,defaultStatus);
        }
    }
    )
    params?.api?.applyTransaction({
        update: rowNodes,
    })
    setUndoStack([])
    let newColDefs = params.api.getColumnDefs().map(col => {
        const { headerComponentParams, headerGroupComponentParams, ...safeCol } = col;
        return { ...safeCol };
      });    
    colDef.lastSyncedTimestamp = new Date()
    colDef.defaultStatus= JSON.stringify(defaultStatus)
    dispatch({ type: XTABLES_ACTION_TYPES.SET_STATUSCOLUMN_STATE, statusColumnRollupInfo: { listData, precedenceMapping } })
    dispatch(  {
        type: XTABLES_ACTION_TYPES.SET_LAST_SYNCED_TIMESTAMP,
        payload: {
          colId: colDef.columnElasticid,
          timestamp: new Date()
        }
      })
    let updatedcolDefs =  updateColDefRecursively(newColDefs, colDef);
    updatedcolDefs = sanitizeColumnDefs(updatedcolDefs)
    // newColDefs[focusedColumnIndex] = colDef;
    try {
        await updateColumnWithId(colDef, makeColumnArrayForDB(autoColumnGroupDefs, updatedcolDefs), 'true')
    } catch (e) {
        console.error('handleStatusRecalulation: failed to persist column update', e);
    }
    setColumnDefs({ colDefs: updatedcolDefs })
    newSheetSetColumnDefs(makeColumnArrayForDB(autoColumnGroupDefs, updatedcolDefs));


    if (rowNodes.length) {
        saveRowsViaUserActivity()
        dispatch(categorizeAndStoreUpdatedRows({ update: rowNodes }))
    }
}

export const extractValueForShareableRollupList = (input) => {
    if (!input) return '';

    try {
        if (typeof input === 'object') {
            return input?.value;
        } else if (typeof input === 'string' && input.startsWith('{')) {
            const parsedValue = JSON.parse(input);
            return parsedValue?.value;
        } else {
            return input;
        }
    } catch (error) {
        console.error("Invalid JSON format in extractValueForShareableRollupList:", error);
        return input; // If JSON parsing fails, return the original value
    }
};
export const checkIfObjectIsEmpty = (obj) => {
    return Object.keys(obj).length === 0
}

export function linkPredecessorColumns(focusedColumnDef, startColumn, endColumn) {
    // Link the focused column with the start and end columns
    focusedColumnDef.linkedColumns = {
      predecessorStartDate: startColumn.field,
      predecessorEndDate: endColumn.field,
    };
  
    // Update startColumn's linkedColumns
    startColumn.linkedColumns = startColumn.linkedColumns
      ? {
          ...startColumn.linkedColumns,
          predecessor: focusedColumnDef.field,
          predecessorEndDate: endColumn.field,
        }
      : {
          predecessor: focusedColumnDef.field,
          predecessorEndDate: endColumn.field,
        };
  
    // Update endColumn's linkedColumns
    endColumn.linkedColumns = endColumn.linkedColumns
      ? {
          ...endColumn.linkedColumns,
          predecessor: focusedColumnDef.field,
          predecessorStartDate: startColumn.field,
        }
      : {
          predecessor: focusedColumnDef.field,
          predecessorStartDate: startColumn.field,
        };
  
    // Remove cellEditorParams if present
    if (focusedColumnDef.cellEditorParams) {
      delete focusedColumnDef.cellEditorParams;
    }
  
    // Clean up old duration links in startColumn and endColumn
    if (
      startColumn?.linkedColumns &&
      startColumn.linkedColumns.duration === focusedColumnDef.field
    ) {
      delete startColumn.linkedColumns.duration;
    }
  
    if (
      endColumn?.linkedColumns &&
      endColumn.linkedColumns.duration === focusedColumnDef.field
    ) {
      delete endColumn.linkedColumns.duration;
    }
  }
  export const sanitizeColumnDefs=(columns)=> {
    return columns?.map(col => {
      const sanitized = {};
  
      for (const key in col) {
        const value = col[key];
  
        if (
          key === "headerComponentParams" ||
          key === "headerGroupComponentParams"
        ) {
          continue; // skip unwanted keys
        }
  
        // Recursively sanitize children if present
        if (key === "children" && Array.isArray(value)) {
          sanitized[key] = sanitizeColumnDefs(value);
        } else {
          sanitized[key] = value;
        }
      }
  
      return sanitized;
    });
  }
export function getDefaultNewValue(newValue, colDef, isSingle, originalParsedRollupStatusData,isEditRowPopup) {
    if (newValue !== null && newValue.trim() !== '' && newValue !== undefined) return newValue;

    let value = colDef?.defaultStatus ? JSON.parse(colDef?.defaultStatus) : '';
    let defaultItem = value ? findDefaultItem(originalParsedRollupStatusData, value) : '';

    if (isSingle) {
        if (colDef.type !== "shareableRollupList") {
            return "";
        } else {
            return value &&!isEditRowPopup
                ?  { rowId: defaultItem? defaultItem?.rowId:value?.rowId, value: value?.value } :
                 "";
        }
    } else {
        return [];
    }
}
const adjustDate = (dateString, days) => {
  const date = new Date(dateString);
  date.setDate(date.getDate() + days);
  return date;
};

// Function to format date back to string YYYY-MM-DD if needed
const formatDate = (date) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${mm}/${dd}/${yyyy}`;
};

// Function to create filter objects
export const createFilterObject = (columnDefs, startDate, endDate) => {
  const filters = [];

  columnDefs.forEach((col) => {
    if (col.headerName === "Start Date") {
      const adjustedStart = adjustDate(startDate, -1); // one day less
      filters.push({
        id: Date.now(),
        column: col,
        condition: "greaterThan",
        inputValue: formatDate(adjustedStart),
        dateObject: adjustedStart,
        option: [formatDate(adjustedStart)],
        options: [formatDate(adjustedStart), "Blank"],
        propFilters: [],
        propName: "",
        propNameOptions: [],
      });
    } else if (col.headerName === "End Date") {
      const adjustedEnd = adjustDate(endDate, 1); // one day greater
      filters.push({
        id: Date.now() + 1,
        column: col,
        condition: "lessThan",
        inputValue: formatDate(adjustedEnd),
        dateObject: adjustedEnd,
        option: [formatDate(adjustedEnd)],
        options: [formatDate(adjustedEnd), "Blank"],
        propFilters: [],
        propName: "",
          propNameOptions: [],
      });
      }
  });
    const operators = [];
    if (filters.length > 1) {
        operators.push({
            isAnd: true,
            id: filters[filters.length - 1].id // last filter's id
        });
    }

    return { filters, operators };
};
export const createRiskBlockerFilters = (columnDefs) => {
  const filters = [];

  columnDefs.forEach((col) => {
    if (col.headerName === "Risk" || col.headerName === "Blocker") {
      filters.push({
        id: Date.now() + filters.length,
        column: col,
        condition: "notBlank",
        inputValue: "",
        dateObject: "",
        option: "",
        options: ["Blank"],
        propFilters: [],
        propName: "",
        propNameOptions: [],
      });
    }
  });

  const operators = [];
  if (filters.length > 1) {
    operators.push({
      isAnd: false,
      id: filters[filters.length - 1].id, // last filter's id
    });
  }

  return { filters, operators };
};


export const buildReportFilter = (columnDefs, parentName, WorkItem) => {
    let filters = columnDefs
        .filter(col => {
            if (WorkItem && parentName) {
                return col.type === "shareableRollupList" || (col.headerName || "").toLowerCase() === "work item type";
            }
            else if(WorkItem){
              return (col.headerName || "").toLowerCase() === "work item type";}
            else if(parentName){
               return col.type === "shareableRollupList" 
            }
        })
        .map(col => {
            let listItems = [];
            try {
                listItems = typeof col.listData === "string" ? JSON.parse(col.listData) : col.listData;
            } catch (err) {
                console.error("Invalid listData JSON for column:", col.headerName, err);
            }

            // For Work Item Type column (dropdownsingle), filter by WorkItem
            const isWorkItemType = col.headerName === "Work Item Type";

            const filteredOptions = isWorkItemType
                ? [WorkItem]
                : listItems.filter(item => item.parent === parentName).map(item => item.value);

            return {
                column: col,
                condition: isWorkItemType ? "equals" : "has any of",
                option: filteredOptions,
                options: isWorkItemType ? listItems : listItems.map(item => item.value),
                propFilters: [],
                id: Date.now() + Math.random() // unique id
            };
        });

    // Build operators array if more than 1 filter
    const operators = [];
    if (filters.length > 1) {
        operators.push({
            isAnd: true,
            id: filters[filters.length - 1].id // last filter's id
        });
    }

    return { filters, operators };
};

export const buildSprintMetrics = async (columnDefs,filterData,sprintRows, gridRef,setHighlightTScellOnFilter) => {
    const getReportFilterForMetric = (metric) => {
        switch (metric) {
            case "Total Planned User Stories":
                return buildReportFilter(columnDefs, "", "User Story");
            case "Completed User Stories":
                return buildReportFilter(columnDefs, "Complete", "User Story");
            case "User Stories in Progress":
                return buildReportFilter(columnDefs, "In Progress", "User Story");
            case "Not Started":
                return buildReportFilter(columnDefs, "To Do");
            case "Bugs Reported":
                return buildReportFilter(columnDefs, "", "Bug");
            case "Bugs Resolved":
                return buildReportFilter(columnDefs, "Complete", "Bug");
            default:
                return [];
        }
    };

    const metricsList = [
        "Total Planned User Stories",
        "Completed User Stories",
        "User Stories in Progress",
        "Not Started",
        "Bugs Reported",
        "Bugs Resolved"
    ];

    const metrics = await Promise.all(
        metricsList.map(async metric => {
            const reportFilter = getReportFilterForMetric(metric);
            const { filteredRowsWithoutParent, parentData } = await filterData(sprintRows, reportFilter.filters, reportFilter.operators, gridRef, setHighlightTScellOnFilter);
            return {
                metric,
                count: filteredRowsWithoutParent?.filter(r => r != null).length
            };
        })
    );

    return metrics;
};


const parseIfJsonArray = (input, validatorFn) => {
    if (!input) return [];
  
    if (typeof input === "string" && validatorFn(input)) {
      try {
        return JSON.parse(input);
      } catch (err) {
        console.warn("JSON parse failed:", input, err);
        return [];
      }
    }
  
    return Array.isArray(input) ? input : [];
  };

  
  export const processListDataHelper = ({
    params,
    isCancel,
    isStringifiedArrayWithPropName,
    setFields,
    setData,
    setReasonField
  }) => {
  
    // Extract base listData
    let listData = parseIfJsonArray(params?.colDef?.listData, isStringifiedArrayWithPropName);
    let value = parseIfJsonArray(params?.value, isStringifiedArrayWithPropName);
  
    // ---- Handle Special Case for Multi Dimensional Value ----
    if (params.colDef.type === "multi dimensional value" && params.colDef.block) {
      const hasReason = listData.some(item => item.propName === "Reason");
  
      if (!hasReason) {
        const reasonObj = {
          propName: "Reason",
          propType: "text",
          propValue: "",
          propAbbrevation: "R",
          propBgColor: "#FF7F50",
          propFgColor: "none",
        };
  
        setReasonField(true);
  
        const actualTimeIndex = listData.findIndex(item => item.propName === "Actual Time");
  
        if (actualTimeIndex !== -1) {
          listData.splice(actualTimeIndex + 1, 0, reasonObj);
        } else {
          listData.push(reasonObj);
        }
      }
    }
  
    // ---- Apply values unless cancel ----
    if (!isCancel) {
      const updatedData = listData.map(item => {
        const found = value.find(v => v.propName === item.propName);
        return found ? { ...item, propValue: found.propValue } : { ...item, propValue: "" };
      });
  
      setData(updatedData);
    }
    setFields(listData);
  };
  
  export const handleAddValueHelper = async ({
    event,
    key,
    fields,
    params,
    gridRef,
    existingData,
    originalExistingData,
    updateListData,
    updateDB,
    extendValuesToWholeRow,
    checkForDuplicates,
    validatePropAbbreviation,
    validatePropName,
    renderAlert,
    processDate,
    dayjs,
    setReasonField,
    isModify,
    data,
    reasonField,
    props,
    onClose,
    valuestoBeExtended
  }) => {

    event.preventDefault();
    // Filter out blank fields
    const filteredFields = fields.filter(f =>
      !(f.propName.trim() === "" && f.propAbbrevation.trim() === "")
    );
    
    // Validation: Missing values and format validation
    for (const field of filteredFields) {
      const abbrevValidation = validatePropAbbreviation(field.propAbbrevation);
      const nameValidation = validatePropName(field.propName);
  
      if (
        ["multi-list", "single-list"].includes(field.propType) &&
        (!field.propList || field.propList.length === 0) &&
        key === "ok"
      ) {
        return renderAlert("List Items are missing", "error", 2000);
      }
  
      if (field.propName.trim() === "" && field.propAbbrevation.trim() !== "") {
        return renderAlert("Property name is missing", "error", 2000);
      }
  
      if (field.propName.trim() !== "" && field.propAbbrevation.trim() === "") {
        return renderAlert("Abbreviation is missing", "error", 2000);
      }
  
      if (!abbrevValidation.isValid) {
        return renderAlert(abbrevValidation.message, "error", 2000);
      }
  
      if (!nameValidation.isValid) {
        return renderAlert(nameValidation.message, "error", 2000);
      }
    }
    // Duplicate Check
    const duplicates = checkForDuplicates(filteredFields);
    if (duplicates.propNames.size > 0)
      return renderAlert("Duplicate name found", "error", 2000);
  
    if (duplicates.propAbbrevation.size > 0)
      return renderAlert("Duplicate abbreviation found", "error", 2000);
  
    // Validation: Reason check based on Planned/Actual Time
    const hasInvalidReason = data.some(i => i.propName === "Reason" && !i.propValue);
    const plannedTime = data.find(d => d.propName === "Planned Time")?.propValue || 0;
    const actualTime = data.find(d => d.propName === "Actual Time")?.propValue || 0;
  
    if (Number(actualTime) > Number(plannedTime) && hasInvalidReason) {
      return renderAlert(
        "Reason is required when Actual Time exceeds Planned Time.",
        "error",
        2000
      );
    }
  
    const columns = gridRef.current?.api?.getColumnDefs();
    const updatedParams = { ...params, shouldModify: isModify };
    const prevListData = updatedParams.colDef.listData;
    updatedParams.colDef.listData = filteredFields;

    // Handle Modify Flow
    if (
      ["save", "enter", "ok"].includes(key) &&
      !props.isEditRowPopup &&
      (key === "ok" || reasonField)
    ) {
      try {
        if (existingData?.length > 0 && isModify) {
          gridRef.current?.api?.applyTransaction({ update: existingData });
  
          const confirmed = window.confirm(
            "Updating the MDV structure: Any existing values related to the previous MDV structure will be removed/updated"
          );
  
          if (confirmed) {
            await updateListData(updatedParams, columns, isModify);
          } else {
            if (originalExistingData?.length > 0 && isModify) {
              gridRef.current?.api?.applyTransaction({ update: originalExistingData });
            }
            updatedParams.colDef.listData = prevListData;
          }
  
          setReasonField(false);
        } else {
          await updateListData(updatedParams, columns, isModify);
        }
      } catch (error) {
        console.error("Error in updateListData:", error);
      }
    }

    // Update Data Formatting
    const updatedData = data.map((item, index) => {
      let value = item.propValue;
      if (item.propType === 'date') {
        const formatted = processDate(item.propValue);
            const formattedDate = dayjs(formatted).format("MM/DD/YYYY");
            value = formattedDate !== "Invalid Date" ? formattedDate : "";
        }

        if (item.propType === "multi-list") {
            const safeValue = Array.isArray(value) ? value : [];
            value = safeValue.filter(val =>
                fields?.[index]?.propList?.includes(val)
            );
        }

  
      if (Number(actualTime) <= Number(plannedTime) && item.propName === "Reason") {
        value = "";
      }
  
      return { ...item, propValue: value };
    });

    // Save / Close Behavior
    if (["save", "enter", "ok"].includes(key)) {
      if (!props.isEditRowPopup) {
        if (key !== "ok") {
          params.context.applyClick = false;
          updateDB(JSON.stringify(updatedData), () => {
            params.context.applyClick = true;
            params.stopEditing();
          });
        } else {
          params.context.applyClick = true;
          params.stopEditing();
        }
      } else {
        updateDB(JSON.stringify(updatedData));
        onClose();
      }
    } else {
      params.onValueChange(JSON.stringify(updatedData));
      updateDB(params, JSON.stringify(updatedData));
      props.isEditRowPopup ? onClose() : params.stopEditing();
    }
  
    // Extend Values If Needed
    if (valuestoBeExtended.length > 0) {
      await extendValuesToWholeRow(valuestoBeExtended, updatedData, params, gridRef);
    }
  };

   export const columnInstanceThatCannotBeDeleted = (col) => {
          const currentSheet = store.getState().sheetReducer.currentSelectedSheet;
          const accessInfoById = store.getState().userActivityReducer.accessInfoById
          const userData = store.getState().userReducer.userData;
          const { hasOriginalTemplateShareAccess } = store.getState().userActivityReducer
          const hasWriteOrAdminAccessForTemplateInstance =
              ((accessInfoById?.[0]?.Write === "Full" || accessInfoById?.[0]?.admin === true) && currentSheet?.templateOwner === accessInfoById?.[accessInfoById.length - 1]?.sender_id) || (hasOriginalTemplateShareAccess || currentSheet.hasOriginalTemplatesharedWithUser);
  
  
          const {
              isTemplateColumn,
              isWprTemplate,
              isInstanceOfTemplate,
              isInstanceSharedWithEditAccess,
              isInstanceCreatedByNonOwner,
          } = getTemplateColumnContext({
              column: col,
              currentSheet,
              userEmail: userData?.email,
              hasWriteOrAdminAccessForTemplateInstance,
          });
          if ((isWprTemplate || (isInstanceOfTemplate && accessInfoById.length > 0 && !isInstanceSharedWithEditAccess) || isInstanceCreatedByNonOwner)) return true
      }
  export const getTemplateColumnContext = ({
  column,
  currentSheet,
  userEmail,
  hasWriteOrAdminAccessForTemplateInstance,
}) => {
  const isTemplateColumn = column?.colDef?.template || column?.template;

  const isWprTemplate =
    isTemplateColumn &&
    currentSheet?.template_id &&
    currentSheet.template_id === window.WPR_TEMPLATE_ID;

  const isInstanceOfTemplate =
    isTemplateColumn && !currentSheet?.copyOfOriginal;

  const isInstanceSharedWithEditAccess =
    isInstanceOfTemplate && hasWriteOrAdminAccessForTemplateInstance;

  const isInstanceCreatedByNonOwner =
    isInstanceOfTemplate &&
    currentSheet?.templateOwner !== userEmail &&
    !hasWriteOrAdminAccessForTemplateInstance;

  return {
    isTemplateColumn,
    isWprTemplate,
    isInstanceOfTemplate,
    isInstanceSharedWithEditAccess,
    isInstanceCreatedByNonOwner,
  };
};
